(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire167f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire167f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("98dye", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e5523d8070359c$export$2e2bcd8739ae039);
/*
 * HSDataTable
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $61e5523d8070359c$var$HSDataTable extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        this.el = typeof el === "string" ? document.querySelector(el) : el;
        // Exclude columns from ordering
        const columnDefs = [];
        Array.from(this.el.querySelectorAll("thead th, thead td")).forEach((th, ind)=>{
            if (th.classList.contains("--exclude-from-ordering")) columnDefs.push({
                targets: ind,
                orderable: false
            });
        });
        const data = this.el.getAttribute("data-hs-datatable");
        const dataOptions = data ? JSON.parse(data) : {};
        this.concatOptions = {
            searching: true,
            lengthChange: false,
            order: [],
            columnDefs: [
                ...columnDefs
            ],
            ...dataOptions,
            ...options
        };
        this.table = this.el.querySelector("table");
        this.search = this.el.querySelector("[data-hs-datatable-search]") ?? null;
        this.pageEntities = this.el.querySelector("[data-hs-datatable-page-entities]") ?? null;
        this.paging = this.el.querySelector("[data-hs-datatable-paging]") ?? null;
        this.pagingPrev = this.el.querySelector("[data-hs-datatable-paging-prev]") ?? null;
        this.pagingNext = this.el.querySelector("[data-hs-datatable-paging-next]") ?? null;
        this.pagingPages = this.el.querySelector("[data-hs-datatable-paging-pages]") ?? null;
        this.info = this.el.querySelector("[data-hs-datatable-info]") ?? null;
        this.infoFrom = this.el.querySelector("[data-hs-datatable-info-from]") ?? null;
        this.infoTo = this.el.querySelector("[data-hs-datatable-info-to]") ?? null;
        this.infoLength = this.el.querySelector("[data-hs-datatable-info-length]") ?? null;
        if (this.concatOptions?.rowSelectingOptions) this.rowSelectingAll = (this.concatOptions?.rowSelectingOptions?.selectAllSelector ? document.querySelector(this.concatOptions?.rowSelectingOptions?.selectAllSelector) : document.querySelector("[data-hs-datatable-row-selecting-all]")) ?? null;
        if (this.concatOptions?.rowSelectingOptions) this.rowSelectingIndividual = this.concatOptions?.rowSelectingOptions?.individualSelector ?? "[data-hs-datatable-row-selecting-individual]" ?? null;
        if (this.pageEntities) this.concatOptions.pageLength = parseInt(this.pageEntities.value);
        this.maxPagesToShow = 3;
        this.isRowSelecting = !!this.concatOptions?.rowSelectingOptions;
        this.pageBtnClasses = this.concatOptions?.pagingOptions?.pageBtnClasses ?? null;
        this.init();
    }
    init() {
        this.createCollection(window.$hsDataTableCollection, this);
        this.initTable();
        if (this.search) this.initSearch();
        if (this.pageEntities) this.initPageEntities();
        if (this.paging) this.initPaging();
        if (this.pagingPrev) this.initPagingPrev();
        if (this.pagingNext) this.initPagingNext();
        if (this.pagingPages) this.buildPagingPages();
        if (this.info) this.initInfo();
        if (this.isRowSelecting) this.initRowSelecting();
    }
    initTable() {
        this.dataTable = new DataTable(this.table, this.concatOptions);
        if (this.isRowSelecting) this.triggerChangeEventToRow();
        this.dataTable.on("draw", ()=>{
            if (this.isRowSelecting) this.updateSelectAllCheckbox();
            if (this.isRowSelecting) this.triggerChangeEventToRow();
            this.updateInfo();
            this.updatePaging();
        });
    }
    // Search
    initSearch() {
        this.search.addEventListener("input", (0, $htam9.debounce)((evt)=>this.onSearchInput(evt.target.value)));
    }
    onSearchInput(val) {
        this.dataTable.search(val).draw();
    }
    // Page entities
    initPageEntities() {
        this.pageEntities.addEventListener("change", (evt)=>this.onEntitiesChange(parseInt(evt.target.value)));
    }
    onEntitiesChange(entities) {
        this.dataTable.page.len(entities).draw();
    }
    // Info
    initInfo() {
        if (this.infoFrom) this.initInfoFrom();
        if (this.infoTo) this.initInfoTo();
        if (this.infoLength) this.initInfoLength();
    }
    initInfoFrom() {
        const { start: start } = this.dataTable.page.info();
        this.infoFrom.innerText = `${start + 1}`;
    }
    initInfoTo() {
        const { end: end } = this.dataTable.page.info();
        this.infoTo.innerText = `${end}`;
    }
    initInfoLength() {
        const { recordsTotal: recordsTotal } = this.dataTable.page.info();
        this.infoLength.innerText = `${recordsTotal}`;
    }
    updateInfo() {
        this.initInfo();
    }
    // Paging
    initPaging() {
        this.hidePagingIfSinglePage();
    }
    hidePagingIfSinglePage() {
        const { pages: pages } = this.dataTable.page.info();
        if (pages < 2) {
            this.paging.classList.add("hidden");
            this.paging.style.display = "none";
        } else {
            this.paging.classList.remove("hidden");
            this.paging.style.display = "";
        }
    }
    initPagingPrev() {
        this.pagingPrev.addEventListener("click", ()=>{
            this.onPrevClick();
        });
    }
    onPrevClick() {
        this.dataTable.page("previous").draw("page");
    }
    disablePagingArrow(el, statement) {
        if (statement) {
            el.classList.add("disabled");
            el.setAttribute("disabled", "disabled");
        } else {
            el.classList.remove("disabled");
            el.removeAttribute("disabled");
        }
    }
    initPagingNext() {
        this.pagingNext.addEventListener("click", ()=>{
            this.onNextClick();
        });
    }
    onNextClick() {
        this.dataTable.page("next").draw("page");
    }
    buildPagingPages() {
        this.updatePaging();
    }
    updatePaging() {
        const { page: page, pages: pages, length: length } = this.dataTable.page.info();
        const totalRecords = this.dataTable.rows({
            search: "applied"
        }).count();
        const totalPages = Math.ceil(totalRecords / length);
        const currentPage = page + 1;
        let startPage = Math.max(1, currentPage - Math.floor(this.maxPagesToShow / 2));
        let endPage = Math.min(totalPages, startPage + (this.maxPagesToShow - 1));
        if (endPage - startPage + 1 < this.maxPagesToShow) startPage = Math.max(1, endPage - this.maxPagesToShow + 1);
        this.pagingPages.innerHTML = "";
        if (startPage > 1) {
            this.buildPagingPage(1);
            if (startPage > 2) this.pagingPages.appendChild((0, $htam9.htmlToElement)(`<span class="ellipsis">...</span>`));
        }
        for(let i = startPage; i <= endPage; i++)this.buildPagingPage(i);
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) this.pagingPages.appendChild((0, $htam9.htmlToElement)(`<span class="ellipsis">...</span>`));
            this.buildPagingPage(totalPages);
        }
        this.disablePagingArrow(this.pagingPrev, page === 0);
        this.disablePagingArrow(this.pagingNext, page === pages - 1);
        this.hidePagingIfSinglePage();
    }
    buildPagingPage(counter) {
        const { page: page } = this.dataTable.page.info();
        const pageEl = (0, $htam9.htmlToElement)(`<button type="button"></button>`);
        pageEl.innerText = `${counter}`;
        pageEl.setAttribute("data-page", `${counter}`);
        if (this.pageBtnClasses) (0, $htam9.classToClassList)(this.pageBtnClasses, pageEl);
        if (page === counter - 1) pageEl.classList.add("active");
        pageEl.addEventListener("click", ()=>this.onPageClick(counter));
        this.pagingPages.append(pageEl);
    }
    onPageClick(counter) {
        this.dataTable.page(counter - 1).draw("page");
    }
    // Select row
    initRowSelecting() {
        this.rowSelectingAll.addEventListener("change", ()=>this.onSelectAllChange());
    }
    triggerChangeEventToRow() {
        this.table.querySelectorAll(`tbody ${this.rowSelectingIndividual}`).forEach((el)=>{
            el.addEventListener("change", ()=>{
                this.updateSelectAllCheckbox();
            });
        });
    }
    onSelectAllChange() {
        let isChecked = this.rowSelectingAll.checked;
        const visibleRows = Array.from(this.dataTable.rows({
            page: "current",
            search: "applied"
        }).nodes());
        visibleRows.forEach((el)=>{
            const checkbox = el.querySelector(this.rowSelectingIndividual);
            if (checkbox) checkbox.checked = isChecked;
        });
        this.updateSelectAllCheckbox();
    }
    updateSelectAllCheckbox() {
        const searchRelatedItems = this.dataTable.rows({
            search: "applied"
        }).count();
        if (!searchRelatedItems) {
            this.rowSelectingAll.checked = false;
            return false;
        }
        let isChecked = true;
        const visibleRows = Array.from(this.dataTable.rows({
            page: "current",
            search: "applied"
        }).nodes());
        visibleRows.forEach((el)=>{
            const checkbox = el.querySelector(this.rowSelectingIndividual);
            if (checkbox && !checkbox.checked) {
                isChecked = false;
                return false;
            }
        });
        this.rowSelectingAll.checked = isChecked;
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsDataTableCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsDataTableCollection) window.$hsDataTableCollection = [];
        document.querySelectorAll("[data-hs-datatable]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsDataTableCollection.find((elC)=>elC?.element?.el === el)) new $61e5523d8070359c$var$HSDataTable(el);
        });
    }
}
window.addEventListener("load", ()=>{
    if (document.querySelectorAll("[data-hs-datatable]:not(.--prevent-on-load-init)").length) {
        if (typeof jQuery === "undefined") console.error("HSDataTable: jQuery is not available, please add it to the page.");
        if (typeof DataTable === "undefined") console.error("HSDataTable: DataTable is not available, please add it to the page.");
    }
    if (typeof DataTable !== "undefined" && typeof jQuery !== "undefined") $61e5523d8070359c$var$HSDataTable.autoInit();
// Uncomment for debug
// console.log('Datatable collection:', window.$hsDataTableCollection);
});
if (typeof window !== "undefined") window.HSDataTable = $61e5523d8070359c$var$HSDataTable;
var $61e5523d8070359c$export$2e2bcd8739ae039 = $61e5523d8070359c$var$HSDataTable;

});
parcelRegister("htam9", function(module, exports) {

$parcel$export(module.exports, "stringToBoolean", () => $478cf65b5d671095$export$70f24959ef00553b);
$parcel$export(module.exports, "getClassProperty", () => $478cf65b5d671095$export$11a826c585352eb8);
$parcel$export(module.exports, "getClassPropertyAlt", () => $478cf65b5d671095$export$315f1f5a8da35a59);
$parcel$export(module.exports, "isIOS", () => $478cf65b5d671095$export$fedb369cb70207f1);
$parcel$export(module.exports, "isIpadOS", () => $478cf65b5d671095$export$363474031fa64020);
$parcel$export(module.exports, "isDirectChild", () => $478cf65b5d671095$export$d27a746b95b8b6f0);
$parcel$export(module.exports, "isEnoughSpace", () => $478cf65b5d671095$export$e3db11022a3681e4);
$parcel$export(module.exports, "isFormElement", () => $478cf65b5d671095$export$5da71380ac3cd382);
$parcel$export(module.exports, "isParentOrElementHidden", () => $478cf65b5d671095$export$82366544b9d4ab15);
$parcel$export(module.exports, "debounce", () => $478cf65b5d671095$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "dispatch", () => $478cf65b5d671095$export$635e15bbd66f01ea);
$parcel$export(module.exports, "afterTransition", () => $478cf65b5d671095$export$24d4b3961cffb4db);
$parcel$export(module.exports, "htmlToElement", () => $478cf65b5d671095$export$c5c738da9ba7f9f);
$parcel$export(module.exports, "classToClassList", () => $478cf65b5d671095$export$a73398b198c9e798);
$parcel$export(module.exports, "menuSearchHistory", () => $478cf65b5d671095$export$23c7272ae11663ba);
/*
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ const $478cf65b5d671095$export$70f24959ef00553b = (string)=>{
    return string === "true" ? true : false;
};
const $478cf65b5d671095$export$11a826c585352eb8 = (el, prop, val = "")=>{
    return (window.getComputedStyle(el).getPropertyValue(prop) || val).replace(" ", "");
};
const $478cf65b5d671095$export$315f1f5a8da35a59 = (el, prop, val = "")=>{
    let targetClass = "";
    el.classList.forEach((c)=>{
        if (c.includes(prop)) targetClass = c;
    });
    return targetClass.match(/:(.*)]/) ? targetClass.match(/:(.*)]/)[1] : val;
};
const $478cf65b5d671095$export$9b544f58430fc883 = (el)=>{
    const computedStyle = window.getComputedStyle(el);
    const zIndex = computedStyle.getPropertyValue("z-index");
    return zIndex;
};
function $478cf65b5d671095$export$d0dcfbb7d83a7f11(arr) {
    let highestZIndex = Number.NEGATIVE_INFINITY;
    arr.forEach((el)=>{
        let zIndex = $478cf65b5d671095$export$9b544f58430fc883(el);
        if (zIndex !== "auto") {
            zIndex = parseInt(zIndex, 10);
            if (zIndex > highestZIndex) highestZIndex = zIndex;
        }
    });
    return highestZIndex;
}
const $478cf65b5d671095$export$fedb369cb70207f1 = ()=>{
    if (/iPad|iPhone|iPod/.test(navigator.platform)) return true;
    else return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};
const $478cf65b5d671095$export$363474031fa64020 = ()=>{
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};
const $478cf65b5d671095$export$d27a746b95b8b6f0 = (parent, child)=>{
    const children = parent.children;
    for(let i = 0; i < children.length; i++){
        if (children[i] === child) return true;
    }
    return false;
};
const $478cf65b5d671095$export$e3db11022a3681e4 = (el, toggle, preferredPosition = "auto", space = 10, wrapper = null)=>{
    const referenceRect = toggle.getBoundingClientRect();
    const wrapperRect = wrapper ? wrapper.getBoundingClientRect() : null;
    const viewportHeight = window.innerHeight;
    const spaceAbove = wrapperRect ? referenceRect.top - wrapperRect.top : referenceRect.top;
    const spaceBelow = (wrapper ? wrapperRect.bottom : viewportHeight) - referenceRect.bottom;
    const minimumSpaceRequired = el.clientHeight + space;
    if (preferredPosition === "bottom") return spaceBelow >= minimumSpaceRequired;
    else if (preferredPosition === "top") return spaceAbove >= minimumSpaceRequired;
    else return spaceAbove >= minimumSpaceRequired || spaceBelow >= minimumSpaceRequired;
};
const $478cf65b5d671095$export$5da71380ac3cd382 = (target)=>{
    return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement;
};
const $478cf65b5d671095$export$82366544b9d4ab15 = (element)=>{
    if (!element) return false;
    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.display === "none") return true;
    return $478cf65b5d671095$export$82366544b9d4ab15(element.parentElement);
};
const $478cf65b5d671095$export$61fc7d43ac8f84b0 = (func, timeout = 200)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(undefined, args);
        }, timeout);
    };
};
const $478cf65b5d671095$export$635e15bbd66f01ea = (evt, element, payload = null)=>{
    const event = new CustomEvent(evt, {
        detail: {
            payload: payload
        },
        bubbles: true,
        cancelable: true,
        composed: false
    });
    element.dispatchEvent(event);
};
const $478cf65b5d671095$export$24d4b3961cffb4db = (el, callback)=>{
    const handleEvent = ()=>{
        callback();
        el.removeEventListener("transitionend", handleEvent, true);
    };
    const computedStyle = window.getComputedStyle(el);
    const transitionDuration = computedStyle.getPropertyValue("transition-duration");
    const transitionProperty = computedStyle.getPropertyValue("transition-property");
    const hasTransition = transitionProperty !== "none" && parseFloat(transitionDuration) > 0;
    if (hasTransition) el.addEventListener("transitionend", handleEvent, true);
    else callback();
};
const $478cf65b5d671095$export$c5c738da9ba7f9f = (html)=>{
    const template = document.createElement("template");
    html = html.trim();
    template.innerHTML = html;
    return template.content.firstChild;
};
const $478cf65b5d671095$export$a73398b198c9e798 = (classes, target, splitter = " ", action = "add")=>{
    const classesToArray = classes.split(splitter);
    classesToArray.forEach((cl)=>action === "add" ? target.classList.add(cl) : target.classList.remove(cl));
};
const $478cf65b5d671095$export$23c7272ae11663ba = {
    historyIndex: -1,
    addHistory (index) {
        this.historyIndex = index;
    },
    existsInHistory (index) {
        return index > this.historyIndex;
    },
    clearHistory () {
        this.historyIndex = -1;
    }
};

});

parcelRegister("kYnwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0288c6577afded82$export$2e2bcd8739ae039);
/// <reference path="../../../global.d.ts" />
/*
 * HSBasePlugin
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ class $0288c6577afded82$export$2e2bcd8739ae039 {
    constructor(el, options, events){
        this.el = el;
        this.options = options;
        this.events = events;
        this.el = el;
        this.options = options;
        this.events = {};
    }
    createCollection(collection, element) {
        collection.push({
            id: element?.el?.id || collection.length + 1,
            element: element
        });
    }
    fireEvent(evt, payload = null) {
        if (this.events.hasOwnProperty(evt)) return this.events[evt](payload);
    }
    on(evt, cb) {
        this.events[evt] = cb;
    }
}

});


parcelRegister("h1iCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df072ef2c4c8876$export$2e2bcd8739ae039);
/*
 * HSFileUpload
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
if (typeof Dropzone !== "undefined") Dropzone.autoDiscover = false;
class $4df072ef2c4c8876$var$HSFileUpload extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        this.extensions = {};
        this.el = typeof el === "string" ? document.querySelector(el) : el;
        const data = this.el.getAttribute("data-hs-file-upload");
        const dataOptions = data ? JSON.parse(data) : {};
        this.previewTemplate = this.el.querySelector("[data-hs-file-upload-preview]")?.innerHTML || `<div class="p-3 bg-white border border-solid border-gray-300 rounded-xl dark:bg-neutral-800 dark:border-neutral-600">
			<div class="mb-2 flex justify-between items-center">
				<div class="flex items-center gap-x-3">
					<span class="size-8 flex justify-center items-center border border-gray-200 text-gray-500 rounded-lg dark:border-neutral-700 dark:text-neutral-500" data-hs-file-upload-file-icon></span>
					<div>
						<p class="text-sm font-medium text-gray-800 dark:text-white">
							<span class="truncate inline-block max-w-[300px] align-bottom" data-hs-file-upload-file-name></span>.<span data-hs-file-upload-file-ext></span>
						</p>
						<p class="text-xs text-gray-500 dark:text-neutral-500" data-hs-file-upload-file-size></p>
					</div>
				</div>
				<div class="inline-flex items-center gap-x-2">
					<button type="button" class="text-gray-500 hover:text-gray-800 dark:text-neutral-500 dark:hover:text-neutral-200" data-hs-file-upload-remove>
						<svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>
					</button>
				</div>
			</div>
			<div class="flex items-center gap-x-3 whitespace-nowrap">
				<div class="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-neutral-700" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" data-hs-file-upload-progress-bar>
					<div class="flex flex-col justify-center rounded-full overflow-hidden bg-blue-600 text-xs text-white text-center whitespace-nowrap transition-all duration-500 hs-file-upload-complete:bg-green-600 dark:bg-blue-500" style="width: 0" data-hs-file-upload-progress-bar-pane></div>
				</div>
				<div class="w-10 text-end">
					<span class="text-sm text-gray-800 dark:text-white">
						<span data-hs-file-upload-progress-bar-value>0</span>%
					</span>
				</div>
			</div>
		</div>`;
        this.extensions = _.merge({
            default: {
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>',
                class: "size-5"
            },
            xls: {
                icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0243 1.43996H7.08805C6.82501 1.43996 6.57277 1.54445 6.38677 1.73043C6.20077 1.91642 6.09631 2.16868 6.09631 2.43171V6.64796L15.0243 11.856L19.4883 13.7398L23.9523 11.856V6.64796L15.0243 1.43996Z" fill="#21A366"></path><path d="M6.09631 6.64796H15.0243V11.856H6.09631V6.64796Z" fill="#107C41"></path><path d="M22.9605 1.43996H15.0243V6.64796H23.9523V2.43171C23.9523 2.16868 23.8478 1.91642 23.6618 1.73043C23.4758 1.54445 23.2235 1.43996 22.9605 1.43996Z" fill="#33C481"></path><path d="M15.0243 11.856H6.09631V21.2802C6.09631 21.5433 6.20077 21.7955 6.38677 21.9815C6.57277 22.1675 6.82501 22.272 7.08805 22.272H22.9606C23.2236 22.272 23.4759 22.1675 23.6618 21.9815C23.8478 21.7955 23.9523 21.5433 23.9523 21.2802V17.064L15.0243 11.856Z" fill="#185C37"></path><path d="M15.0243 11.856H23.9523V17.064H15.0243V11.856Z" fill="#107C41"></path><path opacity="0.1" d="M12.5446 5.15996H6.09631V19.296H12.5446C12.8073 19.2952 13.0591 19.1904 13.245 19.0046C13.4308 18.8188 13.5355 18.567 13.5363 18.3042V6.1517C13.5355 5.88892 13.4308 5.63712 13.245 5.4513C13.0591 5.26548 12.8073 5.16074 12.5446 5.15996Z" fill="black"></path><path opacity="0.2" d="M11.8006 5.90396H6.09631V20.04H11.8006C12.0633 20.0392 12.3151 19.9344 12.501 19.7486C12.6868 19.5628 12.7915 19.311 12.7923 19.0482V6.8957C12.7915 6.6329 12.6868 6.38114 12.501 6.19532C12.3151 6.0095 12.0633 5.90475 11.8006 5.90396Z" fill="black"></path><path opacity="0.2" d="M11.8006 5.90396H6.09631V18.552H11.8006C12.0633 18.5512 12.3151 18.4464 12.501 18.2606C12.6868 18.0748 12.7915 17.823 12.7923 17.5602V6.8957C12.7915 6.6329 12.6868 6.38114 12.501 6.19532C12.3151 6.0095 12.0633 5.90475 11.8006 5.90396Z" fill="black"></path><path opacity="0.2" d="M11.0566 5.90396H6.09631V18.552H11.0566C11.3193 18.5512 11.5711 18.4464 11.757 18.2606C11.9428 18.0748 12.0475 17.823 12.0483 17.5602V6.8957C12.0475 6.6329 11.9428 6.38114 11.757 6.19532C11.5711 6.0095 11.3193 5.90475 11.0566 5.90396Z" fill="black"></path><path d="M1.13604 5.90396H11.0566C11.3195 5.90396 11.5718 6.00842 11.7578 6.19442C11.9438 6.38042 12.0483 6.63266 12.0483 6.8957V16.8162C12.0483 17.0793 11.9438 17.3315 11.7578 17.5175C11.5718 17.7035 11.3195 17.808 11.0566 17.808H1.13604C0.873012 17.808 0.620754 17.7035 0.434765 17.5175C0.248775 17.3315 0.144287 17.0793 0.144287 16.8162V6.8957C0.144287 6.63266 0.248775 6.38042 0.434765 6.19442C0.620754 6.00842 0.873012 5.90396 1.13604 5.90396Z" fill="#107C41"></path><path d="M2.77283 15.576L5.18041 11.8455L2.9752 8.13596H4.74964L5.95343 10.5071C6.06401 10.7318 6.14015 10.8994 6.18185 11.01H6.19745C6.27683 10.8305 6.35987 10.6559 6.44669 10.4863L7.73309 8.13596H9.36167L7.09991 11.8247L9.41897 15.576H7.68545L6.29489 12.972C6.22943 12.861 6.17387 12.7445 6.12899 12.6238H6.10817C6.06761 12.7419 6.01367 12.855 5.94748 12.9608L4.51676 15.576H2.77283Z" fill="white"></path></svg>',
                class: "size-5"
            },
            doc: {
                icon: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.6141 1.91994H9.45071C9.09999 1.91994 8.76367 2.05926 8.51567 2.30725C8.26767 2.55523 8.12839 2.89158 8.12839 3.24228V8.86395L20.0324 12.3359L31.9364 8.86395V3.24228C31.9364 2.89158 31.797 2.55523 31.549 2.30725C31.3011 2.05926 30.9647 1.91994 30.6141 1.91994Z" fill="#41A5EE"></path><path d="M31.9364 8.86395H8.12839V15.8079L20.0324 19.2799L31.9364 15.8079V8.86395Z" fill="#2B7CD3"></path><path d="M31.9364 15.8079H8.12839V22.7519L20.0324 26.2239L31.9364 22.7519V15.8079Z" fill="#185ABD"></path><path d="M31.9364 22.752H8.12839V28.3736C8.12839 28.7244 8.26767 29.0607 8.51567 29.3087C8.76367 29.5567 9.09999 29.696 9.45071 29.696H30.6141C30.9647 29.696 31.3011 29.5567 31.549 29.3087C31.797 29.0607 31.9364 28.7244 31.9364 28.3736V22.752Z" fill="#103F91"></path><path opacity="0.1" d="M16.7261 6.87994H8.12839V25.7279H16.7261C17.0764 25.7269 17.4121 25.5872 17.6599 25.3395C17.9077 25.0917 18.0473 24.756 18.0484 24.4056V8.20226C18.0473 7.8519 17.9077 7.51616 17.6599 7.2684C17.4121 7.02064 17.0764 6.88099 16.7261 6.87994Z" class="fill-black dark:fill-neutral-200" fill="currentColor"></path><path opacity="0.2" d="M15.7341 7.87194H8.12839V26.7199H15.7341C16.0844 26.7189 16.4201 26.5792 16.6679 26.3315C16.9157 26.0837 17.0553 25.748 17.0564 25.3976V9.19426C17.0553 8.84386 16.9157 8.50818 16.6679 8.26042C16.4201 8.01266 16.0844 7.87299 15.7341 7.87194Z" class="fill-black dark:fill-neutral-200" fill="currentColor"></path><path opacity="0.2" d="M15.7341 7.87194H8.12839V24.7359H15.7341C16.0844 24.7349 16.4201 24.5952 16.6679 24.3475C16.9157 24.0997 17.0553 23.764 17.0564 23.4136V9.19426C17.0553 8.84386 16.9157 8.50818 16.6679 8.26042C16.4201 8.01266 16.0844 7.87299 15.7341 7.87194Z" class="fill-black dark:fill-neutral-200" fill="currentColor"></path><path opacity="0.2" d="M14.7421 7.87194H8.12839V24.7359H14.7421C15.0924 24.7349 15.4281 24.5952 15.6759 24.3475C15.9237 24.0997 16.0633 23.764 16.0644 23.4136V9.19426C16.0633 8.84386 15.9237 8.50818 15.6759 8.26042C15.4281 8.01266 15.0924 7.87299 14.7421 7.87194Z" class="fill-black dark:fill-neutral-200" fill="currentColor"></path><path d="M1.51472 7.87194H14.7421C15.0927 7.87194 15.4291 8.01122 15.6771 8.25922C15.925 8.50722 16.0644 8.84354 16.0644 9.19426V22.4216C16.0644 22.7723 15.925 23.1087 15.6771 23.3567C15.4291 23.6047 15.0927 23.7439 14.7421 23.7439H1.51472C1.16401 23.7439 0.827669 23.6047 0.579687 23.3567C0.3317 23.1087 0.192383 22.7723 0.192383 22.4216V9.19426C0.192383 8.84354 0.3317 8.50722 0.579687 8.25922C0.827669 8.01122 1.16401 7.87194 1.51472 7.87194Z" fill="#185ABD"></path><path d="M12.0468 20.7679H10.2612L8.17801 13.9231L5.99558 20.7679H4.20998L2.22598 10.8479H4.01158L5.40038 17.7919L7.48358 11.0463H8.97161L10.9556 17.7919L12.3444 10.8479H14.0308L12.0468 20.7679Z" fill="white"></path></svg>',
                class: "size-5"
            },
            zip: {
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v18"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><circle cx="10" cy="20" r="2"/><path d="M10 7V6"/><path d="M10 12v-1"/><path d="M10 18v-2"/></svg>',
                class: "size-5"
            }
        }, dataOptions.extensions);
        this.singleton = dataOptions.singleton;
        this.concatOptions = {
            clickable: this.el.querySelector("[data-hs-file-upload-trigger]"),
            previewsContainer: this.el.querySelector("[data-hs-file-upload-previews]"),
            addRemoveLinks: false,
            previewTemplate: this.previewTemplate,
            autoHideTrigger: false,
            ...dataOptions,
            ...options
        };
        this.init();
    }
    init() {
        this.createCollection(window.$hsFileUploadCollection, this);
        this.initDropzone();
    }
    initDropzone() {
        const clear = this.el.querySelector("[data-hs-file-upload-clear]");
        const pseudoTriggers = Array.from(this.el.querySelectorAll("[data-hs-file-upload-pseudo-trigger]"));
        this.dropzone = new Dropzone(this.el, this.concatOptions);
        this.dropzone.on("addedfile", (file)=>this.onAddFile(file));
        this.dropzone.on("removedfile", ()=>this.onRemoveFile());
        this.dropzone.on("uploadprogress", (file, progress)=>this.onUploadProgress(file, progress));
        this.dropzone.on("complete", (file)=>this.onComplete(file));
        if (clear) clear.onclick = ()=>{
            if (this.dropzone.files.length) this.dropzone.removeAllFiles(true);
        };
        if (pseudoTriggers.length) pseudoTriggers.forEach((el)=>{
            el.onclick = ()=>{
                if (this.concatOptions?.clickable) (this.concatOptions?.clickable).click();
            };
        });
    }
    onAddFile(file) {
        const { previewElement: previewElement } = file;
        const reloadButton = file.previewElement.querySelector("[data-hs-file-upload-reload]");
        if (!previewElement) return false;
        if (this.singleton && this.dropzone.files.length > 1) this.dropzone.removeFile(this.dropzone.files[0]);
        if (reloadButton) reloadButton.addEventListener("click", (evt)=>{
            evt.preventDefault();
            evt.stopPropagation();
            const tempFileInput = document.createElement("input");
            tempFileInput.type = "file";
            tempFileInput.click();
            tempFileInput.addEventListener("change", (event)=>{
                const input = event.target;
                const newFile = input.files?.[0];
                if (newFile) {
                    const dzNewFile = newFile;
                    dzNewFile.status = Dropzone.ADDED;
                    dzNewFile.accepted = true;
                    dzNewFile.previewElement = file.previewElement;
                    dzNewFile.previewTemplate = file.previewTemplate;
                    dzNewFile.previewsContainer = file.previewsContainer;
                    this.dropzone.removeFile(file);
                    this.dropzone.addFile(dzNewFile);
                }
            });
        });
        this.previewAccepted(file);
    }
    previewAccepted(file) {
        const { previewElement: previewElement } = file;
        const fileInfo = this.splitFileName(file.name);
        const fileName = previewElement.querySelector("[data-hs-file-upload-file-name]");
        const fileExt = previewElement.querySelector("[data-hs-file-upload-file-ext]");
        const fileSize = previewElement.querySelector("[data-hs-file-upload-file-size]");
        const fileIcon = previewElement.querySelector("[data-hs-file-upload-file-icon]");
        const trigger = this.el.querySelector("[data-hs-file-upload-trigger]");
        const preview = previewElement.querySelector("[data-dz-thumbnail]");
        const remove = previewElement.querySelector("[data-hs-file-upload-remove]");
        if (fileName) fileName.textContent = fileInfo.name;
        if (fileExt) fileExt.textContent = fileInfo.extension;
        if (fileSize) fileSize.textContent = this.formatFileSize(file.size);
        if (preview) {
            if (file.type.includes("image/")) preview.classList.remove("hidden");
            else this.setIcon(fileInfo.extension, fileIcon);
        }
        if (this.dropzone.files.length > 0 && this.concatOptions.autoHideTrigger) trigger.style.display = "none";
        if (remove) remove.onclick = ()=>this.dropzone.removeFile(file);
    }
    onRemoveFile() {
        const trigger = this.el.querySelector("[data-hs-file-upload-trigger]");
        if (this.dropzone.files.length === 0 && this.concatOptions.autoHideTrigger) trigger.style.display = "";
    }
    onUploadProgress(file, progress) {
        const { previewElement: previewElement } = file;
        if (!previewElement) return false;
        const progressBar = previewElement.querySelector("[data-hs-file-upload-progress-bar]");
        const progressBarPane = previewElement.querySelector("[data-hs-file-upload-progress-bar-pane]");
        const progressBarValue = previewElement.querySelector("[data-hs-file-upload-progress-bar-value]");
        const currentProgress = Math.floor(progress);
        if (progressBar) progressBar.setAttribute("aria-valuenow", `${currentProgress}`);
        if (progressBarPane) progressBarPane.style.width = `${currentProgress}%`;
        if (progressBarValue) progressBarValue.innerText = `${currentProgress}`;
    }
    onComplete(file) {
        const { previewElement: previewElement } = file;
        if (!previewElement) return false;
        previewElement.classList.add("complete");
    }
    setIcon(ext, file) {
        const icon = this.createIcon(ext);
        file.append(icon);
    }
    createIcon(ext) {
        const icon = this.extensions[ext]?.icon ? (0, $htam9.htmlToElement)(this.extensions[ext].icon) : (0, $htam9.htmlToElement)(this.extensions.default.icon);
        (0, $htam9.classToClassList)(this.extensions[ext]?.class ? this.extensions[ext].class : this.extensions.default.class, icon);
        return icon;
    }
    formatFileSize(size) {
        if (size < 1024) return size.toFixed(2) + " B";
        else if (size < 1048576) return (size / 1024).toFixed(2) + " KB";
        else if (size < 1073741824) return (size / 1048576).toFixed(2) + " MB";
        else if (size < 1099511627776) return (size / 1073741824).toFixed(2) + " GB";
        else return (size / 1099511627776).toFixed(2) + " TB";
    }
    splitFileName(file) {
        let dotIndex = file.lastIndexOf(".");
        if (dotIndex == -1) return {
            name: file,
            extension: ""
        };
        return {
            name: file.substring(0, dotIndex),
            extension: file.substring(dotIndex + 1)
        };
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsFileUploadCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsFileUploadCollection) window.$hsFileUploadCollection = [];
        document.querySelectorAll("[data-hs-file-upload]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsFileUploadCollection.find((elC)=>elC?.element?.el === el)) new $4df072ef2c4c8876$var$HSFileUpload(el);
        });
    }
}
window.addEventListener("load", ()=>{
    if (document.querySelectorAll("[data-hs-file-upload]:not(.--prevent-on-load-init)").length) {
        if (typeof _ === "undefined") console.error("HSFileUpload: Lodash is not available, please add it to the page.");
        if (typeof Dropzone === "undefined") console.error("HSFileUpload: Dropzone is not available, please add it to the page.");
    }
    if (typeof _ !== "undefined" && typeof Dropzone !== "undefined") $4df072ef2c4c8876$var$HSFileUpload.autoInit();
// Uncomment for debug
// console.log('File upload collection:', window.$hsFileUploadCollection);
});
if (typeof window !== "undefined") window.HSFileUpload = $4df072ef2c4c8876$var$HSFileUpload;
var $4df072ef2c4c8876$export$2e2bcd8739ae039 = $4df072ef2c4c8876$var$HSFileUpload;

});

parcelRegister("jdtiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f373ffb9c02506$export$2e2bcd8739ae039);
/*
 * HSRangeSlider
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $kYnwU = parcelRequire("kYnwU");
class $26f373ffb9c02506$var$HSRangeSlider extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        const data = el.getAttribute("data-hs-range-slider");
        const dataOptions = data ? JSON.parse(data) : {};
        this.concatOptions = {
            ...dataOptions,
            ...options,
            cssClasses: {
                ...noUiSlider.cssClasses,
                ...this.processClasses(dataOptions.cssClasses)
            }
        };
        this.init();
    }
    get formattedValue() {
        const values = this.el.noUiSlider.get();
        if (Array.isArray(values) && this.format) {
            const updateValues = [];
            values.forEach((val)=>{
                updateValues.push(this.format.to(val));
            });
            return updateValues;
        } else if (this.format) return this.format.to(values);
        else return values;
    }
    processClasses(cl) {
        const mergedClasses = {};
        Object.keys(cl).forEach((key)=>{
            if (key) mergedClasses[key] = `${noUiSlider.cssClasses[key]} ${cl[key]}`;
        });
        return mergedClasses;
    }
    init() {
        this.createCollection(window.$hsRangeSliderCollection, this);
        if (typeof this.concatOptions?.formatter === "object" ? this.concatOptions?.formatter?.type === "thousandsSeparatorAndDecimalPoints" : this.concatOptions?.formatter === "thousandsSeparatorAndDecimalPoints") this.thousandsSeparatorAndDecimalPointsFormatter();
        else if (typeof this.concatOptions?.formatter === "object" ? this.concatOptions?.formatter?.type === "integer" : this.concatOptions?.formatter === "integer") this.integerFormatter();
        else if (typeof this.concatOptions?.formatter === "object" && (this.concatOptions?.formatter?.prefix || this.concatOptions?.formatter?.postfix)) this.prefixOrPostfixFormatter();
        noUiSlider.create(this.el, this.concatOptions);
        if (this.concatOptions.disabled) this.setDisabled();
    }
    formatValue(val) {
        let result = "";
        if (typeof this.concatOptions?.formatter === "object") {
            if (this.concatOptions?.formatter?.prefix) result += this.concatOptions?.formatter?.prefix;
            result += val;
            if (this.concatOptions?.formatter?.postfix) result += this.concatOptions?.formatter?.postfix;
        } else result += val;
        return result;
    }
    integerFormatter() {
        this.format = {
            to: (val)=>this.formatValue(Math.round(val)),
            from: (val)=>Math.round(+val)
        };
        if (this.concatOptions?.tooltips) this.concatOptions.tooltips = this.format;
    }
    prefixOrPostfixFormatter() {
        this.format = {
            to: (val)=>this.formatValue(val),
            from: (val)=>+val
        };
        if (this.concatOptions?.tooltips) this.concatOptions.tooltips = this.format;
    }
    thousandsSeparatorAndDecimalPointsFormatter() {
        this.format = {
            to: (val)=>this.formatValue(new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(val)),
            from: (val)=>parseFloat(val.replace(/,/g, ""))
        };
        if (this.concatOptions?.tooltips) this.concatOptions.tooltips = this.format;
    }
    setDisabled() {
        this.el.setAttribute("disabled", "disabled");
        this.el.classList.add("disabled");
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsRangeSliderCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsRangeSliderCollection) window.$hsRangeSliderCollection = [];
        document.querySelectorAll("[data-hs-range-slider]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsRangeSliderCollection.find((elC)=>elC?.element?.el === el)) new $26f373ffb9c02506$var$HSRangeSlider(el);
        });
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsRangeSliderCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $26f373ffb9c02506$var$HSRangeSlider.autoInit();
// Uncomment for debug
// console.log('Range slider collection:', window.$hsRangeSliderCollection);
});
if (typeof window !== "undefined") window.HSRangeSlider = $26f373ffb9c02506$var$HSRangeSlider;
var $26f373ffb9c02506$export$2e2bcd8739ae039 = $26f373ffb9c02506$var$HSRangeSlider;

});


/*
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ /*
 * HSCopyMarkup
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $0c306a747591bace$var$HSCopyMarkup extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-copy-markup");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.targetSelector = concatOptions?.targetSelector || null;
        this.wrapperSelector = concatOptions?.wrapperSelector || null;
        this.limit = concatOptions?.limit || null;
        this.items = [];
        if (this.targetSelector) this.init();
    }
    init() {
        this.createCollection(window.$hsCopyMarkupCollection, this);
        this.setTarget();
        this.setWrapper();
        this.addPredefinedItems();
        this.el.addEventListener("click", ()=>this.copy());
    }
    copy() {
        if (this.limit && this.items.length >= this.limit) return false;
        if (this.el.hasAttribute("disabled")) this.el.setAttribute("disabled", "");
        const copiedElement = this.target.cloneNode(true);
        this.addToItems(copiedElement);
        if (this.limit && this.items.length >= this.limit) this.el.setAttribute("disabled", "disabled");
        this.fireEvent("copy", copiedElement);
        (0, $htam9.dispatch)("copy.hs.copyMarkup", copiedElement, copiedElement);
    }
    addPredefinedItems() {
        Array.from(this.wrapper.children).filter((el)=>!el.classList.contains("[--ignore-for-count]")).forEach((el)=>{
            this.addToItems(el);
        });
    }
    setTarget() {
        const target = typeof this.targetSelector === "string" ? document.querySelector(this.targetSelector).cloneNode(true) : this.targetSelector.cloneNode(true);
        target.removeAttribute("id");
        this.target = target;
    }
    setWrapper() {
        this.wrapper = typeof this.wrapperSelector === "string" ? document.querySelector(this.wrapperSelector) : this.wrapperSelector;
    }
    addToItems(item) {
        const deleteItemButton = item.querySelector("[data-hs-copy-markup-delete-item]");
        if (this.wrapper) this.wrapper.append(item);
        else this.el.before(item);
        if (deleteItemButton) deleteItemButton.addEventListener("click", ()=>this.delete(item));
        this.items.push(item);
    }
    // Public methods
    delete(target) {
        const index = this.items.indexOf(target);
        if (index !== -1) this.items.splice(index, 1);
        target.remove();
        this.fireEvent("delete", target);
        (0, $htam9.dispatch)("delete.hs.copyMarkup", target, target);
    }
    // Static method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsCopyMarkupCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsCopyMarkupCollection) window.$hsCopyMarkupCollection = [];
        document.querySelectorAll("[data-hs-copy-markup]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsCopyMarkupCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-copy-markup");
                const options = data ? JSON.parse(data) : {};
                new $0c306a747591bace$var$HSCopyMarkup(el, options);
            }
        });
    }
}
window.addEventListener("load", ()=>{
    $0c306a747591bace$var$HSCopyMarkup.autoInit();
// Uncomment for debug
// console.log('Copy markup collection:', window.$hsCopyMarkupCollection);
});
if (typeof window !== "undefined") window.HSCopyMarkup = $0c306a747591bace$var$HSCopyMarkup;
var $0c306a747591bace$export$2e2bcd8739ae039 = $0c306a747591bace$var$HSCopyMarkup;


/*
 * HSAccordion
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $fdf3273b082fdf99$var$HSAccordion extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        this.toggle = this.el.querySelector(".hs-accordion-toggle") || null;
        this.content = this.el.querySelector(".hs-accordion-content") || null;
        this.update();
        if (this.toggle && this.content) this.init();
    }
    init() {
        this.createCollection(window.$hsAccordionCollection, this);
        this.toggle.addEventListener("click", (evt)=>{
            evt.stopPropagation();
            if (this.el.classList.contains("active")) this.hide();
            else this.show();
        });
    }
    // Public methods
    show() {
        if (this.group && !this.isAlwaysOpened && this.group.querySelector(":scope > .hs-accordion.active") && this.group.querySelector(":scope > .hs-accordion.active") !== this.el) {
            const currentlyOpened = window.$hsAccordionCollection.find((el)=>el.element.el === this.group.querySelector(":scope > .hs-accordion.active"));
            currentlyOpened.element.hide();
        }
        if (this.el.classList.contains("active")) return false;
        this.el.classList.add("active");
        if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "true";
        this.content.style.display = "block";
        this.content.style.height = "0";
        setTimeout(()=>{
            this.content.style.height = `${this.content.scrollHeight}px`;
        });
        (0, $htam9.afterTransition)(this.content, ()=>{
            this.content.style.display = "block";
            this.content.style.height = "";
            this.fireEvent("open", this.el);
            (0, $htam9.dispatch)("open.hs.accordion", this.el, this.el);
        });
    }
    hide() {
        if (!this.el.classList.contains("active")) return false;
        this.el.classList.remove("active");
        if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "false";
        this.content.style.height = `${this.content.scrollHeight}px`;
        setTimeout(()=>{
            this.content.style.height = "0";
        });
        (0, $htam9.afterTransition)(this.content, ()=>{
            this.content.style.display = "";
            this.content.style.height = "0";
            this.fireEvent("close", this.el);
            (0, $htam9.dispatch)("close.hs.accordion", this.el, this.el);
        });
    }
    update() {
        this.group = this.el.closest(".hs-accordion-group") || null;
        if (!this.group) return false;
        this.isAlwaysOpened = this.group.hasAttribute("data-hs-accordion-always-open") || false;
        window.$hsAccordionCollection.map((el)=>{
            if (el.id === this.el.id) {
                el.element.group = this.group;
                el.element.isAlwaysOpened = this.isAlwaysOpened;
            }
            return el;
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static show(target) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.content.style.display !== "block") elInCollection.element.show();
    }
    static hide(target) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.content.style.display === "block") elInCollection.element.hide();
    }
    static autoInit() {
        if (!window.$hsAccordionCollection) window.$hsAccordionCollection = [];
        document.querySelectorAll(".hs-accordion:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsAccordionCollection.find((elC)=>elC?.element?.el === el)) new $fdf3273b082fdf99$var$HSAccordion(el);
        });
    }
    static treeView() {
        if (!document.querySelectorAll(".hs-accordion-treeview-root").length) return false;
        this.selectable = [];
        document.querySelectorAll(".hs-accordion-treeview-root").forEach((el)=>{
            const data = el?.getAttribute("data-hs-accordion-options");
            const options = data ? JSON.parse(data) : {};
            this.selectable.push({
                el: el,
                options: {
                    ...options
                }
            });
        });
        if (this.selectable.length) this.selectable.forEach((item)=>{
            const { el: el } = item;
            el.querySelectorAll(".hs-accordion-selectable").forEach((_el)=>{
                _el.addEventListener("click", (evt)=>{
                    evt.stopPropagation();
                    this.toggleSelected(item, _el);
                });
            });
        });
    }
    static toggleSelected(root, item) {
        if (item.classList.contains("selected")) item.classList.remove("selected");
        else {
            root.el.querySelectorAll(".hs-accordion-selectable").forEach((el)=>el.classList.remove("selected"));
            item.classList.add("selected");
        }
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $fdf3273b082fdf99$var$HSAccordion.autoInit();
    if (document.querySelectorAll(".hs-accordion-treeview-root").length) $fdf3273b082fdf99$var$HSAccordion.treeView();
// Uncomment for debug
// console.log('Accordion collection:', window.$hsAccordionCollection);
});
if (typeof window !== "undefined") window.HSAccordion = $fdf3273b082fdf99$var$HSAccordion;
var $fdf3273b082fdf99$export$2e2bcd8739ae039 = $fdf3273b082fdf99$var$HSAccordion;


/*
 * HSCarousel
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
const $704e031c65277337$export$1a1f61c9c4dd9df0 = {
    auto: "auto",
    "auto-start": "auto-start",
    "auto-end": "auto-end",
    top: "top",
    "top-left": "top-start",
    "top-right": "top-end",
    bottom: "bottom",
    "bottom-left": "bottom-start",
    "bottom-right": "bottom-end",
    right: "right",
    "right-start": "right-start",
    "right-end": "right-end",
    left: "left",
    "left-start": "left-start",
    "left-end": "left-end"
};
const $704e031c65277337$export$ab14482922808af8 = [
    "Escape",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "Enter"
];
const $704e031c65277337$export$d563486924a41abc = [
    "Escape",
    "Tab"
];
const $704e031c65277337$export$8c1058a58d2daf41 = [
    "ArrowUp",
    "ArrowLeft",
    "ArrowDown",
    "ArrowRight",
    "Home",
    "End"
];
const $704e031c65277337$export$717c92bf60493a1c = [
    "ArrowUp",
    "ArrowLeft",
    "ArrowDown",
    "ArrowRight",
    "Home",
    "End",
    "Escape",
    "Enter",
    "Tab"
];
const $704e031c65277337$export$3ea3ef3aa4c9fb07 = [
    "ArrowUp",
    "ArrowLeft",
    "ArrowDown",
    "ArrowRight",
    "Home",
    "End",
    "Escape",
    "Enter"
];
const $704e031c65277337$export$426e07cd0772984d = {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
};


class $21e0b253669cf069$var$HSCarousel extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-carousel");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.currentIndex = concatOptions.currentIndex || 0;
        this.loadingClasses = concatOptions.loadingClasses ? `${concatOptions.loadingClasses}`.split(",") : null;
        this.dotsItemClasses = concatOptions.dotsItemClasses ? concatOptions.dotsItemClasses : null;
        this.isAutoHeight = typeof concatOptions.isAutoHeight !== "undefined" ? concatOptions.isAutoHeight : false;
        this.isAutoPlay = typeof concatOptions.isAutoPlay !== "undefined" ? concatOptions.isAutoPlay : false;
        this.isCentered = typeof concatOptions.isCentered !== "undefined" ? concatOptions.isCentered : false;
        this.isDraggable = typeof concatOptions.isDraggable !== "undefined" ? concatOptions.isDraggable : false;
        this.isInfiniteLoop = typeof concatOptions.isInfiniteLoop !== "undefined" ? concatOptions.isInfiniteLoop : false;
        this.isRTL = typeof concatOptions.isRTL !== "undefined" ? concatOptions.isRTL : false;
        this.isSnap = typeof concatOptions.isSnap !== "undefined" ? concatOptions.isSnap : false;
        this.hasSnapSpacers = typeof concatOptions.hasSnapSpacers !== "undefined" ? concatOptions.hasSnapSpacers : true;
        this.speed = concatOptions.speed || 4000;
        this.updateDelay = concatOptions.updateDelay || 0;
        this.slidesQty = concatOptions.slidesQty || 1;
        this.loadingClassesRemove = this.loadingClasses?.[0] ? this.loadingClasses[0].split(" ") : "opacity-0";
        this.loadingClassesAdd = this.loadingClasses?.[1] ? this.loadingClasses[1].split(" ") : "";
        this.afterLoadingClassesAdd = this.loadingClasses?.[2] ? this.loadingClasses[2].split(" ") : "";
        this.container = this.el.querySelector(".hs-carousel") || null;
        this.inner = this.el.querySelector(".hs-carousel-body") || null;
        this.slides = this.el.querySelectorAll(".hs-carousel-slide") || [];
        this.prev = this.el.querySelector(".hs-carousel-prev") || null;
        this.next = this.el.querySelector(".hs-carousel-next") || null;
        this.dots = this.el.querySelector(".hs-carousel-pagination") || null;
        this.info = this.el.querySelector(".hs-carousel-info") || null;
        this.infoTotal = this?.info?.querySelector(".hs-carousel-info-total") || null;
        this.infoCurrent = this?.info?.querySelector(".hs-carousel-info-current") || null;
        this.sliderWidth = this.el.getBoundingClientRect().width;
        // Drag events' help variables
        this.isDragging = false;
        this.dragStartX = null;
        this.initialTranslateX = null;
        // Touch events' help variables
        this.touchX = {
            start: 0,
            end: 0
        };
        // Resize events' help variables
        this.resizeContainer = document.querySelector("body");
        this.resizeContainerWidth = 0;
        this.init();
    }
    setIsSnap() {
        const containerRect = this.container.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;
        let closestElement = null;
        let closestElementIndex = null;
        let closestDistance = Infinity;
        Array.from(this.inner.children).forEach((child)=>{
            const childRect = child.getBoundingClientRect();
            const innerContainerRect = this.inner.getBoundingClientRect();
            const childCenter = childRect.left + childRect.width / 2 - innerContainerRect.left;
            const distance = Math.abs(containerCenter - (innerContainerRect.left + childCenter));
            if (distance < closestDistance) {
                closestDistance = distance;
                closestElement = child;
            }
        });
        if (closestElement) closestElementIndex = Array.from(this.slides).findIndex((el)=>el === closestElement);
        this.setIndex(closestElementIndex);
        if (this.dots) this.setCurrentDot();
    }
    init() {
        this.createCollection(window.$hsCarouselCollection, this);
        if (this.inner) {
            this.calculateWidth();
            if (this.isDraggable && !this.isSnap) this.initDragHandling();
        }
        if (this.prev) this.prev.addEventListener("click", ()=>{
            this.goToPrev();
            if (this.isAutoPlay) {
                this.resetTimer();
                this.setTimer();
            }
        });
        if (this.next) this.next.addEventListener("click", ()=>{
            this.goToNext();
            if (this.isAutoPlay) {
                this.resetTimer();
                this.setTimer();
            }
        });
        if (this.dots) this.initDots();
        if (this.info) this.buildInfo();
        if (this.slides.length) {
            this.addCurrentClass();
            if (!this.isInfiniteLoop) this.addDisabledClass();
            if (this.isAutoPlay) this.autoPlay();
        }
        setTimeout(()=>{
            if (this.isSnap) this.setIsSnap();
            if (this.loadingClassesRemove) {
                if (typeof this.loadingClassesRemove === "string") this.inner.classList.remove(this.loadingClassesRemove);
                else this.inner.classList.remove(...this.loadingClassesRemove);
            }
            if (this.loadingClassesAdd) {
                if (typeof this.loadingClassesAdd === "string") this.inner.classList.add(this.loadingClassesAdd);
                else this.inner.classList.add(...this.loadingClassesAdd);
            }
            if (this.inner && this.afterLoadingClassesAdd) setTimeout(()=>{
                if (typeof this.afterLoadingClassesAdd === "string") this.inner.classList.add(this.afterLoadingClassesAdd);
                else this.inner.classList.add(...this.afterLoadingClassesAdd);
            });
        }, 400);
        if (this.isSnap) this.container.addEventListener("scroll", ()=>{
            clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(()=>{
                this.setIsSnap();
            }, 100);
        });
        this.el.classList.add("init");
        if (!this.isSnap) {
            this.el.addEventListener("touchstart", (evt)=>{
                this.touchX.start = evt.changedTouches[0].screenX;
            });
            this.el.addEventListener("touchend", (evt)=>{
                this.touchX.end = evt.changedTouches[0].screenX;
                this.detectDirection();
            });
        }
        this.observeResize();
    }
    initDragHandling() {
        const scrollableElement = this.inner;
        if (scrollableElement) {
            scrollableElement.addEventListener("mousedown", this.handleDragStart.bind(this));
            scrollableElement.addEventListener("touchstart", this.handleDragStart.bind(this), {
                passive: true
            });
            document.addEventListener("mousemove", this.handleDragMove.bind(this));
            document.addEventListener("touchmove", this.handleDragMove.bind(this), {
                passive: false
            });
            document.addEventListener("mouseup", this.handleDragEnd.bind(this));
            document.addEventListener("touchend", this.handleDragEnd.bind(this));
        }
    }
    getTranslateXValue() {
        const transformMatrix = window.getComputedStyle(this.inner).transform;
        if (transformMatrix !== "none") {
            const matrixValues = transformMatrix.match(/matrix.*\((.+)\)/)?.[1].split(", ");
            if (matrixValues) {
                let translateX = parseFloat(matrixValues.length === 6 ? matrixValues[4] : matrixValues[12]);
                if (this.isRTL) translateX = -translateX;
                return isNaN(translateX) || translateX === 0 ? 0 : -translateX;
            }
        }
        return 0;
    }
    removeClickEventWhileDragging(evt) {
        evt.preventDefault();
    }
    handleDragStart(evt) {
        evt.preventDefault();
        this.isDragging = true;
        this.dragStartX = this.getEventX(evt);
        this.initialTranslateX = this.isRTL ? this.getTranslateXValue() : -this.getTranslateXValue();
        this.inner.classList.add("dragging");
    }
    handleDragMove(evt) {
        if (!this.isDragging) return;
        this.inner.querySelectorAll("a:not(.prevented-click)").forEach((el)=>{
            el.classList.add("prevented-click");
            el.addEventListener("click", this.removeClickEventWhileDragging);
        });
        const currentX = this.getEventX(evt);
        let deltaX = currentX - this.dragStartX;
        if (this.isRTL) deltaX = -deltaX;
        const newTranslateX = this.initialTranslateX + deltaX;
        const newTranslateXFunc = ()=>{
            let calcWidth = this.sliderWidth * this.slides.length / this.getCurrentSlidesQty() - this.sliderWidth;
            const containerWidth = this.sliderWidth;
            const itemWidth = containerWidth / this.getCurrentSlidesQty();
            const centeredOffset = (containerWidth - itemWidth) / 2;
            const limitStart = this.isCentered ? centeredOffset : 0;
            if (this.isCentered) calcWidth = calcWidth + centeredOffset;
            const limitEnd = -calcWidth;
            if (this.isRTL) {
                if (newTranslateX < limitStart) return limitStart;
                if (newTranslateX > calcWidth) return limitEnd;
                else return -newTranslateX;
            } else {
                if (newTranslateX > limitStart) return limitStart;
                else if (newTranslateX < -calcWidth) return limitEnd;
                else return newTranslateX;
            }
        };
        this.setTranslate(newTranslateXFunc());
    }
    handleDragEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        const containerWidth = this.sliderWidth;
        const itemWidth = containerWidth / this.getCurrentSlidesQty();
        const currentTranslateX = this.getTranslateXValue();
        let closestIndex = Math.round(currentTranslateX / itemWidth);
        if (this.isRTL) closestIndex = Math.round(currentTranslateX / itemWidth);
        this.inner.classList.remove("dragging");
        setTimeout(()=>{
            this.calculateTransform(closestIndex);
            if (this.dots) this.setCurrentDot();
            this.dragStartX = null;
            this.initialTranslateX = null;
            this.inner.querySelectorAll("a.prevented-click").forEach((el)=>{
                el.classList.remove("prevented-click");
                el.removeEventListener("click", this.removeClickEventWhileDragging);
            });
        });
    }
    getEventX(event) {
        return event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    }
    getCurrentSlidesQty() {
        if (typeof this.slidesQty === "object") {
            const windowWidth = document.body.clientWidth;
            let currentRes = 0;
            Object.keys(this.slidesQty).forEach((key)=>{
                if (windowWidth >= (typeof key + 1 === "number" ? this.slidesQty[key] : (0, $704e031c65277337$export$426e07cd0772984d)[key])) currentRes = this.slidesQty[key];
            });
            return currentRes;
        } else return this.slidesQty;
    }
    buildSnapSpacers() {
        const existingBefore = this.inner.querySelector(".hs-snap-before");
        const existingAfter = this.inner.querySelector(".hs-snap-after");
        if (existingBefore) existingBefore.remove();
        if (existingAfter) existingAfter.remove();
        const containerWidth = this.sliderWidth;
        const itemWidth = containerWidth / this.getCurrentSlidesQty();
        const spacerWidth = containerWidth / 2 - itemWidth / 2;
        const before = (0, $htam9.htmlToElement)(`<div class="hs-snap-before" style="height: 100%; width: ${spacerWidth}px"></div>`);
        const after = (0, $htam9.htmlToElement)(`<div class="hs-snap-after" style="height: 100%; width: ${spacerWidth}px"></div>`);
        this.inner.prepend(before);
        this.inner.appendChild(after);
    }
    initDots() {
        if (this.el.querySelectorAll(".hs-carousel-pagination-item").length) this.setDots();
        else this.buildDots();
        if (this.dots) this.setCurrentDot();
    }
    buildDots() {
        this.dots.innerHTML = "";
        const slidesQty = !this.isCentered && this.slidesQty ? this.slides.length - (this.getCurrentSlidesQty() - 1) : this.slides.length;
        for(let i = 0; i < slidesQty; i++){
            const singleDot = this.buildSingleDot(i);
            this.dots.append(singleDot);
        }
    }
    setDots() {
        this.dotsItems = this.dots.querySelectorAll(".hs-carousel-pagination-item");
        this.dotsItems.forEach((dot, ind)=>{
            const targetIndex = dot.getAttribute("data-carousel-pagination-item-target");
            this.singleDotEvents(dot, targetIndex ? +targetIndex : ind);
        });
    }
    goToCurrentDot() {
        const container = this.dots;
        const containerRect = container.getBoundingClientRect();
        const containerScrollLeft = container.scrollLeft;
        const containerScrollTop = container.scrollTop;
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;
        const item = this.dotsItems[this.currentIndex];
        const itemRect = item.getBoundingClientRect();
        const itemLeft = itemRect.left - containerRect.left + containerScrollLeft;
        const itemRight = itemLeft + item.clientWidth;
        const itemTop = itemRect.top - containerRect.top + containerScrollTop;
        const itemBottom = itemTop + item.clientHeight;
        let scrollLeft = containerScrollLeft;
        let scrollTop = containerScrollTop;
        if (itemLeft < containerScrollLeft || itemRight > containerScrollLeft + containerWidth) scrollLeft = itemRight - containerWidth;
        if (itemTop < containerScrollTop || itemBottom > containerScrollTop + containerHeight) scrollTop = itemBottom - containerHeight;
        container.scrollTo({
            left: scrollLeft,
            top: scrollTop,
            behavior: "smooth"
        });
    }
    buildInfo() {
        if (this.infoTotal) this.setInfoTotal();
        if (this.infoCurrent) this.setInfoCurrent();
    }
    setInfoTotal() {
        this.infoTotal.innerText = `${this.slides.length}`;
    }
    setInfoCurrent() {
        this.infoCurrent.innerText = `${this.currentIndex + 1}`;
    }
    buildSingleDot(ind) {
        const singleDot = (0, $htam9.htmlToElement)("<span></span>");
        if (this.dotsItemClasses) (0, $htam9.classToClassList)(this.dotsItemClasses, singleDot);
        this.singleDotEvents(singleDot, ind);
        return singleDot;
    }
    singleDotEvents(dot, ind) {
        dot.addEventListener("click", ()=>{
            this.goTo(ind);
            if (this.isAutoPlay) {
                this.resetTimer();
                this.setTimer();
            }
        });
    }
    observeResize() {
        const resizeObserver = new ResizeObserver((0, $htam9.debounce)((entries)=>{
            for (let entry of entries){
                const newWidth = entry.contentRect.width;
                if (newWidth !== this.resizeContainerWidth) {
                    this.recalculateWidth();
                    if (this.dots) this.initDots();
                    this.addCurrentClass();
                    this.resizeContainerWidth = newWidth;
                }
            }
        }, this.updateDelay));
        resizeObserver.observe(this.resizeContainer);
    }
    calculateWidth() {
        if (!this.isSnap) this.inner.style.width = `${this.sliderWidth * this.slides.length / this.getCurrentSlidesQty()}px`;
        this.slides.forEach((el)=>{
            el.style.width = `${this.sliderWidth / this.getCurrentSlidesQty()}px`;
        });
        this.calculateTransform();
    }
    addCurrentClass() {
        if (this.isSnap) {
            const itemsQty = Math.floor(this.getCurrentSlidesQty() / 2);
            for(let i = 0; i < this.slides.length; i++){
                const slide = this.slides[i];
                if (i <= this.currentIndex + itemsQty && i >= this.currentIndex - itemsQty) slide.classList.add("active");
                else slide.classList.remove("active");
            }
        } else {
            const maxIndex = this.isCentered ? this.currentIndex + this.getCurrentSlidesQty() + (this.getCurrentSlidesQty() - 1) : this.currentIndex + this.getCurrentSlidesQty();
            this.slides.forEach((el, i)=>{
                if (i >= this.currentIndex && i < maxIndex) el.classList.add("active");
                else el.classList.remove("active");
            });
        }
    }
    setCurrentDot() {
        const toggleDotActive = (el, i)=>{
            let statement = false;
            const itemsQty = Math.floor(this.getCurrentSlidesQty() / 2);
            if (this.isSnap && !this.hasSnapSpacers) statement = i === (this.getCurrentSlidesQty() % 2 === 0 ? this.currentIndex - itemsQty + 1 : this.currentIndex - itemsQty);
            else statement = i === this.currentIndex;
            if (statement) el.classList.add("active");
            else el.classList.remove("active");
        };
        if (this.dotsItems) this.dotsItems.forEach((el, i)=>toggleDotActive(el, i));
        else this.dots.querySelectorAll(":scope > *").forEach((el, i)=>toggleDotActive(el, i));
    }
    setElementToDisabled(el) {
        el.classList.add("disabled");
        if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.setAttribute("disabled", "disabled");
    }
    unsetElementToDisabled(el) {
        el.classList.remove("disabled");
        if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.removeAttribute("disabled");
    }
    addDisabledClass() {
        if (!this.prev || !this.next) return false;
        const gapValue = getComputedStyle(this.inner).getPropertyValue("gap");
        const itemsQty = Math.floor(this.getCurrentSlidesQty() / 2);
        let currentIndex = 0;
        let maxIndex = 0;
        let statementPrev = false;
        let statementNext = false;
        if (this.isSnap) {
            currentIndex = this.currentIndex;
            maxIndex = this.hasSnapSpacers ? this.slides.length - 1 : this.slides.length - itemsQty - 1;
            statementPrev = this.hasSnapSpacers ? currentIndex === 0 : this.getCurrentSlidesQty() % 2 === 0 ? currentIndex - itemsQty < 0 : currentIndex - itemsQty === 0;
            statementNext = currentIndex >= maxIndex && this.container.scrollLeft + this.container.clientWidth + (parseFloat(gapValue) || 0) >= this.container.scrollWidth;
        } else {
            currentIndex = this.currentIndex;
            maxIndex = this.isCentered ? this.slides.length - this.getCurrentSlidesQty() + (this.getCurrentSlidesQty() - 1) : this.slides.length - this.getCurrentSlidesQty();
            statementPrev = currentIndex === 0;
            statementNext = currentIndex >= maxIndex;
        }
        if (statementPrev) {
            this.unsetElementToDisabled(this.next);
            this.setElementToDisabled(this.prev);
        } else if (statementNext) {
            this.unsetElementToDisabled(this.prev);
            this.setElementToDisabled(this.next);
        } else {
            this.unsetElementToDisabled(this.prev);
            this.unsetElementToDisabled(this.next);
        }
    }
    autoPlay() {
        this.setTimer();
    }
    setTimer() {
        this.timer = setInterval(()=>{
            if (this.currentIndex === this.slides.length - 1) this.goTo(0);
            else this.goToNext();
        }, this.speed);
    }
    resetTimer() {
        clearInterval(this.timer);
    }
    detectDirection() {
        const { start: start, end: end } = this.touchX;
        if (end < start) this.goToNext();
        if (end > start) this.goToPrev();
    }
    // Public methods
    recalculateWidth() {
        this.sliderWidth = this.inner.parentElement.getBoundingClientRect().width;
        this.calculateWidth();
        if (this.sliderWidth !== this.inner.parentElement.getBoundingClientRect().width) this.recalculateWidth();
    }
    calculateTransform(currentIdx) {
        if (currentIdx !== undefined) this.currentIndex = currentIdx;
        if (this.currentIndex > this.slides.length - this.getCurrentSlidesQty() && !this.isCentered) this.currentIndex = this.slides.length - this.getCurrentSlidesQty();
        const containerWidth = this.sliderWidth;
        const itemWidth = containerWidth / this.getCurrentSlidesQty();
        let translateX = this.currentIndex * itemWidth;
        // TODO:: need to test auto scrolling to the end if last on resize
        if (this.isSnap && !this.isCentered) {
            if (this.container.scrollLeft < containerWidth && this.container.scrollLeft + itemWidth / 2 > containerWidth) this.container.scrollLeft = this.container.scrollWidth;
        }
        if (this.isCentered && !this.isSnap) {
            const centeredOffset = (containerWidth - itemWidth) / 2;
            if (this.currentIndex === 0) translateX = -centeredOffset;
            else if (this.currentIndex >= this.slides.length - this.getCurrentSlidesQty() + (this.getCurrentSlidesQty() - 1)) {
                const totalSlideWidth = this.slides.length * itemWidth;
                translateX = totalSlideWidth - containerWidth + centeredOffset;
            } else translateX = this.currentIndex * itemWidth - centeredOffset;
        }
        if (!this.isSnap) this.inner.style.transform = this.isRTL ? `translate(${translateX}px, 0px)` : `translate(${-translateX}px, 0px)`;
        if (this.isAutoHeight) this.inner.style.height = `${this.slides[this.currentIndex].clientHeight}px`;
        if (this.dotsItems) this.goToCurrentDot();
        this.addCurrentClass();
        if (!this.isInfiniteLoop) this.addDisabledClass();
        if (this.isSnap && this.hasSnapSpacers) this.buildSnapSpacers();
        if (this.infoCurrent) this.setInfoCurrent();
    }
    setTranslate(val) {
        this.inner.style.transform = this.isRTL ? `translate(${-val}px, 0px)` : `translate(${val}px, 0px)`;
    }
    goToPrev() {
        if (this.currentIndex > 0) this.currentIndex--;
        else this.currentIndex = this.slides.length - this.getCurrentSlidesQty();
        if (this.isSnap) {
            const itemWidth = this.sliderWidth / this.getCurrentSlidesQty();
            this.container.scrollBy({
                left: Math.max(-this.container.scrollLeft, -itemWidth),
                behavior: "smooth"
            });
            this.addCurrentClass();
            if (!this.isInfiniteLoop) this.addDisabledClass();
        } else this.calculateTransform();
        if (this.dots) this.setCurrentDot();
    }
    goToNext() {
        const statement = this.isCentered ? this.slides.length - this.getCurrentSlidesQty() + (this.getCurrentSlidesQty() - 1) : this.slides.length - this.getCurrentSlidesQty();
        if (this.currentIndex < statement) this.currentIndex++;
        else this.currentIndex = 0;
        if (this.isSnap) {
            const itemWidth = this.sliderWidth / this.getCurrentSlidesQty();
            const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;
            this.container.scrollBy({
                left: Math.min(itemWidth, maxScrollLeft - this.container.scrollLeft),
                behavior: "smooth"
            });
            this.addCurrentClass();
            if (!this.isInfiniteLoop) this.addDisabledClass();
        } else this.calculateTransform();
        if (this.dots) this.setCurrentDot();
    }
    goTo(i) {
        const currentIndex = this.currentIndex;
        this.currentIndex = i;
        if (this.isSnap) {
            const itemWidth = this.sliderWidth / this.getCurrentSlidesQty();
            const index = currentIndex > this.currentIndex ? currentIndex - this.currentIndex : this.currentIndex - currentIndex;
            const width = currentIndex > this.currentIndex ? -(itemWidth * index) : itemWidth * index;
            this.container.scrollBy({
                left: width,
                behavior: "smooth"
            });
            this.addCurrentClass();
            if (!this.isInfiniteLoop) this.addDisabledClass();
        } else this.calculateTransform();
        if (this.dots) this.setCurrentDot();
    }
    setIndex(i) {
        this.currentIndex = i;
        this.addCurrentClass();
        if (!this.isInfiniteLoop) this.addDisabledClass();
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsCarouselCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsCarouselCollection) window.$hsCarouselCollection = [];
        document.querySelectorAll("[data-hs-carousel]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsCarouselCollection.find((elC)=>elC?.element?.el === el)) new $21e0b253669cf069$var$HSCarousel(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $21e0b253669cf069$var$HSCarousel.autoInit();
// Uncomment for debug
// console.log('Carousel collection:', window.$hsCarouselCollection);
});
if (typeof window !== "undefined") window.HSCarousel = $21e0b253669cf069$var$HSCarousel;
var $21e0b253669cf069$export$2e2bcd8739ae039 = $21e0b253669cf069$var$HSCarousel;


/*
 * HSCollapse
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $c33bd9274652961f$var$HSCollapse extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        this.contentId = this.el.dataset.hsCollapse;
        this.content = document.querySelector(this.contentId);
        this.animationInProcess = false;
        if (this.content) this.init();
    }
    init() {
        this.createCollection(window.$hsCollapseCollection, this);
        if (this?.el?.ariaExpanded) {
            if (this.el.classList.contains("open")) this.el.ariaExpanded = "true";
            else this.el.ariaExpanded = "false";
        }
        this.el.addEventListener("click", ()=>{
            if (this.content.classList.contains("open")) this.hide();
            else this.show();
        });
    }
    hideAllMegaMenuItems() {
        this.content.querySelectorAll(".hs-mega-menu-content.block").forEach((el)=>{
            el.classList.remove("block");
            el.classList.add("hidden");
        });
    }
    // Public methods
    show() {
        if (this.animationInProcess || this.el.classList.contains("open")) return false;
        this.animationInProcess = true;
        this.el.classList.add("open");
        if (this?.el?.ariaExpanded) this.el.ariaExpanded = "true";
        this.content.classList.add("open");
        this.content.classList.remove("hidden");
        this.content.style.height = "0";
        setTimeout(()=>{
            this.content.style.height = `${this.content.scrollHeight}px`;
            this.fireEvent("beforeOpen", this.el);
            (0, $htam9.dispatch)("beforeOpen.hs.collapse", this.el, this.el);
        });
        (0, $htam9.afterTransition)(this.content, ()=>{
            this.content.style.height = "";
            this.fireEvent("open", this.el);
            (0, $htam9.dispatch)("open.hs.collapse", this.el, this.el);
            this.animationInProcess = false;
        });
    }
    hide() {
        if (this.animationInProcess || !this.el.classList.contains("open")) return false;
        this.animationInProcess = true;
        this.el.classList.remove("open");
        if (this?.el?.ariaExpanded) this.el.ariaExpanded = "false";
        this.content.style.height = `${this.content.scrollHeight}px`;
        setTimeout(()=>{
            this.content.style.height = "0";
        });
        this.content.classList.remove("open");
        (0, $htam9.afterTransition)(this.content, ()=>{
            this.content.classList.add("hidden");
            this.content.style.height = "";
            this.fireEvent("hide", this.el);
            (0, $htam9.dispatch)("hide.hs.collapse", this.el, this.el);
            this.animationInProcess = false;
        });
        if (this.content.querySelectorAll(".hs-mega-menu-content.block").length) this.hideAllMegaMenuItems();
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsCollapseCollection) window.$hsCollapseCollection = [];
        document.querySelectorAll(".hs-collapse-toggle:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsCollapseCollection.find((elC)=>elC?.element?.el === el)) new $c33bd9274652961f$var$HSCollapse(el);
        });
    }
    static show(target) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.content.classList.contains("hidden")) elInCollection.element.show();
    }
    static hide(target) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.content.classList.contains("hidden")) elInCollection.element.hide();
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $c33bd9274652961f$var$HSCollapse.autoInit();
// Uncomment for debug
// console.log('Collapse collection:', window.$hsCollapseCollection);
});
if (typeof window !== "undefined") window.HSCollapse = $c33bd9274652961f$var$HSCollapse;
var $c33bd9274652961f$export$2e2bcd8739ae039 = $c33bd9274652961f$var$HSCollapse;


/*
 * HSComboBox
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");

class $4dd20d6ee44ededb$var$HSComboBox extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        // Data parameters
        const data = el.getAttribute("data-hs-combo-box");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.gap = 5;
        this.viewport = (typeof concatOptions?.viewport === "string" ? document.querySelector(concatOptions?.viewport) : concatOptions?.viewport) ?? null;
        this.preventVisibility = concatOptions?.preventVisibility ?? false;
        this.apiUrl = concatOptions?.apiUrl ?? null;
        this.apiDataPart = concatOptions?.apiDataPart ?? null;
        this.apiQuery = concatOptions?.apiQuery ?? null;
        this.apiSearchQuery = concatOptions?.apiSearchQuery ?? null;
        this.apiHeaders = concatOptions?.apiHeaders ?? {};
        this.apiGroupField = concatOptions?.apiGroupField ?? null;
        this.outputItemTemplate = concatOptions?.outputItemTemplate ?? `<div class="cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800" data-hs-combo-box-output-item>
				<div class="flex justify-between items-center w-full">
					<span data-hs-combo-box-search-text></span>
					<span class="hidden hs-combo-box-selected:block">
						<svg class="shrink-0 size-3.5 text-blue-600 dark:text-blue-500" xmlns="http:.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<polyline points="20 6 9 17 4 12"></polyline>
						</svg>
					</span>
				</div>
			</div>`;
        this.outputEmptyTemplate = concatOptions?.outputEmptyTemplate ?? `<div class="py-2 px-4 w-full text-sm text-gray-800 rounded-lg dark:bg-neutral-900 dark:text-neutral-200">Nothing found...</div>`;
        this.outputLoaderTemplate = concatOptions?.outputLoaderTemplate ?? `<div class="flex justify-center items-center py-2 px-4 text-sm text-gray-800 rounded-lg bg-white dark:bg-neutral-900 dark:text-neutral-200">
				<div class="animate-spin inline-block size-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full dark:text-blue-500" role="status" aria-label="loading">
					<span class="sr-only">Loading...</span>
				</div>
			</div>`;
        this.groupingType = concatOptions?.groupingType ?? null;
        this.groupingTitleTemplate = concatOptions?.groupingTitleTemplate ?? (this.groupingType === "default" ? `<div class="block mb-1 text-xs font-semibold uppercase text-blue-600 dark:text-blue-500"></div>` : `<button type="button" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold whitespace-nowrap rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"></button>`);
        this.tabsWrapperTemplate = concatOptions?.tabsWrapperTemplate ?? `<div class="overflow-x-auto p-4"></div>`;
        this.preventSelection = concatOptions?.preventSelection ?? false;
        this.preventAutoPosition = concatOptions?.preventAutoPosition ?? false;
        this.isOpenOnFocus = concatOptions?.isOpenOnFocus ?? false;
        // Internal parameters
        this.input = this.el.querySelector("[data-hs-combo-box-input]") ?? null;
        this.output = this.el.querySelector("[data-hs-combo-box-output]") ?? null;
        this.itemsWrapper = this.el.querySelector("[data-hs-combo-box-output-items-wrapper]") ?? null;
        this.items = Array.from(this.el.querySelectorAll("[data-hs-combo-box-output-item]")) ?? [];
        this.tabs = [];
        this.toggle = this.el.querySelector("[data-hs-combo-box-toggle]") ?? null;
        this.toggleClose = this.el.querySelector("[data-hs-combo-box-close]") ?? null;
        this.toggleOpen = this.el.querySelector("[data-hs-combo-box-open]") ?? null;
        this.outputPlaceholder = null;
        this.selected = this.value = this.el.querySelector("[data-hs-combo-box-input]").value ?? "";
        this.isOpened = false;
        this.isCurrent = false;
        this.animationInProcess = false;
        this.selectedGroup = "all";
        this.init();
    }
    init() {
        this.createCollection(window.$hsComboBoxCollection, this);
        this.build();
    }
    build() {
        this.buildInput();
        if (this.groupingType) this.setGroups();
        this.buildItems();
        if (this.preventVisibility) // TODO:: test the plugin while the line below is commented.
        // this.isOpened = true;
        {
            if (!this.preventAutoPosition) this.recalculateDirection();
        }
        if (this.toggle) this.buildToggle();
        if (this.toggleClose) this.buildToggleClose();
        if (this.toggleOpen) this.buildToggleOpen();
    }
    setResultAndRender(value = "") {
        // TODO:: test the plugin with below code added.
        let _value = this.preventVisibility ? this.input.value : value;
        this.setResults(_value);
        if (this.apiSearchQuery) this.itemsFromJson();
    }
    buildInput() {
        if (this.isOpenOnFocus) this.input.addEventListener("focus", ()=>{
            if (!this.isOpened) {
                this.setResultAndRender();
                this.open();
            }
        });
        this.input.addEventListener("input", (0, $htam9.debounce)((evt)=>{
            this.setResultAndRender(evt.target.value);
            if (this.input.value !== "") this.el.classList.add("has-value");
            else this.el.classList.remove("has-value");
            if (!this.isOpened) this.open();
        }));
    }
    buildItems() {
        this.output.role = "listbox";
        this.output.tabIndex = -1;
        this.output.ariaOrientation = "vertical";
        if (this.apiUrl) this.itemsFromJson();
        else {
            if (this.itemsWrapper) this.itemsWrapper.innerHTML = "";
            else this.output.innerHTML = "";
            this.itemsFromHtml();
        }
    }
    setResults(val) {
        this.value = val;
        this.resultItems();
        if (this.hasVisibleItems()) this.destroyOutputPlaceholder();
        else this.buildOutputPlaceholder();
    }
    isItemExists(obj) {
        return this.items.some((el)=>{
            const groupField = el.getAttribute("data-hs-combo-box-output-item-group-field") ?? null;
            const params = JSON.parse(el.getAttribute("data-hs-combo-box-output-item")) ?? null;
            let group = null;
            if (groupField && params?.group?.name) group = obj[groupField];
            return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).some((elI)=>{
                const equality = params?.group?.name && group ? group === params.group.name && elI.getAttribute("data-hs-combo-box-search-text") === obj[elI.getAttribute("data-hs-combo-box-output-item-field")] : elI.getAttribute("data-hs-combo-box-search-text") === obj[elI.getAttribute("data-hs-combo-box-output-item-field")];
                return equality;
            });
        });
    }
    isTextExists(el, val) {
        const lowerCased = val.map((v)=>v.toLowerCase());
        return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).some((elI)=>lowerCased.includes(elI.getAttribute("data-hs-combo-box-search-text").toLowerCase()));
    }
    isTextExistsAny(el, val) {
        return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).some((elI)=>elI.getAttribute("data-hs-combo-box-search-text").toLowerCase().includes(val.toLowerCase()));
    }
    valuesBySelector(el) {
        return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).reduce((acc, cur)=>[
                ...acc,
                cur.getAttribute("data-hs-combo-box-search-text")
            ], []);
    }
    buildOutputLoader() {
        if (this.outputLoader) return false;
        this.outputLoader = (0, $htam9.htmlToElement)(this.outputLoaderTemplate);
        if (this.items.length || this.outputPlaceholder) {
            this.outputLoader.style.position = "absolute";
            this.outputLoader.style.top = "0";
            this.outputLoader.style.bottom = "0";
            this.outputLoader.style.left = "0";
            this.outputLoader.style.right = "0";
            this.outputLoader.style.zIndex = "2";
        } else {
            this.outputLoader.style.position = "";
            this.outputLoader.style.top = "";
            this.outputLoader.style.bottom = "";
            this.outputLoader.style.left = "";
            this.outputLoader.style.right = "";
            this.outputLoader.style.zIndex = "";
            this.outputLoader.style.height = "30px";
        }
        this.output.append(this.outputLoader);
    }
    destroyOutputLoader() {
        if (this.outputLoader) this.outputLoader.remove();
        this.outputLoader = null;
    }
    async itemsFromJson() {
        this.buildOutputLoader();
        try {
            const query = `${this.apiQuery}`;
            const searchQuery = `${this.apiSearchQuery}=${this.value.toLowerCase()}`;
            let url = this.apiUrl;
            if (this.apiQuery && this.apiSearchQuery) url += `?${searchQuery}&${query}`;
            else if (this.apiQuery) url += `?${query}`;
            else if (this.apiSearchQuery) url += `?${searchQuery}`;
            const res = await fetch(url, this.apiHeaders);
            let items = await res.json();
            if (this.apiDataPart) items = items[this.apiDataPart];
            if (this.apiSearchQuery) this.items = [];
            if (this.itemsWrapper) this.itemsWrapper.innerHTML = "";
            else this.output.innerHTML = "";
            if (this.groupingType === "tabs") {
                this.setApiGroups(items);
                this.groupTabsRender();
                this.jsonItemsRender(items);
            } else if (this.groupingType === "default") {
                this.setApiGroups(items);
                this.groups.forEach((el)=>{
                    const title = (0, $htam9.htmlToElement)(this.groupingTitleTemplate);
                    title.setAttribute("data-hs-combo-box-group-title", el.name);
                    title.classList.add("--exclude-accessibility");
                    title.innerText = el.title;
                    const newItems = items.filter((i)=>i[this.apiGroupField] === el.name);
                    if (this.itemsWrapper) this.itemsWrapper.append(title);
                    else this.output.append(title);
                    this.jsonItemsRender(newItems);
                });
            } else this.jsonItemsRender(items);
            this.setResults(this.input.value);
        } catch (err) {
            console.error(err);
        }
        this.destroyOutputLoader();
    }
    jsonItemsRender(items) {
        items.forEach((item, index)=>{
            // TODO:: test without checking below
            // if (this.isItemExists(item)) return false;
            const newItem = (0, $htam9.htmlToElement)(this.outputItemTemplate);
            newItem.querySelectorAll("[data-hs-combo-box-output-item-field]").forEach((el)=>{
                const value = item[el.getAttribute("data-hs-combo-box-output-item-field")];
                const hideIfEmpty = el.hasAttribute("data-hs-combo-box-output-item-hide-if-empty");
                el.textContent = value ?? "";
                if (!value && hideIfEmpty) el.style.display = "none";
            });
            newItem.querySelectorAll("[data-hs-combo-box-search-text]").forEach((el)=>{
                el.setAttribute("data-hs-combo-box-search-text", item[el.getAttribute("data-hs-combo-box-output-item-field")] ?? "");
            });
            newItem.querySelectorAll("[data-hs-combo-box-output-item-attr]").forEach((el)=>{
                const attributes = JSON.parse(el.getAttribute("data-hs-combo-box-output-item-attr"));
                attributes.forEach((attr)=>{
                    el.setAttribute(attr.attr, item[attr.valueFrom]);
                });
            });
            newItem.setAttribute("tabIndex", `${index}`);
            if (this.groupingType === "tabs" || this.groupingType === "default") newItem.setAttribute("data-hs-combo-box-output-item", `{"group": {"name": "${item[this.apiGroupField]}", "title": "${item[this.apiGroupField]}"}}`);
            this.items = [
                ...this.items,
                newItem
            ];
            if (!this.preventSelection) newItem.addEventListener("click", ()=>{
                this.close(newItem.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text"));
                this.setSelectedByValue(this.valuesBySelector(newItem));
            });
            this.appendItemsToWrapper(newItem);
        });
    }
    setGroups() {
        const groups = [];
        this.items.forEach((item)=>{
            const { group: group } = JSON.parse(item.getAttribute("data-hs-combo-box-output-item"));
            if (!groups.some((el)=>el?.name === group.name)) groups.push(group);
        });
        this.groups = groups;
    }
    setCurrent() {
        if (window.$hsComboBoxCollection.length) {
            window.$hsComboBoxCollection.map((el)=>el.element.isCurrent = false);
            this.isCurrent = true;
        }
    }
    setApiGroups(items) {
        const groups = [];
        items.forEach((item)=>{
            const group = item[this.apiGroupField];
            if (!groups.some((el)=>el.name === group)) groups.push({
                name: group,
                title: group
            });
        });
        this.groups = groups;
    }
    sortItems() {
        const compareFn = (i1, i2)=>{
            const a = i1.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
            const b = i2.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
            if (a < b) return -1;
            else if (a > b) return 1;
            return 0;
        };
        return this.items.sort(compareFn);
    }
    itemRender(item) {
        const val = item.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
        if (this.itemsWrapper) this.itemsWrapper.append(item);
        else this.output.append(item);
        if (!this.preventSelection) item.addEventListener("click", ()=>{
            this.close(val);
            this.setSelectedByValue(this.valuesBySelector(item));
        });
    }
    plainRender(items) {
        items.forEach((item)=>{
            this.itemRender(item);
        });
    }
    groupTabsRender() {
        const tabsScroll = (0, $htam9.htmlToElement)(this.tabsWrapperTemplate);
        const tabsWrapper = (0, $htam9.htmlToElement)(`<div class="flex flex-nowrap gap-x-2"></div>`);
        tabsScroll.append(tabsWrapper);
        this.output.insertBefore(tabsScroll, this.output.firstChild);
        const tabDef = (0, $htam9.htmlToElement)(this.groupingTitleTemplate);
        tabDef.setAttribute("data-hs-combo-box-group-title", "all");
        tabDef.classList.add("--exclude-accessibility", "active");
        tabDef.innerText = "All";
        this.tabs = [
            ...this.tabs,
            tabDef
        ];
        tabsWrapper.append(tabDef);
        tabDef.addEventListener("click", ()=>{
            this.selectedGroup = "all";
            const selectedTab = this.tabs.find((elI)=>elI.getAttribute("data-hs-combo-box-group-title") === this.selectedGroup);
            this.tabs.forEach((el)=>el.classList.remove("active"));
            selectedTab.classList.add("active");
            this.setItemsVisibility();
        });
        this.groups.forEach((el)=>{
            const tab = (0, $htam9.htmlToElement)(this.groupingTitleTemplate);
            tab.setAttribute("data-hs-combo-box-group-title", el.name);
            tab.classList.add("--exclude-accessibility");
            tab.innerText = el.title;
            this.tabs = [
                ...this.tabs,
                tab
            ];
            tabsWrapper.append(tab);
            tab.addEventListener("click", ()=>{
                this.selectedGroup = el.name;
                const selectedTab = this.tabs.find((elI)=>elI.getAttribute("data-hs-combo-box-group-title") === this.selectedGroup);
                this.tabs.forEach((el)=>el.classList.remove("active"));
                selectedTab.classList.add("active");
                this.setItemsVisibility();
            });
        });
    }
    groupDefaultRender() {
        this.groups.forEach((el)=>{
            const title = (0, $htam9.htmlToElement)(this.groupingTitleTemplate);
            title.setAttribute("data-hs-combo-box-group-title", el.name);
            title.classList.add("--exclude-accessibility");
            title.innerText = el.title;
            if (this.itemsWrapper) this.itemsWrapper.append(title);
            else this.output.append(title);
            const items = this.sortItems().filter((f)=>{
                const { group: group } = JSON.parse(f.getAttribute("data-hs-combo-box-output-item"));
                return group.name === el.name;
            });
            this.plainRender(items);
        });
    }
    itemsFromHtml() {
        if (this.groupingType === "default") this.groupDefaultRender();
        else if (this.groupingType === "tabs") {
            const items = this.sortItems();
            this.groupTabsRender();
            this.plainRender(items);
        } else {
            const items = this.sortItems();
            this.plainRender(items);
        }
        this.setResults(this.input.value);
    }
    buildToggle() {
        if (this.isOpened) {
            if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "true";
            if (this?.input?.ariaExpanded) this.input.ariaExpanded = "true";
        } else {
            if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "false";
            if (this?.input?.ariaExpanded) this.input.ariaExpanded = "false";
        }
        this.toggle.addEventListener("click", ()=>{
            if (this.isOpened) this.close();
            else this.open(this.toggle.getAttribute("data-hs-combo-box-toggle"));
        });
    }
    buildToggleClose() {
        this.toggleClose.addEventListener("click", ()=>this.close());
    }
    buildToggleOpen() {
        this.toggleOpen.addEventListener("click", ()=>this.open());
    }
    setSelectedByValue(val) {
        this.items.forEach((el)=>{
            if (this.isTextExists(el, val)) el.classList.add("selected");
            else el.classList.remove("selected");
        });
    }
    setValue(val) {
        this.selected = val;
        this.value = val;
        this.input.value = val;
        this.fireEvent("select", this.el);
        (0, $htam9.dispatch)("select.hs.combobox", this.el, this.value);
    }
    setItemsVisibility() {
        if (this.groupingType === "tabs" && this.selectedGroup !== "all") this.items.forEach((item)=>{
            item.style.display = "none";
        });
        const items = this.groupingType === "tabs" ? this.selectedGroup === "all" ? this.items : this.items.filter((f)=>{
            const { group: group } = JSON.parse(f.getAttribute("data-hs-combo-box-output-item"));
            return group.name === this.selectedGroup;
        }) : this.items;
        if (this.groupingType === "tabs" && this.selectedGroup !== "all") items.forEach((item)=>{
            item.style.display = "block";
        });
        items.forEach((item)=>{
            if (!this.isTextExistsAny(item, this.value)) item.style.display = "none";
            else item.style.display = "block";
        });
        if (this.groupingType === "default") this.output.querySelectorAll("[data-hs-combo-box-group-title]").forEach((el)=>{
            const g = el.getAttribute("data-hs-combo-box-group-title");
            const items = this.items.filter((f)=>{
                const { group: group } = JSON.parse(f.getAttribute("data-hs-combo-box-output-item"));
                return group.name === g && f.style.display === "block";
            });
            if (items.length) el.style.display = "block";
            else el.style.display = "none";
        });
    }
    hasVisibleItems() {
        return this.items.length ? this.items.some((el)=>el.style.display === "block") : false;
    }
    appendItemsToWrapper(item) {
        if (this.itemsWrapper) this.itemsWrapper.append(item);
        else this.output.append(item);
    }
    buildOutputPlaceholder() {
        if (!this.outputPlaceholder) this.outputPlaceholder = (0, $htam9.htmlToElement)(this.outputEmptyTemplate);
        this.appendItemsToWrapper(this.outputPlaceholder);
    }
    destroyOutputPlaceholder() {
        if (this.outputPlaceholder) this.outputPlaceholder.remove();
        this.outputPlaceholder = null;
    }
    resultItems() {
        if (!this.items.length) return false;
        this.setItemsVisibility();
        this.setSelectedByValue([
            this.selected
        ]);
    }
    // Public methods
    setValueAndOpen(val) {
        this.value = val;
        if (this.items.length) this.setItemsVisibility();
    }
    open(val) {
        if (this.animationInProcess) return false;
        if (typeof val !== "undefined") this.setValueAndOpen(val);
        if (this.preventVisibility) return false;
        this.animationInProcess = true;
        this.output.style.display = "block";
        if (!this.preventAutoPosition) this.recalculateDirection();
        setTimeout(()=>{
            if (this?.input?.ariaExpanded) this.input.ariaExpanded = "true";
            if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "true";
            this.el.classList.add("active");
            this.animationInProcess = false;
        });
        this.isOpened = true;
    }
    setValueAndClear(val) {
        if (val) this.setValue(val);
        else this.setValue(this.selected);
        if (this.outputPlaceholder) this.destroyOutputPlaceholder();
    }
    close(val) {
        if (this.animationInProcess) return false;
        if (this.preventVisibility) {
            this.setValueAndClear(val);
            if (this.input.value !== "") this.el.classList.add("has-value");
            else this.el.classList.remove("has-value");
            return false;
        }
        this.animationInProcess = true;
        if (this?.input?.ariaExpanded) this.input.ariaExpanded = "false";
        if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "false";
        this.el.classList.remove("active");
        if (!this.preventAutoPosition) {
            this.output.classList.remove("bottom-full", "top-full");
            this.output.style.marginTop = "";
            this.output.style.marginBottom = "";
        }
        (0, $htam9.afterTransition)(this.output, ()=>{
            this.output.style.display = "none";
            this.setValueAndClear(val);
            this.animationInProcess = false;
        });
        if (this.input.value !== "") this.el.classList.add("has-value");
        else this.el.classList.remove("has-value");
        this.isOpened = false;
    }
    recalculateDirection() {
        if ((0, $htam9.isEnoughSpace)(this.output, this.input, "bottom", this.gap, this.viewport)) {
            this.output.classList.remove("bottom-full");
            this.output.style.marginBottom = "";
            this.output.classList.add("top-full");
            this.output.style.marginTop = `${this.gap}px`;
        } else {
            this.output.classList.remove("top-full");
            this.output.style.marginTop = "";
            this.output.classList.add("bottom-full");
            this.output.style.marginBottom = `${this.gap}px`;
        }
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsComboBoxCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsComboBoxCollection) window.$hsComboBoxCollection = [];
        document.querySelectorAll("[data-hs-combo-box]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsComboBoxCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-combo-box");
                const options = data ? JSON.parse(data) : {};
                new $4dd20d6ee44ededb$var$HSComboBox(el, options);
            }
        });
        if (window.$hsComboBoxCollection) {
            window.addEventListener("click", (evt)=>{
                const evtTarget = evt.target;
                $4dd20d6ee44ededb$var$HSComboBox.closeCurrentlyOpened(evtTarget);
            });
            document.addEventListener("keydown", (evt)=>$4dd20d6ee44ededb$var$HSComboBox.accessibility(evt));
        }
    }
    static close(target) {
        const elInCollection = window.$hsComboBoxCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.isOpened) elInCollection.element.close();
    }
    static closeCurrentlyOpened(evtTarget = null) {
        if (!evtTarget.closest("[data-hs-combo-box].active")) {
            const currentlyOpened = window.$hsComboBoxCollection.filter((el)=>el.element.isOpened) || null;
            if (currentlyOpened) currentlyOpened.forEach((el)=>{
                el.element.close();
            });
        }
    }
    // Accessibility methods
    static getPreparedItems(isReversed = false, output) {
        if (!output) return null;
        const preparedItems = isReversed ? Array.from(output.querySelectorAll(":scope > *:not(.--exclude-accessibility)")).filter((el)=>el.style.display !== "none").reverse() : Array.from(output.querySelectorAll(":scope > *:not(.--exclude-accessibility)")).filter((el)=>el.style.display !== "none");
        const items = preparedItems.filter((el)=>!el.classList.contains("disabled"));
        return items;
    }
    static setHighlighted(prev, current, input) {
        current.focus();
        input.value = current.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
        if (prev) prev.classList.remove("hs-combo-box-output-item-highlighted");
        current.classList.add("hs-combo-box-output-item-highlighted");
    }
    static accessibility(evt) {
        const target = window.$hsComboBoxCollection.find((el)=>el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened);
        if (target && (0, $704e031c65277337$export$3ea3ef3aa4c9fb07).includes(evt.code) && !evt.metaKey) switch(evt.code){
            case "Escape":
                evt.preventDefault();
                this.onEscape();
                break;
            case "ArrowUp":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onArrow();
                break;
            case "ArrowDown":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onArrow(false);
                break;
            case "Home":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onStartEnd();
                break;
            case "End":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onStartEnd(false);
                break;
            case "Enter":
                evt.preventDefault();
                this.onEnter(evt);
                break;
            default:
                break;
        }
    }
    static onEscape() {
        const target = window.$hsComboBoxCollection.find((el)=>!el.element.preventVisibility && el.element.isOpened);
        if (target) {
            target.element.close();
            target.element.input.blur();
        }
    }
    static onArrow(isArrowUp = true) {
        const target = window.$hsComboBoxCollection.find((el)=>el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened);
        if (target) {
            const output = target.element.itemsWrapper ?? target.element.output;
            if (!output) return false;
            const items = $4dd20d6ee44ededb$var$HSComboBox.getPreparedItems(isArrowUp, output);
            const current = output.querySelector(".hs-combo-box-output-item-highlighted");
            let currentItem = null;
            if (!current) items[0].classList.add("hs-combo-box-output-item-highlighted");
            let currentInd = items.findIndex((el)=>el === current);
            if (currentInd + 1 < items.length) currentInd++;
            currentItem = items[currentInd];
            $4dd20d6ee44ededb$var$HSComboBox.setHighlighted(current, currentItem, target.element.input);
        }
    }
    static onStartEnd(isStart = true) {
        const target = window.$hsComboBoxCollection.find((el)=>el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened);
        if (target) {
            const output = target.element.itemsWrapper ?? target.element.output;
            if (!output) return false;
            const items = $4dd20d6ee44ededb$var$HSComboBox.getPreparedItems(isStart, output);
            const current = output.querySelector(".hs-combo-box-output-item-highlighted");
            if (items.length) $4dd20d6ee44ededb$var$HSComboBox.setHighlighted(current, items[0], target.element.input);
        }
    }
    static onEnter(evt) {
        const target = evt.target;
        const opened = window.$hsComboBoxCollection.find((el)=>!(0, $htam9.isParentOrElementHidden)(el.element.el) && evt.target.closest("[data-hs-combo-box]") === el.element.el);
        const link = opened.element.el.querySelector(".hs-combo-box-output-item-highlighted a");
        if (target.hasAttribute("data-hs-combo-box-input")) {
            opened.element.close();
            target.blur();
        } else {
            if (!opened.element.preventSelection) opened.element.setSelectedByValue(opened.element.valuesBySelector(evt.target));
            if (opened.element.preventSelection && link) window.location.assign(link.getAttribute("href"));
            opened.element.close(!opened.element.preventSelection ? evt.target.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text") : null);
        }
    }
}
window.addEventListener("load", ()=>{
    $4dd20d6ee44ededb$var$HSComboBox.autoInit();
// Uncomment for debug
// console.log('ComboBox collection:', window.$hsComboBoxCollection);
});
document.addEventListener("scroll", ()=>{
    if (!window.$hsComboBoxCollection) return false;
    const target = window.$hsComboBoxCollection.find((el)=>el.element.isOpened);
    if (target && !target.element.preventAutoPosition) target.element.recalculateDirection();
});
if (typeof window !== "undefined") window.HSComboBox = $4dd20d6ee44ededb$var$HSComboBox;
var $4dd20d6ee44ededb$export$2e2bcd8739ae039 = $4dd20d6ee44ededb$var$HSComboBox;


/*
 * HSDropdown
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");
function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}


function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}







function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};










var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};


var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}







function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};




var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $kYnwU = parcelRequire("kYnwU");

class $3165a178822236d6$var$HSDropdown extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        this.toggle = this.el.querySelector(":scope > .hs-dropdown-toggle") || this.el.querySelector(":scope > .hs-dropdown-toggle-wrapper > .hs-dropdown-toggle") || this.el.children[0];
        this.closers = Array.from(this.el.querySelectorAll(":scope .hs-dropdown-close")) || null;
        this.menu = this.el.querySelector(":scope > .hs-dropdown-menu");
        this.eventMode = (0, $htam9.getClassProperty)(this.el, "--trigger", "click");
        this.closeMode = (0, $htam9.getClassProperty)(this.el, "--auto-close", "true");
        this.animationInProcess = false;
        if (this.toggle && this.menu) this.init();
    }
    init() {
        this.createCollection(window.$hsDropdownCollection, this);
        if (this.toggle.disabled) return false;
        if (this.toggle) this.buildToggle();
        if (this.menu) this.buildMenu();
        if (this.closers) this.buildClosers();
        if (!(0, $htam9.isIOS)() && !(0, $htam9.isIpadOS)()) {
            this.el.addEventListener("mouseenter", ()=>this.onMouseEnterHandler());
            this.el.addEventListener("mouseleave", ()=>this.onMouseLeaveHandler());
        }
    }
    resizeHandler() {
        this.eventMode = (0, $htam9.getClassProperty)(this.el, "--trigger", "click");
        this.closeMode = (0, $htam9.getClassProperty)(this.el, "--auto-close", "true");
    }
    buildToggle() {
        if (this?.toggle?.ariaExpanded) {
            if (this.el.classList.contains("open")) this.toggle.ariaExpanded = "true";
            else this.toggle.ariaExpanded = "false";
        }
        this.toggle.addEventListener("click", (evt)=>this.onClickHandler(evt));
    }
    buildMenu() {
        this.menu.role = "menu";
    }
    buildClosers() {
        this.closers.forEach((el)=>{
            el.addEventListener("click", ()=>this.close());
        });
    }
    onClickHandler(evt) {
        if (this.el.classList.contains("open") && !this.menu.classList.contains("hidden")) this.close();
        else this.open();
    }
    onMouseEnterHandler() {
        if (this.eventMode !== "hover") return false;
        if (this.el._popper) this.forceClearState();
        if (!this.el.classList.contains("open") && this.menu.classList.contains("hidden")) this.open();
    }
    onMouseLeaveHandler() {
        if (this.eventMode !== "hover") return false;
        if (this.el.classList.contains("open") && !this.menu.classList.contains("hidden")) this.close();
    }
    destroyPopper() {
        this.menu.classList.remove("block");
        this.menu.classList.add("hidden");
        this.menu.style.inset = null;
        this.menu.style.position = null;
        if (this.el && this.el._popper) this.el._popper.destroy();
        this.animationInProcess = false;
    }
    absoluteStrategyModifiers() {
        return [
            {
                name: "applyStyles",
                fn: (data)=>{
                    const strategy = (window.getComputedStyle(this.el).getPropertyValue("--strategy") || "absolute").replace(" ", "");
                    const adaptive = (window.getComputedStyle(this.el).getPropertyValue("--adaptive") || "adaptive").replace(" ", "");
                    data.state.elements.popper.style.position = strategy;
                    data.state.elements.popper.style.transform = adaptive === "adaptive" ? data.state.styles.popper.transform : null;
                    data.state.elements.popper.style.top = null;
                    data.state.elements.popper.style.bottom = null;
                    data.state.elements.popper.style.left = null;
                    data.state.elements.popper.style.right = null;
                    data.state.elements.popper.style.margin = 0;
                }
            }
        ];
    }
    // Public methods
    open() {
        if (this.el.classList.contains("open")) return false;
        if (this.animationInProcess) return false;
        this.animationInProcess = true;
        const placement = (window.getComputedStyle(this.el).getPropertyValue("--placement") || "").replace(" ", "");
        const flip = (window.getComputedStyle(this.el).getPropertyValue("--flip") || "true").replace(" ", "");
        const strategy = (window.getComputedStyle(this.el).getPropertyValue("--strategy") || "fixed").replace(" ", "");
        const offset = parseInt((window.getComputedStyle(this.el).getPropertyValue("--offset") || "10").replace(" ", ""));
        const gpuAcceleration = (window.getComputedStyle(this.el).getPropertyValue("--gpu-acceleration") || "true").replace(" ", "");
        if (strategy !== "static") this.el._popper = (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this.el, this.menu, {
            placement: (0, $704e031c65277337$export$1a1f61c9c4dd9df0)[placement] || "bottom-start",
            strategy: strategy,
            modifiers: [
                ...strategy !== "fixed" ? this.absoluteStrategyModifiers() : [],
                {
                    name: "flip",
                    enabled: flip === "true"
                },
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            offset
                        ]
                    }
                },
                {
                    name: "computeStyles",
                    options: {
                        adaptive: strategy !== "fixed" ? false : true,
                        gpuAcceleration: gpuAcceleration === "true" ? true : false
                    }
                }
            ]
        });
        this.menu.style.margin = null;
        this.menu.classList.remove("hidden");
        this.menu.classList.add("block");
        setTimeout(()=>{
            if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "true";
            this.el.classList.add("open");
            this.animationInProcess = false;
        });
        this.fireEvent("open", this.el);
        (0, $htam9.dispatch)("open.hs.dropdown", this.el, this.el);
    }
    close(isAnimated = true) {
        if (this.animationInProcess || !this.el.classList.contains("open")) return false;
        const clearAfterClose = ()=>{
            this.menu.style.margin = null;
            if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "false";
            this.el.classList.remove("open");
            this.fireEvent("close", this.el);
            (0, $htam9.dispatch)("close.hs.dropdown", this.el, this.el);
        };
        this.animationInProcess = true;
        if (isAnimated) {
            const el = this.el.querySelector("[data-hs-dropdown-transition]") || this.menu;
            (0, $htam9.afterTransition)(el, ()=>this.destroyPopper());
        } else this.destroyPopper();
        clearAfterClose();
    }
    forceClearState() {
        this.destroyPopper();
        this.menu.style.margin = null;
        this.el.classList.remove("open");
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsDropdownCollection) window.$hsDropdownCollection = [];
        document.querySelectorAll(".hs-dropdown:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsDropdownCollection.find((elC)=>elC?.element?.el === el)) new $3165a178822236d6$var$HSDropdown(el);
        });
        if (window.$hsDropdownCollection) {
            document.addEventListener("keydown", (evt)=>$3165a178822236d6$var$HSDropdown.accessibility(evt));
            window.addEventListener("click", (evt)=>{
                const evtTarget = evt.target;
                $3165a178822236d6$var$HSDropdown.closeCurrentlyOpened(evtTarget);
            });
            let prevWidth = window.innerWidth;
            window.addEventListener("resize", ()=>{
                if (window.innerWidth !== prevWidth) {
                    prevWidth = innerWidth;
                    $3165a178822236d6$var$HSDropdown.closeCurrentlyOpened(null, false);
                }
            });
        }
    }
    static open(target) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.menu.classList.contains("hidden")) elInCollection.element.open();
    }
    static close(target) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.menu.classList.contains("hidden")) elInCollection.element.close();
    }
    // Accessibility methods
    static accessibility(evt) {
        this.history = (0, $htam9.menuSearchHistory);
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target && ((0, $704e031c65277337$export$ab14482922808af8).includes(evt.code) || evt.code.length === 4 && evt.code[evt.code.length - 1].match(/^[A-Z]*$/)) && !evt.metaKey && !target.element.menu.querySelector("input:focus") && !target.element.menu.querySelector("textarea:focus")) switch(evt.code){
            case "Escape":
                if (!target.element.menu.querySelector(".hs-select.active")) {
                    evt.preventDefault();
                    this.onEscape(evt);
                }
                break;
            case "Enter":
                if (!target.element.menu.querySelector(".hs-select button:focus") && !target.element.menu.querySelector(".hs-collapse-toggle:focus")) this.onEnter(evt);
                break;
            case "ArrowUp":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onArrow();
                break;
            case "ArrowDown":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onArrow(false);
                break;
            case "Home":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onStartEnd();
                break;
            case "End":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onStartEnd(false);
                break;
            default:
                evt.preventDefault();
                this.onFirstLetter(evt.key);
                break;
        }
    }
    static onEscape(evt) {
        const dropdown = evt.target.closest(".hs-dropdown.open");
        if (window.$hsDropdownCollection.find((el)=>el.element.el === dropdown)) {
            const target = window.$hsDropdownCollection.find((el)=>el.element.el === dropdown);
            if (target) {
                target.element.close();
                target.element.toggle.focus();
            }
        } else this.closeCurrentlyOpened();
    }
    static onEnter(evt) {
        const dropdown = evt.target.parentElement;
        if (window.$hsDropdownCollection.find((el)=>el.element.el === dropdown)) {
            evt.preventDefault();
            const target = window.$hsDropdownCollection.find((el)=>el.element.el === dropdown);
            if (target) target.element.open();
        }
    }
    static onArrow(isArrowUp = true) {
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target) {
            const menu = target.element.menu;
            if (!menu) return false;
            const preparedLinks = isArrowUp ? Array.from(menu.querySelectorAll("a:not([hidden]), .hs-dropdown > button:not([hidden])")).reverse() : Array.from(menu.querySelectorAll("a:not([hidden]), .hs-dropdown > button:not([hidden])"));
            const links = preparedLinks.filter((el)=>!el.classList.contains("disabled"));
            const current = menu.querySelector("a:focus, button:focus");
            let currentInd = links.findIndex((el)=>el === current);
            if (currentInd + 1 < links.length) currentInd++;
            links[currentInd].focus();
        }
    }
    static onStartEnd(isStart = true) {
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target) {
            const menu = target.element.menu;
            if (!menu) return false;
            const preparedLinks = isStart ? Array.from(menu.querySelectorAll("a")) : Array.from(menu.querySelectorAll("a")).reverse();
            const links = preparedLinks.filter((el)=>!el.classList.contains("disabled"));
            if (links.length) links[0].focus();
        }
    }
    static onFirstLetter(code) {
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target) {
            const menu = target.element.menu;
            if (!menu) return false;
            const links = Array.from(menu.querySelectorAll("a"));
            const getCurrentInd = ()=>links.findIndex((el, i)=>el.innerText.toLowerCase().charAt(0) === code.toLowerCase() && this.history.existsInHistory(i));
            let currentInd = getCurrentInd();
            if (currentInd === -1) {
                this.history.clearHistory();
                currentInd = getCurrentInd();
            }
            if (currentInd !== -1) {
                links[currentInd].focus();
                this.history.addHistory(currentInd);
            }
        }
    }
    static closeCurrentlyOpened(evtTarget = null, isAnimated = true) {
        const parent = evtTarget && evtTarget.closest(".hs-dropdown") && evtTarget.closest(".hs-dropdown").parentElement.closest(".hs-dropdown") ? evtTarget.closest(".hs-dropdown").parentElement.closest(".hs-dropdown") : null;
        let currentlyOpened = parent ? window.$hsDropdownCollection.filter((el)=>el.element.el.classList.contains("open") && el.element.menu.closest(".hs-dropdown").parentElement.closest(".hs-dropdown") === parent) : window.$hsDropdownCollection.filter((el)=>el.element.el.classList.contains("open"));
        if (evtTarget && evtTarget.closest(".hs-dropdown") && (0, $htam9.getClassPropertyAlt)(evtTarget.closest(".hs-dropdown"), "--auto-close") === "inside") currentlyOpened = currentlyOpened.filter((el)=>el.element.el !== evtTarget.closest(".hs-dropdown"));
        if (currentlyOpened) currentlyOpened.forEach((el)=>{
            if (el.element.closeMode === "false" || el.element.closeMode === "outside") return false;
            el.element.close(isAnimated);
        });
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $3165a178822236d6$var$HSDropdown.autoInit();
// Uncomment for debug
// console.log('Dropdown collection:', window.$hsDropdownCollection);
});
window.addEventListener("resize", ()=>{
    if (!window.$hsDropdownCollection) window.$hsDropdownCollection = [];
    window.$hsDropdownCollection.forEach((el)=>el.element.resizeHandler());
});
if (typeof window !== "undefined") window.HSDropdown = $3165a178822236d6$var$HSDropdown;
var $3165a178822236d6$export$2e2bcd8739ae039 = $3165a178822236d6$var$HSDropdown;


/*
 * HSInputNumber
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $278cd9d7635fbaf2$var$HSInputNumber extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        this.input = this.el.querySelector("[data-hs-input-number-input]") || null;
        this.increment = this.el.querySelector("[data-hs-input-number-increment]") || null;
        this.decrement = this.el.querySelector("[data-hs-input-number-decrement]") || null;
        if (this.input) this.checkIsNumberAndConvert();
        const data = this.el.dataset.hsInputNumber;
        const dataOptions = data ? JSON.parse(data) : {
            step: 1
        };
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.minInputValue = "min" in concatOptions ? concatOptions.min : 0;
        this.maxInputValue = "max" in concatOptions ? concatOptions.max : null;
        this.step = "step" in concatOptions && concatOptions.step > 0 ? concatOptions.step : 1;
        this.init();
    }
    init() {
        this.createCollection(window.$hsInputNumberCollection, this);
        if (this.input && this.increment) this.build();
    }
    checkIsNumberAndConvert() {
        const value = this.input.value.trim();
        const cleanedValue = this.cleanAndExtractNumber(value);
        if (cleanedValue !== null) {
            this.inputValue = cleanedValue;
            this.input.value = cleanedValue.toString();
        } else {
            this.inputValue = 0;
            this.input.value = "0";
        }
    }
    cleanAndExtractNumber(value) {
        const cleanedArray = [];
        let decimalFound = false;
        value.split("").forEach((char)=>{
            if (char >= "0" && char <= "9") cleanedArray.push(char);
            else if (char === "." && !decimalFound) {
                cleanedArray.push(char);
                decimalFound = true;
            }
        });
        const cleanedValue = cleanedArray.join("");
        const number = parseFloat(cleanedValue);
        return isNaN(number) ? null : number;
    }
    build() {
        if (this.input) this.buildInput();
        if (this.increment) this.buildIncrement();
        if (this.decrement) this.buildDecrement();
        if (this.inputValue <= 0 && this.minInputValue === 0) {
            this.inputValue = 0;
            this.input.value = "0";
        }
        if (this.inputValue <= 0 || this.minInputValue < 0) this.changeValue();
        if (this.input.hasAttribute("disabled")) this.disableButtons();
    }
    buildInput() {
        this.input.addEventListener("input", ()=>this.changeValue());
    }
    buildIncrement() {
        this.increment.addEventListener("click", ()=>{
            this.changeValue("increment");
        });
    }
    buildDecrement() {
        this.decrement.addEventListener("click", ()=>{
            this.changeValue("decrement");
        });
    }
    changeValue(event = "none") {
        const payload = {
            inputValue: this.inputValue
        };
        const minInputValue = this.minInputValue ?? Number.MIN_SAFE_INTEGER;
        const maxInputValue = this.maxInputValue ?? Number.MAX_SAFE_INTEGER;
        this.inputValue = isNaN(this.inputValue) ? 0 : this.inputValue;
        switch(event){
            case "increment":
                const incrementedResult = this.inputValue + this.step;
                this.inputValue = incrementedResult >= minInputValue && incrementedResult <= maxInputValue ? incrementedResult : maxInputValue;
                this.input.value = this.inputValue.toString();
                break;
            case "decrement":
                const decrementedResult = this.inputValue - this.step;
                this.inputValue = decrementedResult >= minInputValue && decrementedResult <= maxInputValue ? decrementedResult : minInputValue;
                this.input.value = this.inputValue.toString();
                break;
            default:
                const defaultResult = isNaN(parseInt(this.input.value)) ? 0 : parseInt(this.input.value);
                this.inputValue = defaultResult >= maxInputValue ? maxInputValue : defaultResult <= minInputValue ? minInputValue : defaultResult;
                if (this.inputValue <= minInputValue) this.input.value = this.inputValue.toString();
                break;
        }
        payload.inputValue = this.inputValue;
        if (this.inputValue === minInputValue) {
            this.el.classList.add("disabled");
            if (this.decrement) this.disableButtons("decrement");
        } else {
            this.el.classList.remove("disabled");
            if (this.decrement) this.enableButtons("decrement");
        }
        if (this.inputValue === maxInputValue) {
            this.el.classList.add("disabled");
            if (this.increment) this.disableButtons("increment");
        } else {
            this.el.classList.remove("disabled");
            if (this.increment) this.enableButtons("increment");
        }
        this.fireEvent("change", payload);
        (0, $htam9.dispatch)("change.hs.inputNumber", this.el, payload);
    }
    disableButtons(mode = "all") {
        if (mode === "all") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.setAttribute("disabled", "disabled");
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.setAttribute("disabled", "disabled");
        } else if (mode === "increment") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.setAttribute("disabled", "disabled");
        } else if (mode === "decrement") {
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.setAttribute("disabled", "disabled");
        }
    }
    enableButtons(mode = "all") {
        if (mode === "all") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.removeAttribute("disabled");
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.removeAttribute("disabled");
        } else if (mode === "increment") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.removeAttribute("disabled");
        } else if (mode === "decrement") {
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.removeAttribute("disabled");
        }
    }
    // Global method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsInputNumberCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsInputNumberCollection) window.$hsInputNumberCollection = [];
        document.querySelectorAll("[data-hs-input-number]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsInputNumberCollection.find((elC)=>elC?.element?.el === el)) new $278cd9d7635fbaf2$var$HSInputNumber(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $278cd9d7635fbaf2$var$HSInputNumber.autoInit();
// Uncomment for debug
// console.log('Input number collection:', window.$hsInputNumberCollection);
});
if (typeof window !== "undefined") window.HSInputNumber = $278cd9d7635fbaf2$var$HSInputNumber;
var $278cd9d7635fbaf2$export$2e2bcd8739ae039 = $278cd9d7635fbaf2$var$HSInputNumber;


/*
 * HSOverlay
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");


var $kYnwU = parcelRequire("kYnwU");
class $8f2f97605797e558$var$HSOverlay extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        const data = el.getAttribute("data-hs-overlay-options");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.hiddenClass = concatOptions?.hiddenClass || "hidden";
        this.emulateScrollbarSpace = concatOptions?.emulateScrollbarSpace || false;
        this.isClosePrev = concatOptions?.isClosePrev ?? true;
        this.backdropClasses = concatOptions?.backdropClasses ?? "hs-overlay-backdrop transition duration fixed inset-0 bg-gray-900 bg-opacity-50 dark:bg-opacity-80 dark:bg-neutral-900";
        this.backdropExtraClasses = concatOptions?.backdropExtraClasses ?? "";
        this.moveOverlayToBody = concatOptions?.moveOverlayToBody || null;
        this.openNextOverlay = false;
        this.autoHide = null;
        this.overlayId = this.el.getAttribute("data-hs-overlay");
        this.overlay = document.querySelector(this.overlayId);
        this.initContainer = this.overlay?.parentElement || null;
        if (this.overlay) {
            this.isCloseWhenClickInside = (0, $htam9.stringToBoolean)((0, $htam9.getClassProperty)(this.overlay, "--close-when-click-inside", "false") || "false");
            this.isTabAccessibilityLimited = (0, $htam9.stringToBoolean)((0, $htam9.getClassProperty)(this.overlay, "--tab-accessibility-limited", "true") || "true");
            this.isLayoutAffect = (0, $htam9.stringToBoolean)((0, $htam9.getClassProperty)(this.overlay, "--is-layout-affect", "false") || "false");
            this.hasAutofocus = (0, $htam9.stringToBoolean)((0, $htam9.getClassProperty)(this.overlay, "--has-autofocus", "true") || "true");
            this.hasAbilityToCloseOnBackdropClick = (0, $htam9.stringToBoolean)(this.overlay.getAttribute("data-hs-overlay-keyboard") || "true");
            const autoCloseBreakpoint = (0, $htam9.getClassProperty)(this.overlay, "--auto-close");
            this.autoClose = !isNaN(+autoCloseBreakpoint) && isFinite(+autoCloseBreakpoint) ? +autoCloseBreakpoint : (0, $704e031c65277337$export$426e07cd0772984d)[autoCloseBreakpoint] || null;
            const openedBreakpoint = (0, $htam9.getClassProperty)(this.overlay, "--opened");
            this.openedBreakpoint = (!isNaN(+openedBreakpoint) && isFinite(+openedBreakpoint) ? +openedBreakpoint : (0, $704e031c65277337$export$426e07cd0772984d)[openedBreakpoint]) || null;
        }
        this.animationTarget = this?.overlay?.querySelector(".hs-overlay-animation-target") || this.overlay;
        if (this.overlay) this.init();
    }
    init() {
        this.createCollection(window.$hsOverlayCollection, this);
        if (this.isLayoutAffect && this.openedBreakpoint) {
            const instance = $8f2f97605797e558$var$HSOverlay.getInstance(this.el, true);
            $8f2f97605797e558$var$HSOverlay.setOpened(this.openedBreakpoint, instance);
        }
        if (this?.el?.ariaExpanded) {
            if (this.overlay.classList.contains("opened")) this.el.ariaExpanded = "true";
            else this.el.ariaExpanded = "false";
        }
        this.el.addEventListener("click", ()=>{
            if (this.overlay.classList.contains("opened")) this.close();
            else this.open();
        });
        this.overlay.addEventListener("click", (evt)=>{
            if (evt.target.id && `#${evt.target.id}` === this.overlayId && this.isCloseWhenClickInside && this.hasAbilityToCloseOnBackdropClick) this.close();
        });
    }
    hideAuto() {
        const time = parseInt((0, $htam9.getClassProperty)(this.overlay, "--auto-hide", "0"));
        if (time) this.autoHide = setTimeout(()=>{
            this.close();
        }, time);
    }
    checkTimer() {
        if (this.autoHide) {
            clearTimeout(this.autoHide);
            this.autoHide = null;
        }
    }
    buildBackdrop() {
        const overlayClasses = this.overlay.classList.value.split(" ");
        const overlayZIndex = parseInt(window.getComputedStyle(this.overlay).getPropertyValue("z-index"));
        const backdropId = this.overlay.getAttribute("data-hs-overlay-backdrop-container") || false;
        let backdrop = document.createElement("div");
        let backdropClasses = `${this.backdropClasses} ${this.backdropExtraClasses}`;
        const closeOnBackdrop = (0, $htam9.getClassProperty)(this.overlay, "--overlay-backdrop", "true") !== "static";
        const disableBackdrop = (0, $htam9.getClassProperty)(this.overlay, "--overlay-backdrop", "true") === "false";
        backdrop.id = `${this.overlay.id}-backdrop`;
        if ("style" in backdrop) backdrop.style.zIndex = `${overlayZIndex - 1}`;
        for (const value of overlayClasses)if (value.startsWith("hs-overlay-backdrop-open:") || value.includes(":hs-overlay-backdrop-open:")) backdropClasses += ` ${value}`;
        if (disableBackdrop) return;
        if (backdropId) {
            backdrop = document.querySelector(backdropId).cloneNode(true);
            backdrop.classList.remove("hidden");
            backdropClasses = `${backdrop.classList.toString()}`;
            backdrop.classList.value = "";
        }
        if (closeOnBackdrop) backdrop.addEventListener("click", ()=>this.close(), true);
        backdrop.setAttribute("data-hs-overlay-backdrop-template", "");
        document.body.appendChild(backdrop);
        setTimeout(()=>{
            backdrop.classList.value = backdropClasses;
        });
    }
    destroyBackdrop() {
        const backdrop = document.querySelector(`#${this.overlay.id}-backdrop`);
        if (!backdrop) return;
        if (this.openNextOverlay) backdrop.style.transitionDuration = `${parseFloat(window.getComputedStyle(backdrop).transitionDuration.replace(/[^\d.-]/g, "")) * 1.8}s`;
        backdrop.classList.add("opacity-0");
        (0, $htam9.afterTransition)(backdrop, ()=>{
            backdrop.remove();
        });
    }
    focusElement() {
        const input = this.overlay.querySelector("[autofocus]");
        if (!input) return false;
        else input.focus();
    }
    getScrollbarSize() {
        let div = document.createElement("div");
        div.style.overflow = "scroll";
        div.style.width = "100px";
        div.style.height = "100px";
        document.body.appendChild(div);
        let scrollbarSize = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
        return scrollbarSize;
    }
    // Public methods
    open() {
        if (!this.overlay) return false;
        const openedOverlays = document.querySelectorAll(".hs-overlay.open");
        const currentlyOpened = window.$hsOverlayCollection.find((el)=>Array.from(openedOverlays).includes(el.element.overlay) && !el.element.isLayoutAffect);
        const toggles = document.querySelectorAll(`[data-hs-overlay="#${this.overlay.id}"]`);
        const disabledScroll = (0, $htam9.getClassProperty)(this.overlay, "--body-scroll", "false") !== "true";
        if (this.isClosePrev && currentlyOpened) {
            this.openNextOverlay = true;
            return currentlyOpened.element.close().then(()=>{
                this.open();
                this.openNextOverlay = false;
            });
        }
        if (disabledScroll) {
            document.body.style.overflow = "hidden";
            if (this.emulateScrollbarSpace) document.body.style.paddingRight = `${this.getScrollbarSize()}px`;
        }
        this.buildBackdrop();
        this.checkTimer();
        this.hideAuto();
        toggles.forEach((toggle)=>{
            if (toggle.ariaExpanded) toggle.ariaExpanded = "true";
        });
        this.overlay.classList.remove(this.hiddenClass);
        this.overlay.setAttribute("aria-overlay", "true");
        this.overlay.setAttribute("tabindex", "-1");
        setTimeout(()=>{
            if (this.overlay.classList.contains("opened")) return false;
            this.overlay.classList.add("open", "opened");
            if (this.isLayoutAffect) document.body.classList.add("hs-overlay-body-open");
            this.fireEvent("open", this.el);
            (0, $htam9.dispatch)("open.hs.overlay", this.el, this.el);
            if (this.hasAutofocus) this.focusElement();
        }, 50);
    }
    close(forceClose = false) {
        if (this.isLayoutAffect) document.body.classList.remove("hs-overlay-body-open");
        const closeFn = (cb)=>{
            if (this.overlay.classList.contains("open")) return false;
            const toggles = document.querySelectorAll(`[data-hs-overlay="#${this.overlay.id}"]`);
            toggles.forEach((toggle)=>{
                if (toggle.ariaExpanded) toggle.ariaExpanded = "false";
            });
            this.overlay.classList.add(this.hiddenClass);
            this.destroyBackdrop();
            this.fireEvent("close", this.el);
            (0, $htam9.dispatch)("close.hs.overlay", this.el, this.el);
            if (!document.querySelector(".hs-overlay.opened")) {
                document.body.style.overflow = "";
                if (this.emulateScrollbarSpace) document.body.style.paddingRight = "";
            }
            cb(this.overlay);
        };
        return new Promise((resolve)=>{
            if (!this.overlay) return false;
            this.overlay.classList.remove("open", "opened");
            this.overlay.removeAttribute("aria-overlay");
            this.overlay.removeAttribute("tabindex");
            if (forceClose) closeFn(resolve);
            else (0, $htam9.afterTransition)(this.animationTarget, ()=>closeFn(resolve));
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsOverlayCollection) window.$hsOverlayCollection = [];
        document.querySelectorAll("[data-hs-overlay]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsOverlayCollection.find((elC)=>elC?.element?.el === el)) new $8f2f97605797e558$var$HSOverlay(el);
        });
        if (window.$hsOverlayCollection) document.addEventListener("keydown", (evt)=>$8f2f97605797e558$var$HSOverlay.accessibility(evt));
    }
    static open(target) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.overlay.classList.contains(elInCollection.element.hiddenClass)) elInCollection.element.open();
    }
    static close(target) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.overlay.classList.contains(elInCollection.element.hiddenClass)) elInCollection.element.close();
    }
    static setOpened(breakpoint, el) {
        if (document.body.clientWidth >= breakpoint) {
            document.body.classList.add("hs-overlay-body-open");
            el.element.overlay.classList.add("opened");
        } else el.element.close(true);
    }
    // Accessibility methods
    static accessibility(evt) {
        const targets = window.$hsOverlayCollection.filter((el)=>el.element.overlay.classList.contains("open"));
        const target = targets[targets.length - 1];
        const focusableElements = target?.element?.overlay?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const notHiddenFocusableElements = [];
        if (focusableElements?.length) focusableElements.forEach((el)=>{
            if (!(0, $htam9.isParentOrElementHidden)(el)) notHiddenFocusableElements.push(el);
        });
        const basicCheck = target && !evt.metaKey;
        if (basicCheck && !target.element.isTabAccessibilityLimited && evt.code === "Tab") return false;
        if (basicCheck && notHiddenFocusableElements.length && evt.code === "Tab") {
            evt.preventDefault();
            this.onTab(target, notHiddenFocusableElements);
        }
        if (basicCheck && evt.code === "Escape") {
            evt.preventDefault();
            this.onEscape(target);
        }
    }
    static onEscape(target) {
        if (target && target.element.hasAbilityToCloseOnBackdropClick) target.element.close();
    }
    static onTab(target, focusableElements) {
        if (!focusableElements.length) return false;
        const focused = target.element.overlay.querySelector(":focus");
        const focusedIndex = Array.from(focusableElements).indexOf(focused);
        if (focusedIndex > -1) {
            const nextIndex = (focusedIndex + 1) % focusableElements.length;
            focusableElements[nextIndex].focus();
        } else focusableElements[0].focus();
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
const $8f2f97605797e558$var$autoCloseResizeFn = ()=>{
    if (!window.$hsOverlayCollection.length || !window.$hsOverlayCollection.find((el)=>el.element.autoClose)) return false;
    const overlays = window.$hsOverlayCollection.filter((el)=>el.element.autoClose);
    overlays.forEach((overlay)=>{
        if (document.body.clientWidth >= overlay.element.autoClose) overlay.element.close(true);
    });
};
const $8f2f97605797e558$var$moveOverlayToBodyResizeFn = ()=>{
    if (!window.$hsOverlayCollection.length || !window.$hsOverlayCollection.find((el)=>el.element.moveOverlayToBody)) return false;
    const overlays = window.$hsOverlayCollection.filter((el)=>el.element.moveOverlayToBody);
    overlays.forEach((overlay)=>{
        const resolution = overlay.element.moveOverlayToBody;
        const initPlace = overlay.element.initContainer;
        const newPlace = document.querySelector("body");
        const target = overlay.element.overlay;
        if (!initPlace && target) return false;
        if (document.body.clientWidth <= resolution && !(0, $htam9.isDirectChild)(newPlace, target)) newPlace.appendChild(target);
        else if (document.body.clientWidth > resolution && !initPlace.contains(target)) initPlace.appendChild(target);
    });
};
const $8f2f97605797e558$var$setOpenedResizeFn = ()=>{
    if (!window.$hsOverlayCollection.length || !window.$hsOverlayCollection.find((el)=>el.element.autoClose)) return false;
    const overlays = window.$hsOverlayCollection.filter((el)=>el.element.autoClose);
    overlays.forEach((overlay)=>{
        if (document.body.clientWidth >= overlay.element.autoClose) overlay.element.close(true);
    });
};
const $8f2f97605797e558$var$setBackdropZIndexResizeFn = ()=>{
    if (!window.$hsOverlayCollection.length || !window.$hsOverlayCollection.find((el)=>el.element.overlay.classList.contains("opened"))) return false;
    const overlays = window.$hsOverlayCollection.filter((el)=>el.element.overlay.classList.contains("opened"));
    overlays.forEach((overlay)=>{
        const overlayZIndex = parseInt(window.getComputedStyle(overlay.element.overlay).getPropertyValue("z-index"));
        const backdrop = document.querySelector(`#${overlay.element.overlay.id}-backdrop`);
        const backdropZIndex = parseInt(window.getComputedStyle(backdrop).getPropertyValue("z-index"));
        if (overlayZIndex === backdropZIndex + 1) return false;
        if ("style" in backdrop) backdrop.style.zIndex = `${overlayZIndex - 1}`;
        document.body.classList.add("hs-overlay-body-open");
    });
};
window.addEventListener("load", ()=>{
    $8f2f97605797e558$var$HSOverlay.autoInit();
    $8f2f97605797e558$var$moveOverlayToBodyResizeFn();
// Uncomment for debug
// console.log('Overlay collection:', window.$hsOverlayCollection);
});
window.addEventListener("resize", ()=>{
    $8f2f97605797e558$var$autoCloseResizeFn();
    $8f2f97605797e558$var$moveOverlayToBodyResizeFn();
    $8f2f97605797e558$var$setOpenedResizeFn();
    $8f2f97605797e558$var$setBackdropZIndexResizeFn();
});
if (typeof window !== "undefined") window.HSOverlay = $8f2f97605797e558$var$HSOverlay;
var $8f2f97605797e558$export$2e2bcd8739ae039 = $8f2f97605797e558$var$HSOverlay;


/*
 * HSPinInput
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $4a788dc9d3bacdfa$var$HSPinInput extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-pin-input");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.items = this.el.querySelectorAll("[data-hs-pin-input-item]");
        this.currentItem = null;
        this.currentValue = new Array(this.items.length).fill("");
        this.placeholders = [];
        this.availableCharsRE = new RegExp(concatOptions?.availableCharsRE || "^[a-zA-Z0-9]+$"); // '^[0-9]+$'
        this.init();
    }
    init() {
        this.createCollection(window.$hsPinInputCollection, this);
        if (this.items.length) this.build();
    }
    build() {
        this.buildInputItems();
    }
    buildInputItems() {
        this.items.forEach((el, index)=>{
            this.placeholders.push(el.getAttribute("placeholder") || "");
            if (el.hasAttribute("autofocus")) this.onFocusIn(index);
            el.addEventListener("input", (evt)=>this.onInput(evt, index));
            el.addEventListener("paste", (evt)=>this.onPaste(evt));
            el.addEventListener("keydown", (evt)=>this.onKeydown(evt, index));
            el.addEventListener("focusin", ()=>this.onFocusIn(index));
            el.addEventListener("focusout", ()=>this.onFocusOut(index));
        });
    }
    checkIfNumber(value) {
        return value.match(this.availableCharsRE);
    }
    autoFillAll(text) {
        Array.from(text).forEach((n, i)=>{
            if (!this?.items[i]) return false;
            this.items[i].value = n;
            this.items[i].dispatchEvent(new Event("input", {
                bubbles: true
            }));
        });
    }
    setCurrentValue() {
        this.currentValue = Array.from(this.items).map((el)=>el.value);
    }
    toggleCompleted() {
        if (!this.currentValue.includes("")) this.el.classList.add("active");
        else this.el.classList.remove("active");
    }
    onInput(evt, index) {
        const originalValue = evt.target.value;
        this.currentItem = evt.target;
        this.currentItem.value = "";
        this.currentItem.value = originalValue[originalValue.length - 1];
        if (!this.checkIfNumber(this.currentItem.value)) {
            this.currentItem.value = this.currentValue[index] || "";
            return false;
        }
        this.setCurrentValue();
        if (this.currentItem.value) {
            if (index < this.items.length - 1) this.items[index + 1].focus();
            if (!this.currentValue.includes("")) {
                const payload = {
                    currentValue: this.currentValue
                };
                this.fireEvent("completed", payload);
                (0, $htam9.dispatch)("completed.hs.pinInput", this.el, payload);
            }
            this.toggleCompleted();
        } else if (index > 0) this.items[index - 1].focus();
    }
    onKeydown(evt, index) {
        if (evt.key === "Backspace" && index > 0) {
            if (this.items[index].value === "") {
                this.items[index - 1].value = "";
                this.items[index - 1].focus();
            } else this.items[index].value = "";
        }
        this.setCurrentValue();
        this.toggleCompleted();
    }
    onFocusIn(index) {
        this.items[index].setAttribute("placeholder", "");
    }
    onFocusOut(index) {
        this.items[index].setAttribute("placeholder", this.placeholders[index]);
    }
    onPaste(evt) {
        evt.preventDefault();
        this.items.forEach((el)=>{
            if (document.activeElement === el) this.autoFillAll(evt.clipboardData.getData("text"));
        });
    }
    // Static method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsPinInputCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsPinInputCollection) window.$hsPinInputCollection = [];
        document.querySelectorAll("[data-hs-pin-input]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsPinInputCollection.find((elC)=>elC?.element?.el === el)) new $4a788dc9d3bacdfa$var$HSPinInput(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $4a788dc9d3bacdfa$var$HSPinInput.autoInit();
// Uncomment for debug
// console.log('PIN input collection:', window.$hsPinInputCollection);
});
if (typeof window !== "undefined") window.HSPinInput = $4a788dc9d3bacdfa$var$HSPinInput;
var $4a788dc9d3bacdfa$export$2e2bcd8739ae039 = $4a788dc9d3bacdfa$var$HSPinInput;


/*
 * HSRemoveElement
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $308f48fd3b91efe3$var$HSRemoveElement extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-remove-element-options");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.removeTargetId = this.el.getAttribute("data-hs-remove-element");
        this.removeTarget = document.querySelector(this.removeTargetId);
        this.removeTargetAnimationClass = concatOptions?.removeTargetAnimationClass || "hs-removing";
        if (this.removeTarget) this.init();
    }
    init() {
        this.createCollection(window.$hsRemoveElementCollection, this);
        this.el.addEventListener("click", ()=>this.remove());
    }
    remove() {
        if (!this.removeTarget) return false;
        this.removeTarget.classList.add(this.removeTargetAnimationClass);
        (0, $htam9.afterTransition)(this.removeTarget, ()=>setTimeout(()=>this.removeTarget.remove()));
    }
    // Static method
    static autoInit() {
        if (!window.$hsRemoveElementCollection) window.$hsRemoveElementCollection = [];
        document.querySelectorAll("[data-hs-remove-element]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsRemoveElementCollection.find((elC)=>elC?.element?.el === el)) new $308f48fd3b91efe3$var$HSRemoveElement(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $308f48fd3b91efe3$var$HSRemoveElement.autoInit();
// Uncomment for debug
// console.log('Remove element collection:', window.$hsRemoveElementCollection);
});
if (typeof window !== "undefined") window.HSRemoveElement = $308f48fd3b91efe3$var$HSRemoveElement;
var $308f48fd3b91efe3$export$2e2bcd8739ae039 = $308f48fd3b91efe3$var$HSRemoveElement;


/*
 * HSScrollspy
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $123fc6210ee090d1$var$HSScrollspy extends (0, $kYnwU.default) {
    constructor(el, options = {}){
        super(el, options);
        this.activeSection = null;
        this.contentId = this.el.getAttribute("data-hs-scrollspy");
        this.content = document.querySelector(this.contentId);
        this.links = this.el.querySelectorAll("[href]");
        this.sections = [];
        this.scrollableId = this.el.getAttribute("data-hs-scrollspy-scrollable-parent");
        this.scrollable = this.scrollableId ? document.querySelector(this.scrollableId) : document;
        this.init();
    }
    init() {
        this.createCollection(window.$hsScrollspyCollection, this);
        this.links.forEach((el)=>{
            this.sections.push(this.scrollable.querySelector(el.getAttribute("href")));
        });
        Array.from(this.sections).forEach((section)=>{
            if (!section.getAttribute("id")) return false;
            this.scrollable.addEventListener("scroll", (evt)=>this.update(evt, section));
        });
        this.links.forEach((el)=>{
            el.addEventListener("click", (evt)=>{
                evt.preventDefault();
                if (el.getAttribute("href") === "javascript:;") return false;
                this.scrollTo(el);
            });
        });
    }
    update(evt, section) {
        const globalOffset = parseInt((0, $htam9.getClassProperty)(this.el, "--scrollspy-offset", "0"));
        const userOffset = parseInt((0, $htam9.getClassProperty)(section, "--scrollspy-offset")) || globalOffset;
        const scrollableParentOffset = evt.target === document ? 0 : parseInt(String(evt.target.getBoundingClientRect().top));
        const topOffset = parseInt(String(section.getBoundingClientRect().top)) - userOffset - scrollableParentOffset;
        const height = section.offsetHeight;
        if (topOffset <= 0 && topOffset + height > 0) {
            if (this.activeSection === section) return false;
            this.links.forEach((el)=>{
                el.classList.remove("active");
            });
            const current = this.el.querySelector(`[href="#${section.getAttribute("id")}"]`);
            if (current) {
                current.classList.add("active");
                const group = current.closest("[data-hs-scrollspy-group]");
                if (group) {
                    const parentLink = group.querySelector("[href]");
                    if (parentLink) parentLink.classList.add("active");
                }
            }
            this.activeSection = section;
        }
    }
    scrollTo(link) {
        const targetId = link.getAttribute("href");
        const target = document.querySelector(targetId);
        const globalOffset = parseInt((0, $htam9.getClassProperty)(this.el, "--scrollspy-offset", "0"));
        const userOffset = parseInt((0, $htam9.getClassProperty)(target, "--scrollspy-offset")) || globalOffset;
        const scrollableParentOffset = this.scrollable === document ? 0 : this.scrollable.offsetTop;
        const topOffset = target.offsetTop - userOffset - scrollableParentOffset;
        const view = this.scrollable === document ? window : this.scrollable;
        const scrollFn = ()=>{
            window.history.replaceState(null, null, link.getAttribute("href"));
            if ("scrollTo" in view) view.scrollTo({
                top: topOffset,
                left: 0,
                behavior: "smooth"
            });
        };
        const beforeScroll = this.fireEvent("beforeScroll", this.el);
        (0, $htam9.dispatch)("beforeScroll.hs.scrollspy", this.el, this.el);
        if (beforeScroll instanceof Promise) beforeScroll.then(()=>scrollFn());
        else scrollFn();
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsScrollspyCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsScrollspyCollection) window.$hsScrollspyCollection = [];
        document.querySelectorAll("[data-hs-scrollspy]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsScrollspyCollection.find((elC)=>elC?.element?.el === el)) new $123fc6210ee090d1$var$HSScrollspy(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $123fc6210ee090d1$var$HSScrollspy.autoInit();
// Uncomment for debug
// console.log('Scrollspy collection:', window.$hsScrollspyCollection);
});
if (typeof window !== "undefined") window.HSScrollspy = $123fc6210ee090d1$var$HSScrollspy;
var $123fc6210ee090d1$export$2e2bcd8739ae039 = $123fc6210ee090d1$var$HSScrollspy;


/*
 * HSSelect
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");

class $45555ee5ed0eeb66$var$HSSelect extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        this.optionId = 0;
        const data = el.getAttribute("data-hs-select");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        const defaultToggleSeparators = {
            items: ", ",
            betweenItemsAndCounter: "and"
        };
        this.value = concatOptions?.value || this.el.value || null;
        this.placeholder = concatOptions?.placeholder || "Select...";
        this.hasSearch = concatOptions?.hasSearch || false;
        this.preventSearchFocus = concatOptions?.preventSearchFocus || false;
        this.mode = concatOptions?.mode || "default";
        this.viewport = typeof concatOptions?.viewport !== "undefined" ? document.querySelector(concatOptions?.viewport) : null;
        this.isOpened = Boolean(concatOptions?.isOpened) || false;
        this.isMultiple = this.el.hasAttribute("multiple") || false;
        this.isDisabled = this.el.hasAttribute("disabled") || false;
        this.selectedItems = [];
        this.apiUrl = concatOptions?.apiUrl || null;
        this.apiQuery = concatOptions?.apiQuery || null;
        this.apiOptions = concatOptions?.apiOptions || null;
        this.apiSearchQueryKey = concatOptions?.apiSearchQueryKey || null;
        this.apiDataPart = concatOptions?.apiDataPart || null;
        this.apiFieldsMap = concatOptions?.apiFieldsMap || null;
        this.apiIconTag = concatOptions?.apiIconTag || null;
        this.wrapperClasses = concatOptions?.wrapperClasses || null;
        this.toggleTag = concatOptions?.toggleTag || null;
        this.toggleClasses = concatOptions?.toggleClasses || null;
        this.toggleSeparators = defaultToggleSeparators;
        this.toggleCountText = concatOptions?.toggleCountText || null;
        this.toggleCountTextMinItems = concatOptions?.toggleCountTextMinItems || 1;
        this.toggleCountTextMode = concatOptions?.toggleCountTextMode || "countAfterLimit";
        this.tagsItemTemplate = concatOptions?.tagsItemTemplate || null;
        this.tagsItemClasses = concatOptions?.tagsItemClasses || null;
        this.tagsInputId = concatOptions?.tagsInputId || null;
        this.tagsInputClasses = concatOptions?.tagsInputClasses || null;
        this.dropdownTag = concatOptions?.dropdownTag || null;
        this.dropdownClasses = concatOptions?.dropdownClasses || null;
        this.dropdownDirectionClasses = concatOptions?.dropdownDirectionClasses || null;
        this.dropdownSpace = concatOptions?.dropdownSpace || 10;
        this.dropdownPlacement = concatOptions?.dropdownPlacement || null;
        this.dropdownScope = concatOptions?.dropdownScope || "parent";
        this.searchTemplate = concatOptions?.searchTemplate || null;
        this.searchWrapperTemplate = concatOptions?.searchWrapperTemplate || null;
        this.searchWrapperClasses = concatOptions?.searchWrapperClasses || "bg-white p-2 sticky top-0";
        this.searchId = concatOptions?.searchId || null;
        this.searchLimit = concatOptions?.searchLimit || Infinity;
        this.isSearchDirectMatch = typeof concatOptions?.isSearchDirectMatch !== "undefined" ? concatOptions?.isSearchDirectMatch : true;
        this.searchClasses = concatOptions?.searchClasses || "block w-[calc(100%-2rem)] text-sm border-gray-200 rounded-md focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 py-2 px-3 my-2 mx-4";
        this.searchPlaceholder = concatOptions?.searchPlaceholder || "Search...";
        this.searchNoResultTemplate = concatOptions?.searchNoResultTemplate || "<span></span>";
        this.searchNoResultText = concatOptions?.searchNoResultText || "No results found";
        this.searchNoResultClasses = concatOptions?.searchNoResultClasses || "px-4 text-sm text-gray-800 dark:text-neutral-200";
        this.optionTemplate = concatOptions?.optionTemplate || null;
        this.optionTag = concatOptions?.optionTag || null;
        this.optionClasses = concatOptions?.optionClasses || null;
        this.extraMarkup = concatOptions?.extraMarkup || null;
        this.descriptionClasses = concatOptions?.descriptionClasses || null;
        this.iconClasses = concatOptions?.iconClasses || null;
        this.isAddTagOnEnter = concatOptions?.isAddTagOnEnter ?? true;
        this.animationInProcess = false;
        this.selectOptions = [];
        this.remoteOptions = [];
        this.tagsInputHelper = null;
        this.init();
    }
    setValue(val) {
        this.value = val;
        this.clearSelections();
        if (Array.isArray(val)) {
            this.toggleTextWrapper.innerHTML = this.value.length ? this.stringFromValue() : this.placeholder;
            this.unselectMultipleItems();
            this.selectMultipleItems();
        } else {
            this.setToggleTitle();
            if (this.toggle.querySelector("[data-icon]")) this.setToggleIcon();
            if (this.toggle.querySelector("[data-title]")) this.setToggleTitle();
            this.selectSingleItem();
        }
    }
    init() {
        this.createCollection(window.$hsSelectCollection, this);
        this.build();
    }
    build() {
        this.el.style.display = "none";
        if (this.el.children) Array.from(this.el.children).filter((el)=>el.value && el.value !== "").forEach((el)=>{
            const data = el.getAttribute("data-hs-select-option");
            this.selectOptions = [
                ...this.selectOptions,
                {
                    title: el.textContent,
                    val: el.value,
                    disabled: el.disabled,
                    options: data !== "undefined" ? JSON.parse(data) : null
                }
            ];
        });
        if (this.isMultiple) {
            const selectedOptions = Array.from(this.el.children).filter((el)=>el.selected);
            if (selectedOptions) {
                const values = [];
                selectedOptions.forEach((el)=>{
                    values.push(el.value);
                });
                this.value = values;
            }
        }
        this.buildWrapper();
        if (this.mode === "tags") this.buildTags();
        else this.buildToggle();
        this.buildDropdown();
        if (this.extraMarkup) this.buildExtraMarkup();
    }
    buildWrapper() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("hs-select", "relative");
        if (this.mode === "tags") this.wrapper.addEventListener("click", (evt)=>{
            if (!evt.target.closest("[data-hs-select-dropdown]") && !evt.target.closest("[data-tag-value]")) this.tagsInput.focus();
        });
        if (this.wrapperClasses) (0, $htam9.classToClassList)(this.wrapperClasses, this.wrapper);
        this.el.before(this.wrapper);
        this.wrapper.append(this.el);
    }
    buildExtraMarkup() {
        const appendMarkup = (markup)=>{
            const el = (0, $htam9.htmlToElement)(markup);
            this.wrapper.append(el);
            return el;
        };
        const clickHandle = (el)=>{
            if (!el.classList.contains("--prevent-click")) el.addEventListener("click", (evt)=>{
                evt.stopPropagation();
                this.toggleFn();
            });
        };
        if (Array.isArray(this.extraMarkup)) this.extraMarkup.forEach((el)=>{
            const newEl = appendMarkup(el);
            clickHandle(newEl);
        });
        else {
            const newEl = appendMarkup(this.extraMarkup);
            clickHandle(newEl);
        }
    }
    buildToggle() {
        let icon, title;
        this.toggleTextWrapper = document.createElement("span");
        this.toggleTextWrapper.classList.add("truncate");
        this.toggle = (0, $htam9.htmlToElement)(this.toggleTag || "<div></div>");
        icon = this.toggle.querySelector("[data-icon]");
        title = this.toggle.querySelector("[data-title]");
        if (!this.isMultiple && icon) this.setToggleIcon();
        if (!this.isMultiple && title) this.setToggleTitle();
        if (this.isMultiple) this.toggleTextWrapper.innerHTML = this.value.length ? this.stringFromValue() : this.placeholder;
        else this.toggleTextWrapper.innerHTML = this.getItemByValue(this.value)?.title || this.placeholder;
        if (!title) this.toggle.append(this.toggleTextWrapper);
        if (this.toggleClasses) (0, $htam9.classToClassList)(this.toggleClasses, this.toggle);
        if (this.isDisabled) this.toggle.classList.add("disabled");
        if (this.wrapper) this.wrapper.append(this.toggle);
        if (this.toggle?.ariaExpanded) {
            if (this.isOpened) this.toggle.ariaExpanded = "true";
            else this.toggle.ariaExpanded = "false";
        }
        this.toggle.addEventListener("click", ()=>{
            if (this.isDisabled) return false;
            this.toggleFn();
        });
    }
    setToggleIcon() {
        const item = this.getItemByValue(this.value);
        const icon = this.toggle.querySelector("[data-icon]");
        icon.innerHTML = "";
        if (icon) {
            const img = (0, $htam9.htmlToElement)(this.apiUrl && this.apiIconTag ? this.apiIconTag || "" : item?.options?.icon || "");
            if (this.value && this.apiUrl && this.apiIconTag && item[this.apiFieldsMap.icon]) img.src = item[this.apiFieldsMap.icon] || "";
            icon.append(img);
            if (!img || !img?.src) icon.classList.add("hidden");
            else icon.classList.remove("hidden");
        }
    }
    setToggleTitle() {
        const title = this.toggle.querySelector("[data-title]");
        title.classList.add("truncate");
        title.innerHTML = "";
        if (title) {
            const titleText = this.getItemByValue(this.value)?.title || this.placeholder;
            title.innerHTML = titleText;
            this.toggle.append(title);
        }
    }
    buildTags() {
        if (this.isDisabled) this.wrapper.classList.add("disabled");
        this.buildTagsInput();
        this.setTagsItems();
    }
    reassignTagsInputPlaceholder(placeholder) {
        this.tagsInput.placeholder = placeholder;
        this.tagsInputHelper.innerHTML = placeholder;
        this.calculateInputWidth();
    }
    buildTagsItem(val) {
        const item = this.getItemByValue(val);
        let template, title, remove, icon;
        const newItem = document.createElement("div");
        newItem.setAttribute("data-tag-value", val);
        if (this.tagsItemClasses) (0, $htam9.classToClassList)(this.tagsItemClasses, newItem);
        if (this.tagsItemTemplate) {
            template = (0, $htam9.htmlToElement)(this.tagsItemTemplate);
            newItem.append(template);
        }
        // Icon
        if (item?.options?.icon || this.apiIconTag) {
            const img = (0, $htam9.htmlToElement)(this.apiUrl && this.apiIconTag ? this.apiIconTag : item?.options?.icon);
            if (this.apiUrl && this.apiIconTag && item[this.apiFieldsMap.icon]) img.src = item[this.apiFieldsMap.icon] || "";
            icon = template ? template.querySelector("[data-icon]") : document.createElement("span");
            icon.append(img);
            if (!template) newItem.append(icon);
        }
        if (template && template.querySelector("[data-icon]") && !item?.options?.icon && !this.apiUrl && !this.apiIconTag && !item[this.apiFieldsMap?.icon]) template.querySelector("[data-icon]").classList.add("hidden");
        // Title
        title = template ? template.querySelector("[data-title]") : document.createElement("span");
        title.textContent = item.title || "";
        if (!template) newItem.append(title);
        // Remove
        if (template) remove = template.querySelector("[data-remove]");
        else {
            remove = document.createElement("span");
            remove.textContent = "X";
            newItem.append(remove);
        }
        remove.addEventListener("click", ()=>{
            this.value = this.value.filter((el)=>el !== val);
            this.selectedItems = this.selectedItems.filter((el)=>el !== val);
            if (!this.value.length) this.reassignTagsInputPlaceholder(this.placeholder);
            this.unselectMultipleItems();
            this.selectMultipleItems();
            newItem.remove();
            this.fireEvent("change", this.value);
            (0, $htam9.dispatch)("change.hs.select", this.el, this.value);
        });
        this.wrapper.append(newItem);
    }
    getItemByValue(val) {
        const value = this.apiUrl ? this.remoteOptions.find((el)=>el[this.apiFieldsMap.title] === val) : this.selectOptions.find((el)=>el.val === val);
        return value;
    }
    setTagsItems() {
        if (this.value) this.value.forEach((val)=>{
            if (!this.selectedItems.includes(val)) this.buildTagsItem(val);
            this.selectedItems = !this.selectedItems.includes(val) ? [
                ...this.selectedItems,
                val
            ] : this.selectedItems;
        });
    }
    buildTagsInput() {
        this.tagsInput = document.createElement("input");
        if (this.tagsInputId) this.tagsInput.id = this.tagsInputId;
        if (this.tagsInputClasses) (0, $htam9.classToClassList)(this.tagsInputClasses, this.tagsInput);
        this.tagsInput.addEventListener("focus", ()=>{
            if (!this.isOpened) this.open();
        });
        this.tagsInput.addEventListener("input", ()=>this.calculateInputWidth());
        this.tagsInput.addEventListener("input", (0, $htam9.debounce)((evt)=>this.searchOptions(evt.target.value)));
        this.tagsInput.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && this.isAddTagOnEnter) {
                const val = evt.target.value;
                if (this.selectOptions.find((el)=>el.val === val)) return false;
                this.addSelectOption(val, val);
                this.buildOption(val, val);
                this.dropdown.querySelector(`[data-value="${val}"]`).click();
                this.resetTagsInputField();
            // this.close();
            }
        });
        this.wrapper.append(this.tagsInput);
        setTimeout(()=>{
            this.adjustInputWidth();
            this.reassignTagsInputPlaceholder(this.value.length ? "" : this.placeholder);
        });
    }
    buildDropdown() {
        this.dropdown = (0, $htam9.htmlToElement)(this.dropdownTag || "<div></div>");
        this.dropdown.setAttribute("data-hs-select-dropdown", "");
        if (this.dropdownScope === "parent") this.dropdown.classList.add("absolute", "top-full");
        this.dropdown.role = "listbox";
        this.dropdown.tabIndex = -1;
        this.dropdown.ariaOrientation = "vertical";
        if (!this.isOpened) this.dropdown.classList.add("hidden");
        if (this.dropdownClasses) (0, $htam9.classToClassList)(this.dropdownClasses, this.dropdown);
        if (this.wrapper) this.wrapper.append(this.dropdown);
        if (this.dropdown && this.hasSearch) this.buildSearch();
        if (this.selectOptions) this.selectOptions.forEach((props, i)=>this.buildOption(props.title, props.val, props.disabled, props.selected, props.options, `${i}`));
        if (this.apiUrl) this.optionsFromRemoteData();
        if (this.dropdownScope === "window") this.buildPopper();
    }
    buildPopper() {
        if (typeof Popper !== "undefined" && Popper.createPopper) {
            document.body.appendChild(this.dropdown);
            this.popperInstance = Popper.createPopper(this.mode === "tags" ? this.wrapper : this.toggle, this.dropdown, {
                placement: (0, $704e031c65277337$export$1a1f61c9c4dd9df0)[this.dropdownPlacement] || "bottom",
                strategy: "fixed",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [
                                0,
                                5
                            ]
                        }
                    }
                ]
            });
        }
    }
    updateDropdownWidth() {
        const toggle = this.mode === "tags" ? this.wrapper : this.toggle;
        this.dropdown.style.width = `${toggle.clientWidth}px`;
    }
    buildSearch() {
        let input;
        this.searchWrapper = (0, $htam9.htmlToElement)(this.searchWrapperTemplate || "<div></div>");
        if (this.searchWrapperClasses) (0, $htam9.classToClassList)(this.searchWrapperClasses, this.searchWrapper);
        input = this.searchWrapper.querySelector("[data-input]");
        const search = (0, $htam9.htmlToElement)(this.searchTemplate || '<input type="text" />');
        this.search = search.tagName === "INPUT" ? search : search.querySelector(":scope input");
        this.search.placeholder = this.searchPlaceholder;
        if (this.searchClasses) (0, $htam9.classToClassList)(this.searchClasses, this.search);
        if (this.searchId) this.search.id = this.searchId;
        this.search.addEventListener("input", (0, $htam9.debounce)((evt)=>{
            if (this.apiUrl) this.remoteSearch(evt.target.value);
            else this.searchOptions(evt.target.value);
        }));
        if (input) input.append(search);
        else this.searchWrapper.append(search);
        this.dropdown.append(this.searchWrapper);
    }
    buildOption(title, val, disabled = false, selected = false, options, index = "1", id) {
        let template = null;
        let titleWrapper = null;
        let iconWrapper = null;
        let descriptionWrapper = null;
        const option = (0, $htam9.htmlToElement)(this.optionTag || "<div></div>");
        option.setAttribute("data-value", val);
        option.setAttribute("data-title-value", title);
        option.setAttribute("tabIndex", index);
        option.classList.add("cursor-pointer");
        option.setAttribute("data-id", id || `${this.optionId}`);
        if (!id) this.optionId++;
        if (disabled) option.classList.add("disabled");
        if (selected) {
            if (this.isMultiple) this.value = [
                ...this.value,
                val
            ];
            else this.value = val;
        }
        if (this.optionTemplate) {
            template = (0, $htam9.htmlToElement)(this.optionTemplate);
            option.append(template);
        }
        if (template) {
            titleWrapper = template.querySelector("[data-title]");
            titleWrapper.textContent = title || "";
        } else option.textContent = title || "";
        if (options) {
            if (options.icon) {
                const img = (0, $htam9.htmlToElement)(this.apiIconTag ?? options.icon);
                img.classList.add("max-w-full");
                if (this.apiUrl) {
                    img.setAttribute("alt", title);
                    img.setAttribute("src", options.icon);
                }
                if (template) {
                    iconWrapper = template.querySelector("[data-icon]");
                    iconWrapper.append(img);
                } else {
                    const icon = (0, $htam9.htmlToElement)("<div></div>");
                    if (this.iconClasses) (0, $htam9.classToClassList)(this.iconClasses, icon);
                    icon.append(img);
                    option.append(icon);
                }
            }
            if (options.description) {
                if (template) {
                    descriptionWrapper = template.querySelector("[data-description]");
                    if (descriptionWrapper) descriptionWrapper.append(options.description);
                } else {
                    const description = (0, $htam9.htmlToElement)("<div></div>");
                    description.textContent = options.description;
                    if (this.descriptionClasses) (0, $htam9.classToClassList)(this.descriptionClasses, description);
                    option.append(description);
                }
            }
        }
        if (template && template.querySelector("[data-icon]") && !options && !options?.icon) template.querySelector("[data-icon]").classList.add("hidden");
        if (this.value && (this.isMultiple ? this.value.includes(val) : this.value === val)) option.classList.add("selected");
        if (!disabled) option.addEventListener("click", ()=>this.onSelectOption(val));
        if (this.optionClasses) (0, $htam9.classToClassList)(this.optionClasses, option);
        if (this.dropdown) this.dropdown.append(option);
        if (selected) this.setNewValue();
    }
    buildOptionFromRemoteData(title, val, disabled = false, selected = false, index = "1", id, options) {
        if (index) this.buildOption(title, val, disabled, selected, options, index, id);
        else alert("ID parameter is required for generating remote options! Please check your API endpoint have it.");
    }
    buildOptionsFromRemoteData(data) {
        data.forEach((el, i)=>{
            let id = null;
            let title = "";
            const options = {
                id: "",
                title: "",
                icon: null,
                description: null,
                rest: {}
            };
            Object.keys(el).forEach((key)=>{
                if (el[this.apiFieldsMap.id]) id = el[this.apiFieldsMap.id];
                if (el[this.apiFieldsMap.title]) title = el[this.apiFieldsMap.title];
                if (el[this.apiFieldsMap.icon]) options.icon = el[this.apiFieldsMap.icon];
                if (el[this.apiFieldsMap?.description]) options.description = el[this.apiFieldsMap.description];
                options.rest[key] = el[key];
            });
            this.buildOriginalOption(title, title, id, false, false, options);
            this.buildOptionFromRemoteData(title, title, false, false, `${i}`, id, options);
        });
        this.sortElements(this.el, "option");
        this.sortElements(this.dropdown, "[data-value]");
    }
    async optionsFromRemoteData(val = "") {
        const res = await this.apiRequest(val);
        this.remoteOptions = res;
        if (res.length) this.buildOptionsFromRemoteData(this.remoteOptions);
        else console.log("There is no data were responded!");
    }
    async apiRequest(val = "") {
        try {
            let url = this.apiUrl;
            const search = this.apiSearchQueryKey ? `${this.apiSearchQueryKey}=${val.toLowerCase()}` : null;
            const query = `${this.apiQuery}`;
            const options = this.apiOptions || {};
            if (search) url += `?${search}`;
            if (this.apiQuery) url += `${search ? "&" : "?"}${query}`;
            const req = await fetch(url, options);
            const res = await req.json();
            return this.apiDataPart ? res[this.apiDataPart] : res;
        } catch (err) {
            console.error(err);
        }
    }
    sortElements(container, selector) {
        const items = Array.from(container.querySelectorAll(selector));
        items.sort((a, b)=>{
            const isASelected = a.classList.contains("selected") || a.hasAttribute("selected");
            const isBSelected = b.classList.contains("selected") || b.hasAttribute("selected");
            if (isASelected && !isBSelected) return -1;
            if (!isASelected && isBSelected) return 1;
            return 0;
        });
        items.forEach((item)=>container.appendChild(item));
    }
    async remoteSearch(val) {
        const res = await this.apiRequest(val);
        this.remoteOptions = res;
        let newIds = res.map((item)=>`${item.id}`);
        let restOptions = null;
        const pseudoOptions = this.dropdown.querySelectorAll("[data-value]");
        const options = this.el.querySelectorAll("[data-hs-select-option]");
        options.forEach((el)=>{
            const dataId = el.getAttribute("data-id");
            if (!newIds.includes(dataId) && !this.value?.includes(el.value)) this.destroyOriginalOption(el.value);
        });
        pseudoOptions.forEach((el)=>{
            const dataId = el.getAttribute("data-id");
            if (!newIds.includes(dataId) && !this.value?.includes(el.getAttribute("data-value"))) this.destroyOption(el.getAttribute("data-value"));
            else newIds = newIds.filter((item)=>item !== dataId);
        });
        restOptions = res.filter((item)=>newIds.includes(`${item.id}`));
        if (restOptions.length) this.buildOptionsFromRemoteData(restOptions);
        else console.log("There is no data were responded!");
    }
    destroyOption(val) {
        const option = this.dropdown.querySelector(`[data-value="${val}"]`);
        if (!option) return false;
        option.remove();
    }
    buildOriginalOption(title, val, id, disabled, selected, options) {
        const option = (0, $htam9.htmlToElement)("<option></option>");
        option.setAttribute("value", val);
        if (disabled) option.setAttribute("disabled", "disabled");
        if (selected) option.setAttribute("selected", "selected");
        if (id) option.setAttribute("data-id", id);
        option.setAttribute("data-hs-select-option", JSON.stringify(options));
        option.innerText = title;
        this.el.append(option);
    }
    destroyOriginalOption(val) {
        const option = this.el.querySelector(`[value="${val}"]`);
        if (!option) return false;
        option.remove();
    }
    buildTagsInputHelper() {
        this.tagsInputHelper = document.createElement("span");
        this.tagsInputHelper.style.fontSize = window.getComputedStyle(this.tagsInput).fontSize;
        this.tagsInputHelper.style.fontFamily = window.getComputedStyle(this.tagsInput).fontFamily;
        this.tagsInputHelper.style.fontWeight = window.getComputedStyle(this.tagsInput).fontWeight;
        this.tagsInputHelper.style.letterSpacing = window.getComputedStyle(this.tagsInput).letterSpacing;
        this.tagsInputHelper.style.visibility = "hidden";
        this.tagsInputHelper.style.whiteSpace = "pre";
        this.tagsInputHelper.style.position = "absolute";
        this.wrapper.appendChild(this.tagsInputHelper);
    }
    calculateInputWidth() {
        this.tagsInputHelper.textContent = this.tagsInput.value || this.tagsInput.placeholder;
        const inputPadding = parseInt(window.getComputedStyle(this.tagsInput).paddingLeft) + parseInt(window.getComputedStyle(this.tagsInput).paddingRight);
        const inputBorder = parseInt(window.getComputedStyle(this.tagsInput).borderLeftWidth) + parseInt(window.getComputedStyle(this.tagsInput).borderRightWidth);
        const newWidth = this.tagsInputHelper.offsetWidth + inputPadding + inputBorder;
        const maxWidth = this.wrapper.offsetWidth - (parseInt(window.getComputedStyle(this.wrapper).paddingLeft) + parseInt(window.getComputedStyle(this.wrapper).paddingRight));
        this.tagsInput.style.width = `${Math.min(newWidth, maxWidth) + 2}px`;
    }
    adjustInputWidth() {
        this.buildTagsInputHelper();
        this.calculateInputWidth();
    }
    onSelectOption(val) {
        this.clearSelections();
        if (this.isMultiple) {
            this.value = this.value.includes(val) ? Array.from(this.value).filter((el)=>el !== val) : [
                ...Array.from(this.value),
                val
            ];
            this.selectMultipleItems();
            this.setNewValue();
        } else {
            this.value = val;
            this.selectSingleItem();
            this.setNewValue();
        }
        this.fireEvent("change", this.value);
        (0, $htam9.dispatch)("change.hs.select", this.el, this.value);
        if (this.mode === "tags") {
            const intersection = this.selectedItems.filter((x)=>!this.value.includes(x));
            if (intersection.length) intersection.forEach((el)=>{
                this.selectedItems = this.selectedItems.filter((elI)=>elI !== el);
                this.wrapper.querySelector(`[data-tag-value="${el}"]`).remove();
            });
            this.resetTagsInputField();
        }
        if (!this.isMultiple) {
            if (this.toggle.querySelector("[data-icon]")) this.setToggleIcon();
            if (this.toggle.querySelector("[data-title]")) this.setToggleTitle();
            this.close();
        }
        if (!this.value.length && this.mode === "tags") this.reassignTagsInputPlaceholder(this.placeholder);
        if (this.isOpened && this.mode === "tags" && this.tagsInput) this.tagsInput.focus();
        this.triggerChangeEventForNativeSelect();
    }
    triggerChangeEventForNativeSelect() {
        // TODO:: test for bugs after comment the line below
        // (this.el as HTMLSelectElement).value = `${this.value}`;
        const selectChangeEvent = new Event("change", {
            bubbles: true
        });
        this.el.dispatchEvent(selectChangeEvent);
    }
    addSelectOption(title, val, disabled, selected, options) {
        this.selectOptions = [
            ...this.selectOptions,
            {
                title: title,
                val: val,
                disabled: disabled,
                selected: selected,
                options: options
            }
        ];
    }
    removeSelectOption(val, isArray = false) {
        const hasOption = !!this.selectOptions.some((el)=>el.val === val);
        if (!hasOption) return false;
        this.selectOptions = this.selectOptions.filter((el)=>el.val !== val);
        this.value = isArray ? this.value.filter((item)=>item !== val) : val;
    }
    resetTagsInputField() {
        this.tagsInput.value = "";
        this.reassignTagsInputPlaceholder("");
        this.searchOptions("");
    }
    clearSelections() {
        Array.from(this.dropdown.children).forEach((el)=>{
            if (el.classList.contains("selected")) el.classList.remove("selected");
        });
        Array.from(this.el.children).forEach((el)=>{
            if (el.selected) el.selected = false;
        });
    }
    setNewValue() {
        if (this.mode === "tags") this.setTagsItems();
        else if (this.value?.length) this.toggleTextWrapper.innerHTML = this.stringFromValue();
        else this.toggleTextWrapper.innerHTML = this.placeholder;
    }
    stringFromValueBasic(options) {
        const value = [];
        let title = "";
        options.forEach((el)=>{
            if (this.isMultiple) {
                if (this.value.includes(el.val)) value.push(el.title);
            } else if (this.value === el.val) value.push(el.title);
        });
        if (this.toggleCountText && this.toggleCountText !== "" && value.length >= this.toggleCountTextMinItems) {
            if (this.toggleCountTextMode === "nItemsAndCount") {
                const nItems = value.slice(0, this.toggleCountTextMinItems - 1);
                title = `${nItems.join(this.toggleSeparators.items)} ${this.toggleSeparators.betweenItemsAndCounter} ${value.length - nItems.length} ${this.toggleCountText}`;
            } else title = `${value.length} ${this.toggleCountText}`;
        } else title = value.join(this.toggleSeparators.items);
        return title;
    }
    stringFromValueRemoteData() {
        const options = this.dropdown.querySelectorAll("[data-title-value]");
        const value = [];
        let title = "";
        options.forEach((el)=>{
            const dataValue = el.getAttribute("data-value");
            if (this.isMultiple) {
                if (this.value.includes(dataValue)) value.push(dataValue);
            } else if (this.value === dataValue) value.push(dataValue);
        });
        if (this.toggleCountText && this.toggleCountText !== "" && value.length >= this.toggleCountTextMinItems) {
            if (this.toggleCountTextMode === "nItemsAndCount") {
                const nItems = value.slice(0, this.toggleCountTextMinItems - 1);
                title = `${nItems.join(this.toggleSeparators.items)} ${this.toggleSeparators.betweenItemsAndCounter} ${value.length - nItems.length} ${this.toggleCountText}`;
            } else title = `${value.length} ${this.toggleCountText}`;
        } else title = value.join(this.toggleSeparators.items);
        return title;
    }
    stringFromValue() {
        const result = this.apiUrl ? this.stringFromValueRemoteData() : this.stringFromValueBasic(this.selectOptions);
        return result;
    }
    selectSingleItem() {
        const selectedOption = Array.from(this.el.children).find((el)=>this.value === el.value);
        selectedOption.selected = true;
        const selectedItem = Array.from(this.dropdown.children).find((el)=>this.value === el.getAttribute("data-value"));
        if (selectedItem) selectedItem.classList.add("selected");
    }
    selectMultipleItems() {
        Array.from(this.dropdown.children).filter((el)=>this.value.includes(el.getAttribute("data-value"))).forEach((el)=>el.classList.add("selected"));
        Array.from(this.el.children).filter((el)=>this.value.includes(el.value)).forEach((el)=>el.selected = true);
    }
    unselectMultipleItems() {
        Array.from(this.dropdown.children).forEach((el)=>el.classList.remove("selected"));
        Array.from(this.el.children).forEach((el)=>el.selected = false);
    }
    searchOptions(val) {
        if (this.searchNoResult) {
            this.searchNoResult.remove();
            this.searchNoResult = null;
        }
        this.searchNoResult = (0, $htam9.htmlToElement)(this.searchNoResultTemplate);
        this.searchNoResult.innerText = this.searchNoResultText;
        (0, $htam9.classToClassList)(this.searchNoResultClasses, this.searchNoResult);
        const options = this.dropdown.querySelectorAll("[data-value]");
        let hasItems = false;
        let countLimit;
        if (this.searchLimit) countLimit = 0;
        options.forEach((el)=>{
            const optionVal = el.getAttribute("data-title-value").toLocaleLowerCase();
            const regexSafeVal = val ? val.split("").map((char)=>{
                return char.match(/\w/) ? `${char}[\\W_]*` : "\\W*";
            }).join("") : "";
            const regex = new RegExp(regexSafeVal, "i");
            const directMatch = this.isSearchDirectMatch;
            const cleanedOptionVal = optionVal.trim();
            const condition = val ? directMatch ? !cleanedOptionVal.toLowerCase().includes(val.toLowerCase()) || countLimit >= this.searchLimit : !regex.test(cleanedOptionVal) || countLimit >= this.searchLimit : !regex.test(cleanedOptionVal);
            if (condition) el.classList.add("hidden");
            else {
                el.classList.remove("hidden");
                hasItems = true;
                if (this.searchLimit) countLimit++;
            }
        });
        if (!hasItems) this.dropdown.append(this.searchNoResult);
    }
    eraseToggleIcon() {
        const icon = this.toggle.querySelector("[data-icon]");
        if (icon) {
            icon.innerHTML = null;
            icon.classList.add("hidden");
        }
    }
    eraseToggleTitle() {
        const title = this.toggle.querySelector("[data-title]");
        if (title) title.innerHTML = this.placeholder;
        else this.toggleTextWrapper.innerHTML = this.placeholder;
    }
    toggleFn() {
        if (this.isOpened) this.close();
        else this.open();
    }
    // Public methods
    destroy() {
        const parent = this.el.parentElement.parentElement;
        this.el.classList.remove("hidden");
        this.el.style.display = "";
        parent.prepend(this.el);
        parent.querySelector(".hs-select").remove();
        this.wrapper = null;
    }
    open() {
        const currentlyOpened = window?.$hsSelectCollection?.find((el)=>el.element.isOpened) || null;
        if (currentlyOpened) currentlyOpened.element.close();
        if (this.animationInProcess) return false;
        this.animationInProcess = true;
        if (this.dropdownScope === "window") this.dropdown.classList.add("invisible");
        this.dropdown.classList.remove("hidden");
        this.recalculateDirection();
        setTimeout(()=>{
            if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "true";
            this.wrapper.classList.add("active");
            this.dropdown.classList.add("opened");
            if (this.dropdown.classList.contains("w-full") && this.dropdownScope === "window") this.updateDropdownWidth();
            if (this.popperInstance && this.dropdownScope === "window") {
                this.popperInstance.update();
                this.dropdown.classList.remove("invisible");
            }
            if (this.hasSearch && !this.preventSearchFocus) this.search.focus();
            this.animationInProcess = false;
        });
        this.isOpened = true;
    }
    close() {
        if (this.animationInProcess) return false;
        this.animationInProcess = true;
        if (this?.toggle?.ariaExpanded) this.toggle.ariaExpanded = "false";
        this.wrapper.classList.remove("active");
        this.dropdown.classList.remove("opened", "bottom-full", "top-full");
        if (this.dropdownDirectionClasses?.bottom) this.dropdown.classList.remove(this.dropdownDirectionClasses.bottom);
        if (this.dropdownDirectionClasses?.top) this.dropdown.classList.remove(this.dropdownDirectionClasses.top);
        this.dropdown.style.marginTop = "";
        this.dropdown.style.marginBottom = "";
        (0, $htam9.afterTransition)(this.dropdown, ()=>{
            this.dropdown.classList.add("hidden");
            if (this.hasSearch) {
                this.search.value = "";
                this.search.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                this.search.blur();
            }
            this.animationInProcess = false;
        });
        this.dropdown.querySelector(".hs-select-option-highlighted")?.classList.remove("hs-select-option-highlighted");
        this.isOpened = false;
    }
    addOption(items) {
        let i = `${this.selectOptions.length}`;
        const addOption = (option)=>{
            const { title: title, val: val, disabled: disabled, selected: selected, options: options } = option;
            const hasOption = !!this.selectOptions.some((el)=>el.val === val);
            if (!hasOption) {
                this.addSelectOption(title, val, disabled, selected, options);
                this.buildOption(title, val, disabled, selected, options, i);
                this.buildOriginalOption(title, val, null, disabled, selected, options);
                if (selected && !this.isMultiple) this.onSelectOption(val);
            }
        };
        if (Array.isArray(items)) items.forEach((option)=>{
            addOption(option);
        });
        else addOption(items);
    }
    removeOption(values) {
        const removeOption = (val, isArray = false)=>{
            const hasOption = !!this.selectOptions.some((el)=>el.val === val);
            if (hasOption) {
                this.removeSelectOption(val, isArray);
                this.destroyOption(val);
                this.destroyOriginalOption(val);
                if (this.value === val) {
                    this.value = null;
                    this.eraseToggleTitle();
                    this.eraseToggleIcon();
                }
            }
        };
        if (Array.isArray(values)) values.forEach((val)=>{
            removeOption(val, this.isMultiple);
        });
        else removeOption(values, this.isMultiple);
        this.setNewValue();
    }
    recalculateDirection() {
        if ((0, $htam9.isEnoughSpace)(this.dropdown, this.toggle || this.tagsInput, "bottom", this.dropdownSpace, this.viewport)) {
            this.dropdown.classList.remove("bottom-full");
            if (this.dropdownDirectionClasses?.bottom) this.dropdown.classList.remove(this.dropdownDirectionClasses.bottom);
            this.dropdown.style.marginBottom = "";
            this.dropdown.classList.add("top-full");
            if (this.dropdownDirectionClasses?.top) this.dropdown.classList.add(this.dropdownDirectionClasses.top);
            this.dropdown.style.marginTop = `${this.dropdownSpace}px`;
        } else {
            this.dropdown.classList.remove("top-full");
            if (this.dropdownDirectionClasses?.top) this.dropdown.classList.remove(this.dropdownDirectionClasses.top);
            this.dropdown.style.marginTop = "";
            this.dropdown.classList.add("bottom-full");
            if (this.dropdownDirectionClasses?.bottom) this.dropdown.classList.add(this.dropdownDirectionClasses.bottom);
            this.dropdown.style.marginBottom = `${this.dropdownSpace}px`;
        }
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsSelectCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsSelectCollection) window.$hsSelectCollection = [];
        document.querySelectorAll("[data-hs-select]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsSelectCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-select");
                const options = data ? JSON.parse(data) : {};
                new $45555ee5ed0eeb66$var$HSSelect(el, options);
            }
        });
        if (window.$hsSelectCollection) {
            window.addEventListener("click", (evt)=>{
                const evtTarget = evt.target;
                $45555ee5ed0eeb66$var$HSSelect.closeCurrentlyOpened(evtTarget);
            });
            document.addEventListener("keydown", (evt)=>$45555ee5ed0eeb66$var$HSSelect.accessibility(evt));
        }
    }
    static open(target) {
        const elInCollection = window.$hsSelectCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.isOpened) elInCollection.element.open();
    }
    static close(target) {
        const elInCollection = window.$hsSelectCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.isOpened) elInCollection.element.close();
    }
    static closeCurrentlyOpened(evtTarget = null) {
        if (!evtTarget.closest(".hs-select.active") && !evtTarget.closest("[data-hs-select-dropdown].opened")) {
            const currentlyOpened = window.$hsSelectCollection.filter((el)=>el.element.isOpened) || null;
            if (currentlyOpened) currentlyOpened.forEach((el)=>{
                el.element.close();
            });
        }
    }
    // Accessibility methods
    static accessibility(evt) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target && (0, $704e031c65277337$export$717c92bf60493a1c).includes(evt.code) && !evt.metaKey) switch(evt.code){
            case "Escape":
                evt.preventDefault();
                this.onEscape();
                break;
            case "ArrowUp":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onArrow();
                break;
            case "ArrowDown":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onArrow(false);
                break;
            case "Tab":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onTab(evt.shiftKey);
                break;
            case "Home":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onStartEnd();
                break;
            case "End":
                evt.preventDefault();
                evt.stopImmediatePropagation();
                this.onStartEnd(false);
                break;
            case "Enter":
                evt.preventDefault();
                this.onEnter(evt);
                break;
            default:
                break;
        }
    }
    static onEscape() {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) target.element.close();
    }
    static onArrow(isArrowUp = true) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) {
            const dropdown = target.element.dropdown;
            if (!dropdown) return false;
            const preparedOptions = isArrowUp ? Array.from(dropdown.querySelectorAll(":scope > *:not(.hidden)")).reverse() : Array.from(dropdown.querySelectorAll(":scope > *:not(.hidden)"));
            const options = preparedOptions.filter((el)=>!el.classList.contains("disabled"));
            const current = dropdown.querySelector(".hs-select-option-highlighted") || dropdown.querySelector(".selected");
            if (!current) options[0].classList.add("hs-select-option-highlighted");
            let currentInd = options.findIndex((el)=>el === current);
            if (currentInd + 1 < options.length) currentInd++;
            options[currentInd].focus();
            if (current) current.classList.remove("hs-select-option-highlighted");
            options[currentInd].classList.add("hs-select-option-highlighted");
        }
    }
    static onTab(isArrowUp = true) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) {
            const dropdown = target.element.dropdown;
            if (!dropdown) return false;
            const preparedOptions = isArrowUp ? Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)")).reverse() : Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)"));
            const options = preparedOptions.filter((el)=>!el.classList.contains("disabled"));
            const current = dropdown.querySelector(".hs-select-option-highlighted") || dropdown.querySelector(".selected");
            if (!current) options[0].classList.add("hs-select-option-highlighted");
            let currentInd = options.findIndex((el)=>el === current);
            if (currentInd + 1 < options.length) currentInd++;
            else {
                if (current) current.classList.remove("hs-select-option-highlighted");
                target.element.close();
                target.element.toggle.focus();
                return false;
            }
            options[currentInd].focus();
            if (current) current.classList.remove("hs-select-option-highlighted");
            options[currentInd].classList.add("hs-select-option-highlighted");
        }
    }
    static onStartEnd(isStart = true) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) {
            const dropdown = target.element.dropdown;
            if (!dropdown) return false;
            const preparedOptions = isStart ? Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)")) : Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)")).reverse();
            const options = preparedOptions.filter((el)=>!el.classList.contains("disabled"));
            const current = dropdown.querySelector(".hs-select-option-highlighted");
            if (options.length) {
                options[0].focus();
                if (current) current.classList.remove("hs-select-option-highlighted");
                options[0].classList.add("hs-select-option-highlighted");
            }
        }
    }
    static onEnter(evt) {
        const select = evt.target.previousSibling;
        if (window.$hsSelectCollection.find((el)=>el.element.el === select)) {
            const opened = window.$hsSelectCollection.find((el)=>el.element.isOpened);
            const target = window.$hsSelectCollection.find((el)=>el.element.el === select);
            opened.element.close();
            target.element.open();
        } else {
            const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
            if (target) target.element.onSelectOption(evt.target.dataset.value || "");
        }
    }
}
window.addEventListener("load", ()=>{
    $45555ee5ed0eeb66$var$HSSelect.autoInit();
// Uncomment for debug
// console.log('Select collection:', window.$hsSelectCollection);
});
document.addEventListener("scroll", ()=>{
    if (!window.$hsSelectCollection) return false;
    const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
    if (target) target.element.recalculateDirection();
});
if (typeof window !== "undefined") window.HSSelect = $45555ee5ed0eeb66$var$HSSelect;
var $45555ee5ed0eeb66$export$2e2bcd8739ae039 = $45555ee5ed0eeb66$var$HSSelect;


/*
 * HSStepper
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $337d9a5ed351f458$var$HSStepper extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-stepper");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.currentIndex = concatOptions?.currentIndex || 1;
        this.mode = concatOptions?.mode || "linear";
        this.isCompleted = typeof concatOptions?.isCompleted !== "undefined" ? concatOptions?.isCompleted : false;
        this.totalSteps = 1;
        this.navItems = [];
        this.contentItems = [];
        this.init();
    }
    init() {
        this.createCollection(window.$hsStepperCollection, this);
        this.buildNav();
        this.buildContent();
        this.buildButtons();
        this.setTotalSteps();
    }
    getUncompletedSteps(inIncludedSkipped = false) {
        return this.navItems.filter(({ isCompleted: isCompleted, isSkip: isSkip })=>inIncludedSkipped ? !isCompleted || isSkip : !isCompleted && !isSkip);
    }
    setTotalSteps() {
        this.navItems.forEach((item)=>{
            const { index: index } = item;
            if (index > this.totalSteps) this.totalSteps = index;
        });
    }
    // Nav
    buildNav() {
        this.el.querySelectorAll("[data-hs-stepper-nav-item]").forEach((el)=>this.addNavItem(el));
        this.navItems.forEach((item)=>this.buildNavItem(item));
    }
    buildNavItem(item) {
        const { index: index, isDisabled: isDisabled, el: el } = item;
        if (index === this.currentIndex) this.setCurrentNavItem();
        if (this.mode !== "linear" || isDisabled) el.addEventListener("click", ()=>this.handleNavItemClick(item));
    }
    addNavItem(el) {
        const { index: index, isFinal: isFinal = false, isCompleted: isCompleted = false, isSkip: isSkip = false, isOptional: isOptional = false, isDisabled: isDisabled = false, isProcessed: isProcessed = false, hasError: hasError = false } = JSON.parse(el.getAttribute("data-hs-stepper-nav-item"));
        if (isCompleted) el.classList.add("success");
        if (isSkip) el.classList.add("skipped");
        if (isDisabled) {
            if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.setAttribute("disabled", "disabled");
            el.classList.add("disabled");
        }
        if (hasError) el.classList.add("error");
        this.navItems.push({
            index: index,
            isFinal: isFinal,
            isCompleted: isCompleted,
            isSkip: isSkip,
            isOptional: isOptional,
            isDisabled: isDisabled,
            isProcessed: isProcessed,
            hasError: hasError,
            el: el
        });
    }
    setCurrentNavItem() {
        this.navItems.forEach((item)=>{
            const { index: index, el: el } = item;
            if (index === this.currentIndex) this.setCurrentNavItemActions(el);
            else this.unsetCurrentNavItemActions(el);
        });
    }
    setCurrentNavItemActions(el) {
        el.classList.add("active");
        this.fireEvent("active", this.currentIndex);
        (0, $htam9.dispatch)("active.hs.stepper", this.el, this.currentIndex);
    }
    getNavItem(n = this.currentIndex) {
        return this.navItems.find(({ index: index })=>index === n);
    }
    setProcessedNavItemActions(item) {
        item.isProcessed = true;
        item.el.classList.add("processed");
    }
    setErrorNavItemActions(item) {
        item.hasError = true;
        item.el.classList.add("error");
    }
    unsetCurrentNavItemActions(el) {
        el.classList.remove("active");
    }
    handleNavItemClick(item) {
        const { index: index } = item;
        this.currentIndex = index;
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
    }
    // Content
    buildContent() {
        this.el.querySelectorAll("[data-hs-stepper-content-item]").forEach((el)=>this.addContentItem(el));
        this.navItems.forEach((item)=>this.buildContentItem(item));
    }
    buildContentItem(item) {
        const { index: index } = item;
        if (index === this.currentIndex) this.setCurrentContentItem();
    }
    addContentItem(el) {
        const { index: index, isFinal: isFinal = false, isCompleted: isCompleted = false, isSkip: isSkip = false } = JSON.parse(el.getAttribute("data-hs-stepper-content-item"));
        if (isCompleted) el.classList.add("success");
        if (isSkip) el.classList.add("skipped");
        this.contentItems.push({
            index: index,
            isFinal: isFinal,
            isCompleted: isCompleted,
            isSkip: isSkip,
            el: el
        });
    }
    setCurrentContentItem() {
        if (this.isCompleted) {
            const finalContentItem = this.contentItems.find(({ isFinal: isFinal })=>isFinal);
            const otherContentItems = this.contentItems.filter(({ isFinal: isFinal })=>!isFinal);
            finalContentItem.el.style.display = "";
            otherContentItems.forEach(({ el: el })=>el.style.display = "none");
            return false;
        }
        this.contentItems.forEach((item)=>{
            const { index: index, el: el } = item;
            if (index === this.currentIndex) this.setCurrentContentItemActions(el);
            else this.unsetCurrentContentItemActions(el);
        });
    }
    hideAllContentItems() {
        this.contentItems.forEach(({ el: el })=>el.style.display = "none");
    }
    setCurrentContentItemActions(el) {
        el.style.display = "";
    }
    unsetCurrentContentItemActions(el) {
        el.style.display = "none";
    }
    disableAll() {
        const currentNavItem = this.getNavItem(this.currentIndex);
        currentNavItem.hasError = false;
        currentNavItem.isCompleted = false;
        currentNavItem.isDisabled = false;
        currentNavItem.el.classList.remove("error", "success");
        this.disableButtons();
    }
    disableNavItemActions(item) {
        item.isDisabled = true;
        item.el.classList.add("disabled");
    }
    enableNavItemActions(item) {
        item.isDisabled = false;
        item.el.classList.remove("disabled");
    }
    // Buttons
    buildButtons() {
        this.backBtn = this.el.querySelector("[data-hs-stepper-back-btn]");
        this.nextBtn = this.el.querySelector("[data-hs-stepper-next-btn]");
        this.skipBtn = this.el.querySelector("[data-hs-stepper-skip-btn]");
        this.completeStepBtn = this.el.querySelector("[data-hs-stepper-complete-step-btn]");
        this.finishBtn = this.el.querySelector("[data-hs-stepper-finish-btn]");
        this.resetBtn = this.el.querySelector("[data-hs-stepper-reset-btn]");
        this.buildBackButton();
        this.buildNextButton();
        this.buildSkipButton();
        this.buildCompleteStepButton();
        this.buildFinishButton();
        this.buildResetButton();
    }
    // back
    buildBackButton() {
        if (!this.backBtn) return;
        this.checkForTheFirstStep();
        this.backBtn.addEventListener("click", ()=>{
            this.handleBackButtonClick();
            if (this.mode === "linear") {
                const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
                const currentContentItem = this.contentItems.find(({ index: index })=>index === this.currentIndex);
                if (!currentNavItem || !currentContentItem) return;
                if (currentNavItem.isCompleted) {
                    currentNavItem.isCompleted = false;
                    currentNavItem.isSkip = false;
                    currentNavItem.el.classList.remove("success", "skipped");
                }
                if (currentContentItem.isCompleted) {
                    currentContentItem.isCompleted = false;
                    currentContentItem.isSkip = false;
                    currentContentItem.el.classList.remove("success", "skipped");
                }
                if (this.mode === "linear" && this.currentIndex !== this.totalSteps) {
                    if (this.nextBtn) this.nextBtn.style.display = "";
                    if (this.completeStepBtn) this.completeStepBtn.style.display = "";
                }
                this.showSkipButton();
                this.showFinishButton();
                this.showCompleteStepButton();
            }
        });
    }
    handleBackButtonClick() {
        if (this.currentIndex === 1) return;
        if (this.mode === "linear") this.removeOptionalClasses();
        this.currentIndex--;
        if (this.mode === "linear") this.removeOptionalClasses();
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
        if (this.completeStepBtn) this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.fireEvent("back", this.currentIndex);
        (0, $htam9.dispatch)("back.hs.stepper", this.el, this.currentIndex);
    }
    checkForTheFirstStep() {
        if (this.currentIndex === 1) this.setToDisabled(this.backBtn);
        else this.setToNonDisabled(this.backBtn);
    }
    setToDisabled(el) {
        if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.setAttribute("disabled", "disabled");
        el.classList.add("disabled");
    }
    setToNonDisabled(el) {
        if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.removeAttribute("disabled");
        el.classList.remove("disabled");
    }
    // next
    buildNextButton() {
        if (!this.nextBtn) return;
        this.nextBtn.addEventListener("click", ()=>{
            this.fireEvent("beforeNext", this.currentIndex);
            (0, $htam9.dispatch)("beforeNext.hs.stepper", this.el, this.currentIndex);
            if (this.getNavItem(this.currentIndex)?.isProcessed) {
                this.disableAll();
                return false;
            }
            this.goToNext();
        });
    }
    unsetProcessedNavItemActions(item) {
        item.isProcessed = false;
        item.el.classList.remove("processed");
    }
    handleNextButtonClick(infinite = true) {
        if (infinite) {
            if (this.currentIndex === this.totalSteps) this.currentIndex = 1;
            else this.currentIndex++;
        } else {
            const nonCompletedSteps = this.getUncompletedSteps();
            if (nonCompletedSteps.length === 1) {
                const { index: index } = nonCompletedSteps[0];
                this.currentIndex = index;
            } else {
                if (this.currentIndex === this.totalSteps) return;
                this.currentIndex++;
            }
        }
        if (this.mode === "linear") this.removeOptionalClasses();
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
        if (this.completeStepBtn) this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.showSkipButton();
        this.showFinishButton();
        this.showCompleteStepButton();
        this.fireEvent("next", this.currentIndex);
        (0, $htam9.dispatch)("next.hs.stepper", this.el, this.currentIndex);
    }
    removeOptionalClasses() {
        const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
        const currentContentItem = this.contentItems.find(({ index: index })=>index === this.currentIndex);
        currentNavItem.isSkip = false;
        currentNavItem.hasError = false;
        currentNavItem.isDisabled = false;
        currentContentItem.isSkip = false;
        currentNavItem.el.classList.remove("skipped", "success", "error");
        currentContentItem.el.classList.remove("skipped", "success", "error");
    }
    // skip
    buildSkipButton() {
        if (!this.skipBtn) return;
        this.showSkipButton();
        this.skipBtn.addEventListener("click", ()=>{
            this.handleSkipButtonClick();
            if (this.mode === "linear" && this.currentIndex === this.totalSteps) {
                if (this.nextBtn) this.nextBtn.style.display = "none";
                if (this.completeStepBtn) this.completeStepBtn.style.display = "none";
                if (this.finishBtn) this.finishBtn.style.display = "";
            }
        });
    }
    setSkipItem(n) {
        const targetNavItem = this.navItems.find(({ index: index })=>index === (n || this.currentIndex));
        const targetContentItem = this.contentItems.find(({ index: index })=>index === (n || this.currentIndex));
        if (!targetNavItem || !targetContentItem) return;
        this.setSkipItemActions(targetNavItem);
        this.setSkipItemActions(targetContentItem);
    }
    setSkipItemActions(item) {
        item.isSkip = true;
        item.el.classList.add("skipped");
    }
    showSkipButton() {
        if (!this.skipBtn) return;
        const { isOptional: isOptional } = this.navItems.find(({ index: index })=>index === this.currentIndex);
        if (isOptional) this.skipBtn.style.display = "";
        else this.skipBtn.style.display = "none";
    }
    handleSkipButtonClick() {
        this.setSkipItem();
        this.handleNextButtonClick();
        this.fireEvent("skip", this.currentIndex);
        (0, $htam9.dispatch)("skip.hs.stepper", this.el, this.currentIndex);
    }
    // complete
    buildCompleteStepButton() {
        if (!this.completeStepBtn) return;
        this.completeStepBtnDefaultText = this.completeStepBtn.innerText;
        this.completeStepBtn.addEventListener("click", ()=>this.handleCompleteStepButtonClick());
    }
    changeTextAndDisableCompleteButtonIfStepCompleted() {
        const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
        const { completedText: completedText } = JSON.parse(this.completeStepBtn.getAttribute("data-hs-stepper-complete-step-btn"));
        if (!currentNavItem) return;
        if (currentNavItem.isCompleted) {
            this.completeStepBtn.innerText = completedText || this.completeStepBtnDefaultText;
            this.completeStepBtn.setAttribute("disabled", "disabled");
            this.completeStepBtn.classList.add("disabled");
        } else {
            this.completeStepBtn.innerText = this.completeStepBtnDefaultText;
            this.completeStepBtn.removeAttribute("disabled");
            this.completeStepBtn.classList.remove("disabled");
        }
    }
    setCompleteItem(n) {
        const targetNavItem = this.navItems.find(({ index: index })=>index === (n || this.currentIndex));
        const targetContentItem = this.contentItems.find(({ index: index })=>index === (n || this.currentIndex));
        if (!targetNavItem || !targetContentItem) return;
        this.setCompleteItemActions(targetNavItem);
        this.setCompleteItemActions(targetContentItem);
    }
    setCompleteItemActions(item) {
        item.isCompleted = true;
        item.el.classList.add("success");
    }
    showCompleteStepButton() {
        if (!this.completeStepBtn) return;
        const nonCompletedSteps = this.getUncompletedSteps();
        if (nonCompletedSteps.length === 1) this.completeStepBtn.style.display = "none";
        else this.completeStepBtn.style.display = "";
    }
    handleCompleteStepButtonClick() {
        this.setCompleteItem();
        this.fireEvent("complete", this.currentIndex);
        (0, $htam9.dispatch)("complete.hs.stepper", this.el, this.currentIndex);
        this.handleNextButtonClick(false);
        this.showFinishButton();
        this.showCompleteStepButton();
        this.checkForTheFirstStep();
        if (this.completeStepBtn) this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.showSkipButton();
    }
    // finish
    buildFinishButton() {
        if (!this.finishBtn) return;
        if (this.isCompleted) this.setCompleted();
        this.finishBtn.addEventListener("click", ()=>this.handleFinishButtonClick());
    }
    setCompleted() {
        this.el.classList.add("completed");
    }
    unsetCompleted() {
        this.el.classList.remove("completed");
    }
    showFinishButton() {
        if (!this.finishBtn) return;
        const nonCompletedSteps = this.getUncompletedSteps();
        if (nonCompletedSteps.length === 1) this.finishBtn.style.display = "";
        else this.finishBtn.style.display = "none";
    }
    handleFinishButtonClick() {
        const uncompletedSteps = this.getUncompletedSteps();
        const uncompletedOrSkipSteps = this.getUncompletedSteps(true);
        const { el: el } = this.contentItems.find(({ isFinal: isFinal })=>isFinal);
        if (uncompletedSteps.length) uncompletedSteps.forEach(({ index: index })=>this.setCompleteItem(index));
        this.currentIndex = this.totalSteps;
        this.setCurrentNavItem();
        this.hideAllContentItems();
        const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
        const currentNavItemEl = currentNavItem ? currentNavItem.el : null;
        currentNavItemEl.classList.remove("active");
        el.style.display = "block";
        if (this.backBtn) this.backBtn.style.display = "none";
        if (this.nextBtn) this.nextBtn.style.display = "none";
        if (this.skipBtn) this.skipBtn.style.display = "none";
        if (this.completeStepBtn) this.completeStepBtn.style.display = "none";
        if (this.finishBtn) this.finishBtn.style.display = "none";
        if (this.resetBtn) this.resetBtn.style.display = "";
        if (uncompletedOrSkipSteps.length <= 1) {
            this.isCompleted = true;
            this.setCompleted();
        }
        this.fireEvent("finish", this.currentIndex);
        (0, $htam9.dispatch)("finish.hs.stepper", this.el, this.currentIndex);
    }
    // reset
    buildResetButton() {
        if (!this.resetBtn) return;
        this.resetBtn.addEventListener("click", ()=>this.handleResetButtonClick());
    }
    handleResetButtonClick() {
        if (this.backBtn) this.backBtn.style.display = "";
        if (this.nextBtn) this.nextBtn.style.display = "";
        if (this.completeStepBtn) {
            this.completeStepBtn.style.display = "";
            this.completeStepBtn.innerText = this.completeStepBtnDefaultText;
            this.completeStepBtn.removeAttribute("disabled");
            this.completeStepBtn.classList.remove("disabled");
        }
        if (this.resetBtn) this.resetBtn.style.display = "none";
        this.navItems.forEach((item)=>{
            const { el: el } = item;
            item.isSkip = false;
            item.isCompleted = false;
            this.unsetCurrentNavItemActions(el);
            el.classList.remove("success", "skipped");
        });
        this.contentItems.forEach((item)=>{
            const { el: el } = item;
            item.isSkip = false;
            item.isCompleted = false;
            this.unsetCurrentContentItemActions(el);
            el.classList.remove("success", "skipped");
        });
        this.currentIndex = 1;
        this.unsetCompleted();
        this.isCompleted = false;
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.showFinishButton();
        this.showCompleteStepButton();
        this.checkForTheFirstStep();
        this.fireEvent("reset", this.currentIndex);
        (0, $htam9.dispatch)("reset.hs.stepper", this.el, this.currentIndex);
    }
    // Public methods
    setProcessedNavItem(n) {
        const targetNavItem = this.getNavItem(n);
        if (!targetNavItem) return;
        this.setProcessedNavItemActions(targetNavItem);
    }
    unsetProcessedNavItem(n) {
        const targetNavItem = this.getNavItem(n);
        if (!targetNavItem) return;
        this.unsetProcessedNavItemActions(targetNavItem);
    }
    goToNext() {
        if (this.mode === "linear") this.setCompleteItem();
        this.handleNextButtonClick(this.mode !== "linear");
        if (this.mode === "linear" && this.currentIndex === this.totalSteps) {
            if (this.nextBtn) this.nextBtn.style.display = "none";
            if (this.completeStepBtn) this.completeStepBtn.style.display = "none";
        }
    }
    disableButtons() {
        if (this.backBtn) this.setToDisabled(this.backBtn);
        if (this.nextBtn) this.setToDisabled(this.nextBtn);
    }
    enableButtons() {
        if (this.backBtn) this.setToNonDisabled(this.backBtn);
        if (this.nextBtn) this.setToNonDisabled(this.nextBtn);
    }
    setErrorNavItem(n) {
        const targetNavItem = this.getNavItem(n);
        if (!targetNavItem) return;
        this.setErrorNavItemActions(targetNavItem);
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsStepperCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsStepperCollection) window.$hsStepperCollection = [];
        document.querySelectorAll("[data-hs-stepper]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsStepperCollection.find((elC)=>elC?.element?.el === el)) new $337d9a5ed351f458$var$HSStepper(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $337d9a5ed351f458$var$HSStepper.autoInit();
// Uncomment for debug
// console.log('Stepper collection:', window.$hsStepperCollection);
});
if (typeof window !== "undefined") window.HSStepper = $337d9a5ed351f458$var$HSStepper;
var $337d9a5ed351f458$export$2e2bcd8739ae039 = $337d9a5ed351f458$var$HSStepper;


/*
 * HSStrongPassword
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $36a0e440f8597468$var$HSStrongPassword extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        this.isOpened = false;
        this.strength = 0;
        this.passedRules = new Set();
        const data = el.getAttribute("data-hs-strong-password");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.target = concatOptions?.target ? typeof concatOptions?.target === "string" ? document.querySelector(concatOptions.target) : concatOptions.target : null;
        this.hints = concatOptions?.hints ? typeof concatOptions?.hints === "string" ? document.querySelector(concatOptions.hints) : concatOptions.hints : null;
        this.stripClasses = concatOptions?.stripClasses || null;
        this.minLength = concatOptions?.minLength || 6;
        this.mode = concatOptions?.mode || "default";
        this.popoverSpace = concatOptions?.popoverSpace || 10;
        this.checksExclude = concatOptions?.checksExclude || [];
        this.availableChecks = [
            "lowercase",
            "uppercase",
            "numbers",
            "special-characters",
            "min-length"
        ].filter((el)=>!this.checksExclude.includes(el));
        this.specialCharactersSet = concatOptions?.specialCharactersSet || "!\"#$%&'()*+,-./:;<=>?@[\\\\\\]^_`{|}~";
        if (this.target) this.init();
    }
    init() {
        this.createCollection(window.$hsStrongPasswordCollection, this);
        if (this.availableChecks.length) this.build();
    }
    build() {
        this.buildStrips();
        if (this.hints) this.buildHints();
        this.setStrength(this.target.value);
        this.target.addEventListener("input", (evt)=>{
            this.setStrength(evt.target.value);
        });
    }
    buildStrips() {
        this.el.innerHTML = "";
        if (this.stripClasses) for(let i = 0; i < this.availableChecks.length; i++){
            const newStrip = (0, $htam9.htmlToElement)("<div></div>");
            (0, $htam9.classToClassList)(this.stripClasses, newStrip);
            this.el.append(newStrip);
        }
    }
    buildHints() {
        this.weakness = this.hints.querySelector("[data-hs-strong-password-hints-weakness-text]") || null;
        this.rules = Array.from(this.hints.querySelectorAll("[data-hs-strong-password-hints-rule-text]")) || null;
        this.rules.forEach((rule)=>{
            const ruleValue = rule.getAttribute("data-hs-strong-password-hints-rule-text");
            if (this.checksExclude?.includes(ruleValue)) rule.remove();
        });
        if (this.weakness) this.buildWeakness();
        if (this.rules) this.buildRules();
        if (this.mode === "popover") {
            this.target.addEventListener("focus", ()=>{
                this.isOpened = true;
                this.hints.classList.remove("hidden");
                this.hints.classList.add("block");
                this.recalculateDirection();
            });
            this.target.addEventListener("blur", ()=>{
                this.isOpened = false;
                this.hints.classList.remove("block", "bottom-full", "top-full");
                this.hints.classList.add("hidden");
                this.hints.style.marginTop = "";
                this.hints.style.marginBottom = "";
            });
        }
    }
    buildWeakness() {
        this.checkStrength(this.target.value);
        this.setWeaknessText();
        this.target.addEventListener("input", ()=>setTimeout(()=>this.setWeaknessText()));
    }
    buildRules() {
        this.setRulesText();
        this.target.addEventListener("input", ()=>setTimeout(()=>this.setRulesText()));
    }
    setWeaknessText() {
        const weaknessText = this.weakness.getAttribute("data-hs-strong-password-hints-weakness-text");
        const weaknessTextToJson = JSON.parse(weaknessText);
        this.weakness.textContent = weaknessTextToJson[this.strength];
    }
    setRulesText() {
        this.rules.forEach((rule)=>{
            const ruleValue = rule.getAttribute("data-hs-strong-password-hints-rule-text");
            this.checkIfPassed(rule, this.passedRules.has(ruleValue));
        });
    }
    togglePopover() {
        const popover = this.el.querySelector(".popover");
        if (popover) popover.classList.toggle("show");
    }
    checkStrength(val) {
        const passedRules = new Set();
        const regexps = {
            lowercase: /[a-z]+/,
            uppercase: /[A-Z]+/,
            numbers: /[0-9]+/,
            "special-characters": new RegExp(`[${this.specialCharactersSet}]`)
        };
        let strength = 0;
        if (this.availableChecks.includes("lowercase") && val.match(regexps["lowercase"])) {
            strength += 1;
            passedRules.add("lowercase");
        }
        if (this.availableChecks.includes("uppercase") && val.match(regexps["uppercase"])) {
            strength += 1;
            passedRules.add("uppercase");
        }
        if (this.availableChecks.includes("numbers") && val.match(regexps["numbers"])) {
            strength += 1;
            passedRules.add("numbers");
        }
        if (this.availableChecks.includes("special-characters") && val.match(regexps["special-characters"])) {
            strength += 1;
            passedRules.add("special-characters");
        }
        if (this.availableChecks.includes("min-length") && val.length >= this.minLength) {
            strength += 1;
            passedRules.add("min-length");
        }
        if (!val.length) strength = 0;
        if (strength === this.availableChecks.length) this.el.classList.add("accepted");
        else this.el.classList.remove("accepted");
        this.strength = strength;
        this.passedRules = passedRules;
        return {
            strength: this.strength,
            rules: this.passedRules
        };
    }
    checkIfPassed(el, isRulePassed = false) {
        const check = el.querySelector("[data-check]");
        const uncheck = el.querySelector("[data-uncheck]");
        if (isRulePassed) {
            el.classList.add("active");
            check.classList.remove("hidden");
            uncheck.classList.add("hidden");
        } else {
            el.classList.remove("active");
            check.classList.add("hidden");
            uncheck.classList.remove("hidden");
        }
    }
    setStrength(val) {
        const { strength: strength, rules: rules } = this.checkStrength(val);
        const payload = {
            strength: strength,
            rules: rules
        };
        this.hideStrips(strength);
        this.fireEvent("change", payload);
        (0, $htam9.dispatch)("change.hs.strongPassword", this.el, payload);
    }
    hideStrips(qty) {
        Array.from(this.el.children).forEach((el, i)=>{
            if (i < qty) el.classList.add("passed");
            else el.classList.remove("passed");
        });
    }
    // Public methods
    recalculateDirection() {
        if ((0, $htam9.isEnoughSpace)(this.hints, this.target, "bottom", this.popoverSpace)) {
            this.hints.classList.remove("bottom-full");
            this.hints.classList.add("top-full");
            this.hints.style.marginBottom = "";
            this.hints.style.marginTop = `${this.popoverSpace}px`;
        } else {
            this.hints.classList.remove("top-full");
            this.hints.classList.add("bottom-full");
            this.hints.style.marginTop = "";
            this.hints.style.marginBottom = `${this.popoverSpace}px`;
        }
    }
    // Static methods
    static getInstance(target) {
        const elInCollection = window.$hsStrongPasswordCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsStrongPasswordCollection) window.$hsStrongPasswordCollection = [];
        document.querySelectorAll("[data-hs-strong-password]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsStrongPasswordCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-strong-password");
                const options = data ? JSON.parse(data) : {};
                new $36a0e440f8597468$var$HSStrongPassword(el, options);
            }
        });
    }
}
window.addEventListener("load", ()=>{
    $36a0e440f8597468$var$HSStrongPassword.autoInit();
// Uncomment for debug
// console.log('Strong password collection:', window.$hsStrongPasswordCollection);
});
document.addEventListener("scroll", ()=>{
    if (!window.$hsStrongPasswordCollection) return false;
    const target = window.$hsStrongPasswordCollection.find((el)=>el.element.isOpened);
    if (target) target.element.recalculateDirection();
});
if (typeof window !== "undefined") window.HSStrongPassword = $36a0e440f8597468$var$HSStrongPassword;
var $36a0e440f8597468$export$2e2bcd8739ae039 = $36a0e440f8597468$var$HSStrongPassword;


/*
 * HSTabs
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");

class $6784483c0c3eb726$var$HSTabs extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        this.toggles = this.el.querySelectorAll("[data-hs-tab]");
        this.extraToggleId = this.el.getAttribute("data-hs-tab-select");
        this.extraToggle = document.querySelector(this.extraToggleId);
        this.current = Array.from(this.toggles).find((el)=>el.classList.contains("active"));
        this.currentContentId = this.current.getAttribute("data-hs-tab");
        this.currentContent = document.querySelector(this.currentContentId);
        this.prev = null;
        this.prevContentId = null;
        this.prevContent = null;
        this.init();
    }
    init() {
        this.createCollection(window.$hsTabsCollection, this);
        this.toggles.forEach((el)=>{
            el.addEventListener("click", ()=>this.open(el));
        });
        if (this.extraToggle) this.extraToggle.addEventListener("change", (evt)=>this.change(evt));
    }
    open(el) {
        this.prev = this.current;
        this.prevContentId = this.currentContentId;
        this.prevContent = this.currentContent;
        this.current = el;
        this.currentContentId = this.current.getAttribute("data-hs-tab");
        this.currentContent = document.querySelector(this.currentContentId);
        if (this?.prev?.ariaSelected) this.prev.ariaSelected = "false";
        this.prev.classList.remove("active");
        this.prevContent.classList.add("hidden");
        if (this?.current?.ariaSelected) this.current.ariaSelected = "true";
        this.current.classList.add("active");
        this.currentContent.classList.remove("hidden");
        this.fireEvent("change", {
            el: el,
            prev: this.prevContentId,
            current: this.currentContentId
        });
        (0, $htam9.dispatch)("change.hs.tab", el, {
            el: el,
            prev: this.prevContentId,
            current: this.currentContentId
        });
    }
    change(evt) {
        const toggle = document.querySelector(`[data-hs-tab="${evt.target.value}"]`);
        if (toggle) toggle.click();
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsTabsCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsTabsCollection) window.$hsTabsCollection = [];
        document.querySelectorAll('[role="tablist"]:not(select):not(.--prevent-on-load-init)').forEach((el)=>{
            if (!window.$hsTabsCollection.find((elC)=>elC?.element?.el === el)) new $6784483c0c3eb726$var$HSTabs(el);
        });
        if (window.$hsTabsCollection) document.addEventListener("keydown", (evt)=>$6784483c0c3eb726$var$HSTabs.accessibility(evt));
    }
    static open(target) {
        const elInCollection = window.$hsTabsCollection.find((el)=>Array.from(el.element.toggles).includes(typeof target === "string" ? document.querySelector(target) : target));
        const targetInCollection = Array.from(elInCollection.element.toggles).find((el)=>el === (typeof target === "string" ? document.querySelector(target) : target));
        if (targetInCollection && !targetInCollection.classList.contains("active")) elInCollection.element.open(targetInCollection);
    }
    // Accessibility methods
    static accessibility(evt) {
        const target = document.querySelector("[data-hs-tab]:focus");
        if (target && (0, $704e031c65277337$export$8c1058a58d2daf41).includes(evt.code) && !evt.metaKey) {
            const isVertical = target.closest('[role="tablist"]').getAttribute("data-hs-tabs-vertical");
            evt.preventDefault();
            switch(evt.code){
                case isVertical === "true" ? "ArrowUp" : "ArrowLeft":
                    this.onArrow();
                    break;
                case isVertical === "true" ? "ArrowDown" : "ArrowRight":
                    this.onArrow(false);
                    break;
                case "Home":
                    this.onStartEnd();
                    break;
                case "End":
                    this.onStartEnd(false);
                    break;
                default:
                    break;
            }
        }
    }
    static onArrow(isOpposite = true) {
        const target = document.querySelector("[data-hs-tab]:focus").closest('[role="tablist"]');
        const targetInCollection = window.$hsTabsCollection.find((el)=>el.element.el === target);
        if (targetInCollection) {
            const toggles = isOpposite ? Array.from(targetInCollection.element.toggles).reverse() : Array.from(targetInCollection.element.toggles);
            const focused = toggles.find((el)=>document.activeElement === el);
            let focusedInd = toggles.findIndex((el)=>el === focused);
            focusedInd = focusedInd + 1 < toggles.length ? focusedInd + 1 : 0;
            toggles[focusedInd].focus();
            toggles[focusedInd].click();
        }
    }
    static onStartEnd(isOpposite = true) {
        const target = document.querySelector("[data-hs-tab]:focus").closest('[role="tablist"]');
        const targetInCollection = window.$hsTabsCollection.find((el)=>el.element.el === target);
        if (targetInCollection) {
            const toggles = isOpposite ? Array.from(targetInCollection.element.toggles) : Array.from(targetInCollection.element.toggles).reverse();
            if (toggles.length) {
                toggles[0].focus();
                toggles[0].click();
            }
        }
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsTabsCollection.find((el)=>Array.from(el.element.toggles).includes(typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $6784483c0c3eb726$var$HSTabs.autoInit();
// Uncomment for debug
// console.log('Tabs collection:', window.$hsTabsCollection);
});
if (typeof window !== "undefined") window.HSTabs = $6784483c0c3eb726$var$HSTabs;
var $6784483c0c3eb726$export$2e2bcd8739ae039 = $6784483c0c3eb726$var$HSTabs;


/*
 * HSTextareaAutoHeight
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $kYnwU = parcelRequire("kYnwU");
class $67ab52e3fc36dff7$var$HSTextareaAutoHeight extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-copy-markup");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.defaultHeight = concatOptions?.defaultHeight || 0;
        this.init();
    }
    init() {
        this.createCollection(window.$hsTextareaAutoHeightCollection, this);
        this.setAutoHeight();
    }
    setAutoHeight() {
        if (this.isParentHidden()) this.callbackAccordingToType();
        else this.textareaSetHeight(3);
        this.el.addEventListener("input", ()=>this.textareaSetHeight(3));
    }
    textareaSetHeight(offsetTop = 0) {
        this.el.style.height = "auto";
        this.el.style.height = this.checkIfOneLine() && this.defaultHeight ? `${this.defaultHeight}px` : `${this.el.scrollHeight + offsetTop}px`;
    }
    checkIfOneLine() {
        const clientHeight = this.el.clientHeight;
        const scrollHeight = this.el.scrollHeight;
        if (scrollHeight > clientHeight) return false;
        else return true;
    }
    isParentHidden() {
        return this.el.closest(".hs-collapse") || this.el.closest(".hs-overlay");
    }
    parentType() {
        if (this.el.closest(".hs-collapse")) return "collapse";
        else if (this.el.closest(".hs-overlay")) return "overlay";
        else return false;
    }
    callbackAccordingToType() {
        if (this.parentType() === "collapse") {
            const collapseId = this.el.closest(".hs-collapse").id;
            const { element: element } = window.HSCollapse.getInstance(`[data-hs-collapse="#${collapseId}"]`, true);
            element.on("beforeOpen", ()=>{
                if (!this.el) return false;
                this.textareaSetHeight(3);
            });
        } else if (this.parentType() === "overlay") {
            const { element: element } = window.HSOverlay.getInstance(this.el.closest(".hs-overlay"), true);
            element.on("open", ()=>{
                if (!this.el) return false;
                this.textareaSetHeight(3);
            });
        } else return false;
    }
    // Static method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsTextareaAutoHeightCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsTextareaAutoHeightCollection) window.$hsTextareaAutoHeightCollection = [];
        document.querySelectorAll("[data-hs-textarea-auto-height]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsTextareaAutoHeightCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-textarea-auto-height");
                const options = data ? JSON.parse(data) : {};
                new $67ab52e3fc36dff7$var$HSTextareaAutoHeight(el, options);
            }
        });
    }
}
window.addEventListener("load", ()=>{
    $67ab52e3fc36dff7$var$HSTextareaAutoHeight.autoInit();
// Uncomment for debug
// console.log('Textarea Autoheight collection:', window.$hsTextareaAutoHeightCollection);
});
if (typeof window !== "undefined") window.HSTextareaAutoHeight = $67ab52e3fc36dff7$var$HSTextareaAutoHeight;
var $67ab52e3fc36dff7$export$2e2bcd8739ae039 = $67ab52e3fc36dff7$var$HSTextareaAutoHeight;


/*
 * HSThemeSwitch
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $kYnwU = parcelRequire("kYnwU");
class $6deeff70b35b9220$var$HSThemeSwitch extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-theme-switch");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.theme = concatOptions?.theme || localStorage.getItem("hs_theme") || "default";
        this.themeSet = [
            "light",
            "dark",
            "default"
        ];
        this.init();
    }
    init() {
        this.createCollection(window.$hsThemeSwitchCollection, this);
        if (this.theme !== "default") this.setAppearance();
    }
    setResetStyles() {
        const style = document.createElement("style");
        style.innerText = `*{transition: unset !important;}`;
        style.setAttribute("data-hs-appearance-onload-styles", "");
        document.head.appendChild(style);
        return style;
    }
    addSystemThemeObserver() {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ({ matches: matches })=>{
            if (matches) this.setAppearance("dark", false);
            else this.setAppearance("default", false);
        });
    }
    removeSystemThemeObserver() {
        window.matchMedia("(prefers-color-scheme: dark)").removeEventListener;
    }
    // Public methods
    setAppearance(theme = this.theme, isSaveToLocalStorage = true, isSetDispatchEvent = true) {
        const html = document.querySelector("html");
        const resetStyles = this.setResetStyles();
        if (isSaveToLocalStorage) localStorage.setItem("hs_theme", theme);
        if (theme === "auto") theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "default";
        html.classList.remove("light", "dark", "default", "auto");
        html.classList.add(theme);
        setTimeout(()=>resetStyles.remove());
        if (isSetDispatchEvent) window.dispatchEvent(new CustomEvent("on-hs-appearance-change", {
            detail: theme
        }));
    }
    // Static methods
    static getInstance(target) {
        const elInCollection = window.$hsThemeSwitchCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsThemeSwitchCollection) window.$hsThemeSwitchCollection = [];
        const toggleObserveSystemTheme = (el)=>{
            if (localStorage.getItem("hs_theme") === "auto") el.addSystemThemeObserver();
            else el.removeSystemThemeObserver();
        };
        document.querySelectorAll("[data-hs-theme-switch]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsThemeSwitchCollection.find((elC)=>elC?.element?.el === el)) {
                const switchTheme = new $6deeff70b35b9220$var$HSThemeSwitch(el);
                switchTheme.el.checked = switchTheme.theme === "dark";
                toggleObserveSystemTheme(switchTheme);
                switchTheme.el.addEventListener("change", (evt)=>{
                    const theme = evt.target.checked ? "dark" : "default";
                    switchTheme.setAppearance(theme);
                    toggleObserveSystemTheme(switchTheme);
                });
            }
        });
        document.querySelectorAll("[data-hs-theme-click-value]:not(.--prevent-on-load-init)").forEach((el)=>{
            const theme = el.getAttribute("data-hs-theme-click-value");
            const switchTheme = new $6deeff70b35b9220$var$HSThemeSwitch(el);
            toggleObserveSystemTheme(switchTheme);
            switchTheme.el.addEventListener("click", ()=>{
                switchTheme.setAppearance(theme);
                toggleObserveSystemTheme(switchTheme);
            });
        });
    }
}
window.addEventListener("load", ()=>{
    $6deeff70b35b9220$var$HSThemeSwitch.autoInit();
// Uncomment for debug
// console.log('Theme switch collection:', window.$hsThemeSwitchCollection);
});
if (window.$hsThemeSwitchCollection) window.addEventListener("on-hs-appearance-change", (evt)=>{
    window.$hsThemeSwitchCollection.forEach((el)=>{
        el.element.el.checked = evt.detail === "dark";
    });
});
if (typeof window !== "undefined") window.HSThemeSwitch = $6deeff70b35b9220$var$HSThemeSwitch;
var $6deeff70b35b9220$export$2e2bcd8739ae039 = $6deeff70b35b9220$var$HSThemeSwitch;


/*
 * HSToggleCount
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $kYnwU = parcelRequire("kYnwU");
class $240fbed97ca869e3$var$HSToggleCount extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-toggle-count");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.target = concatOptions?.target ? typeof concatOptions?.target === "string" ? document.querySelector(concatOptions.target) : concatOptions.target : null;
        this.min = concatOptions?.min || 0;
        this.max = concatOptions?.max || 0;
        this.duration = concatOptions?.duration || 700;
        this.isChecked = this.target.checked || false;
        if (this.target) this.init();
    }
    init() {
        this.createCollection(window.$hsToggleCountCollection, this);
        if (this.isChecked) this.el.innerText = String(this.max);
        this.target.addEventListener("change", ()=>{
            this.isChecked = !this.isChecked;
            this.toggle();
        });
    }
    toggle() {
        if (this.isChecked) this.countUp();
        else this.countDown();
    }
    animate(from, to) {
        let startTimestamp = 0;
        const step = (timestamp)=>{
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / this.duration, 1);
            this.el.innerText = String(Math.floor(progress * (to - from) + from));
            if (progress < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
    }
    // Public methods
    countUp() {
        this.animate(this.min, this.max);
    }
    countDown() {
        this.animate(this.max, this.min);
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsToggleCountCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsToggleCountCollection) window.$hsToggleCountCollection = [];
        document.querySelectorAll("[data-hs-toggle-count]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsToggleCountCollection.find((elC)=>elC?.element?.el === el)) new $240fbed97ca869e3$var$HSToggleCount(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $240fbed97ca869e3$var$HSToggleCount.autoInit();
// Uncomment for debug
// console.log('Toggle count collection:', window.$hsToggleCountCollection);
});
if (typeof window !== "undefined") window.HSToggleCount = $240fbed97ca869e3$var$HSToggleCount;
var $240fbed97ca869e3$export$2e2bcd8739ae039 = $240fbed97ca869e3$var$HSToggleCount;


/*
 * HSTogglePassword
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $a5c5fbeaba71ef8c$var$HSTogglePassword extends (0, $kYnwU.default) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-toggle-password");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        const targets = [];
        if (concatOptions?.target && typeof concatOptions?.target === "string") {
            const ids = concatOptions?.target.split(",");
            ids.forEach((id)=>{
                targets.push(document.querySelector(id));
            });
        } else if (concatOptions?.target && typeof concatOptions?.target === "object") concatOptions.target.forEach((el)=>targets.push(document.querySelector(el)));
        else concatOptions.target.forEach((el)=>targets.push(el));
        this.target = targets;
        this.isShown = this.el.hasAttribute("type") ? this.el.checked : false;
        this.eventType = (0, $htam9.isFormElement)(this.el) ? "change" : "click";
        this.isMultiple = this.target.length > 1 && !!this.el.closest("[data-hs-toggle-password-group]");
        if (this.target) this.init();
    }
    init() {
        this.createCollection(window.$hsTogglePasswordCollection, this);
        if (!this.isShown) this.hide();
        else this.show();
        this.el.addEventListener(this.eventType, ()=>{
            if (this.isShown) this.hide();
            else this.show();
            this.fireEvent("toggle", this.target);
            (0, $htam9.dispatch)("toggle.hs.toggle-select", this.el, this.target);
        });
    }
    getMultipleToggles() {
        const group = this.el.closest("[data-hs-toggle-password-group]");
        const toggles = group.querySelectorAll("[data-hs-toggle-password]");
        const togglesInCollection = [];
        toggles.forEach((el)=>{
            togglesInCollection.push($a5c5fbeaba71ef8c$var$HSTogglePassword.getInstance(el));
        });
        return togglesInCollection;
    }
    // Public methods
    show() {
        if (this.isMultiple) {
            const toggles = this.getMultipleToggles();
            toggles.forEach((el)=>el ? el.isShown = true : false);
            this.el.closest("[data-hs-toggle-password-group]").classList.add("active");
        } else {
            this.isShown = true;
            this.el.classList.add("active");
        }
        this.target.forEach((el)=>{
            el.type = "text";
        });
    }
    hide() {
        if (this.isMultiple) {
            const toggles = this.getMultipleToggles();
            toggles.forEach((el)=>el ? el.isShown = false : false);
            this.el.closest("[data-hs-toggle-password-group]").classList.remove("active");
        } else {
            this.isShown = false;
            this.el.classList.remove("active");
        }
        this.target.forEach((el)=>{
            el.type = "password";
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsTogglePasswordCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsTogglePasswordCollection) window.$hsTogglePasswordCollection = [];
        document.querySelectorAll("[data-hs-toggle-password]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsTogglePasswordCollection.find((elC)=>elC?.element?.el === el)) new $a5c5fbeaba71ef8c$var$HSTogglePassword(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $a5c5fbeaba71ef8c$var$HSTogglePassword.autoInit();
// Uncomment for debug
// console.log('Toggle password collection:', window.$hsTogglePasswordCollection);
});
if (typeof window !== "undefined") window.HSTogglePassword = $a5c5fbeaba71ef8c$var$HSTogglePassword;
var $a5c5fbeaba71ef8c$export$2e2bcd8739ae039 = $a5c5fbeaba71ef8c$var$HSTogglePassword;


/*
 * HSTooltip
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 

var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");

class $6da614c11ce1004c$var$HSTooltip extends (0, $kYnwU.default) {
    constructor(el, options, events){
        super(el, options, events);
        if (this.el) {
            this.toggle = this.el.querySelector(".hs-tooltip-toggle") || this.el;
            this.content = this.el.querySelector(".hs-tooltip-content");
            this.eventMode = (0, $htam9.getClassProperty)(this.el, "--trigger") || "hover";
            this.preventPopper = (0, $htam9.getClassProperty)(this.el, "--prevent-popper", "false");
            this.placement = (0, $htam9.getClassProperty)(this.el, "--placement");
            this.strategy = (0, $htam9.getClassProperty)(this.el, "--strategy");
        }
        if (this.el && this.toggle && this.content) this.init();
    }
    init() {
        this.createCollection(window.$hsTooltipCollection, this);
        if (this.eventMode === "click") this.toggle.addEventListener("click", ()=>this.click());
        else if (this.eventMode === "focus") this.toggle.addEventListener("click", ()=>this.focus());
        else if (this.eventMode === "hover") {
            this.toggle.addEventListener("mouseenter", ()=>this.enter());
            this.toggle.addEventListener("mouseleave", ()=>this.leave());
        }
        if (this.preventPopper === "false") this.buildPopper();
    }
    enter() {
        this.show();
    }
    leave() {
        this.hide();
    }
    click() {
        if (this.el.classList.contains("show")) return false;
        this.show();
        const handle = ()=>{
            setTimeout(()=>{
                this.hide();
                this.toggle.removeEventListener("click", handle, true);
                this.toggle.removeEventListener("blur", handle, true);
            });
        };
        this.toggle.addEventListener("click", handle, true);
        this.toggle.addEventListener("blur", handle, true);
    }
    focus() {
        this.show();
        const handle = ()=>{
            this.hide();
            this.toggle.removeEventListener("blur", handle, true);
        };
        this.toggle.addEventListener("blur", handle, true);
    }
    buildPopper() {
        this.popperInstance = (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this.toggle, this.content, {
            placement: (0, $704e031c65277337$export$1a1f61c9c4dd9df0)[this.placement] || "top",
            strategy: this.strategy || "fixed",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            5
                        ]
                    }
                }
            ]
        });
    }
    // Public methods
    show() {
        this.content.classList.remove("hidden");
        if (this.preventPopper === "false") {
            this.popperInstance.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        ...options.modifiers,
                        {
                            name: "eventListeners",
                            enabled: true
                        }
                    ]
                }));
            this.popperInstance.update();
        }
        setTimeout(()=>{
            this.el.classList.add("show");
            this.fireEvent("show", this.el);
            (0, $htam9.dispatch)("show.hs.tooltip", this.el, this.el);
        });
    }
    hide() {
        this.el.classList.remove("show");
        if (this.preventPopper === "false") this.popperInstance.setOptions((options)=>({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ]
            }));
        this.fireEvent("hide", this.el);
        (0, $htam9.dispatch)("hide.hs.tooltip", this.el, this.el);
        (0, $htam9.afterTransition)(this.content, ()=>{
            if (this.el.classList.contains("show")) return false;
            this.content.classList.add("hidden");
        });
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsTooltipCollection) window.$hsTooltipCollection = [];
        document.querySelectorAll(".hs-tooltip").forEach((el)=>{
            if (!window.$hsTooltipCollection.find((elC)=>elC?.element?.el === el)) new $6da614c11ce1004c$var$HSTooltip(el);
        });
    }
    static show(target) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) switch(elInCollection.element.eventMode){
            case "click":
                elInCollection.element.click();
                break;
            case "focus":
                elInCollection.element.focus();
                break;
            default:
                elInCollection.element.enter();
                break;
        }
    }
    static hide(target) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.hide();
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $6da614c11ce1004c$var$HSTooltip.autoInit();
// Uncomment for debug
// console.log('Tooltip collection:', window.$hsTooltipCollection);
});
if (typeof window !== "undefined") window.HSTooltip = $6da614c11ce1004c$var$HSTooltip;
var $6da614c11ce1004c$export$2e2bcd8739ae039 = $6da614c11ce1004c$var$HSTooltip;


/*
 * HSTreeView
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");

var $kYnwU = parcelRequire("kYnwU");
class $c384d8e41257d6cc$var$HSTreeView extends (0, $kYnwU.default) {
    static{
        this.group = 0;
    }
    constructor(el, options, events){
        super(el, options, events);
        this.items = [];
        const data = el.getAttribute("data-hs-tree-view");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.controlBy = concatOptions?.controlBy || "button";
        this.autoSelectChildren = concatOptions?.autoSelectChildren || false;
        this.isIndeterminate = concatOptions?.isIndeterminate || true;
        this.init();
    }
    init() {
        this.createCollection(window.$hsTreeViewCollection, this);
        $c384d8e41257d6cc$var$HSTreeView.group += 1;
        this.initItems();
    }
    initItems() {
        this.el.querySelectorAll("[data-hs-tree-view-item]").forEach((el, ind)=>{
            const data = JSON.parse(el.getAttribute("data-hs-tree-view-item"));
            if (!el.id) el.id = `tree-view-item-${$c384d8e41257d6cc$var$HSTreeView.group}-${ind}`;
            const concatData = {
                ...data,
                id: data.id ?? el.id,
                path: this.getPath(el),
                isSelected: data.isSelected ?? false
            };
            this.items.push(concatData);
            if (this.controlBy === "checkbox") this.controlByCheckbox(el, concatData);
            else this.controlByButton(el, concatData);
        });
    }
    controlByButton(el, data) {
        el.addEventListener("click", (evt)=>{
            evt.stopPropagation();
            if (el.classList.contains("disabled")) return false;
            if (!evt.metaKey && !evt.shiftKey) this.unselectItem(data);
            this.selectItem(el, data);
            this.fireEvent("click", {
                el: el,
                data: data
            });
            (0, $htam9.dispatch)("click.hs.treeView", this.el, {
                el: el,
                data: data
            });
        });
    }
    controlByCheckbox(el, data) {
        const control = el.querySelector(`input[value="${data.value}"]`);
        if (!!control) control.addEventListener("change", ()=>{
            if (this.autoSelectChildren) {
                this.selectItem(el, data);
                if (data.isDir) this.selectChildren(el, data);
                this.toggleParent(el);
            } else this.selectItem(el, data);
        });
    }
    getItem(id) {
        return this.items.find((el)=>el.id === id);
    }
    getPath(el) {
        const path = [];
        let parent = el.closest("[data-hs-tree-view-item]");
        while(!!parent){
            const data = JSON.parse(parent.getAttribute("data-hs-tree-view-item"));
            path.push(data.value);
            parent = parent.parentElement?.closest("[data-hs-tree-view-item]");
        }
        return path.reverse().join("/");
    }
    unselectItem(exception = null) {
        let selectedItems = this.getSelectedItems();
        if (exception) selectedItems = selectedItems.filter((el)=>el.id !== exception.id);
        if (selectedItems.length) selectedItems.forEach((el)=>{
            const selectedElement = document.querySelector(`#${el.id}`);
            selectedElement.classList.remove("selected");
            this.changeItemProp(el.id, "isSelected", false);
        });
    }
    selectItem(el, data) {
        if (data.isSelected) {
            el.classList.remove("selected");
            this.changeItemProp(data.id, "isSelected", false);
        } else {
            el.classList.add("selected");
            this.changeItemProp(data.id, "isSelected", true);
        }
    }
    selectChildren(el, data) {
        const items = el.querySelectorAll("[data-hs-tree-view-item]");
        Array.from(items).filter((elI)=>!elI.classList.contains("disabled")).forEach((elI)=>{
            const initialItemData = elI.id ? this.getItem(elI.id) : null;
            if (!initialItemData) return false;
            if (data.isSelected) {
                elI.classList.add("selected");
                this.changeItemProp(initialItemData.id, "isSelected", true);
            } else {
                elI.classList.remove("selected");
                this.changeItemProp(initialItemData.id, "isSelected", false);
            }
            const currentItemData = this.getItem(elI.id);
            const control = elI.querySelector(`input[value="${currentItemData.value}"]`);
            if (this.isIndeterminate) control.indeterminate = false;
            if (currentItemData.isSelected) control.checked = true;
            else control.checked = false;
        });
    }
    toggleParent(el) {
        let parent = el.parentElement?.closest("[data-hs-tree-view-item]");
        while(!!parent){
            const items = parent.querySelectorAll("[data-hs-tree-view-item]:not(.disabled)");
            const data = JSON.parse(parent.getAttribute("data-hs-tree-view-item"));
            const control = parent.querySelector(`input[value="${data.value}"]`);
            let hasUnchecked = false;
            let checkedItems = 0;
            items.forEach((elI)=>{
                const dataI = this.getItem(elI.id);
                if (dataI.isSelected) checkedItems += 1;
                if (!dataI.isSelected) hasUnchecked = true;
            });
            if (hasUnchecked) {
                parent.classList.remove("selected");
                this.changeItemProp(parent.id, "isSelected", false);
                control.checked = false;
            } else {
                parent.classList.add("selected");
                this.changeItemProp(parent.id, "isSelected", true);
                control.checked = true;
            }
            if (this.isIndeterminate) {
                if (checkedItems > 0 && checkedItems < items.length) control.indeterminate = true;
                else control.indeterminate = false;
            }
            parent = parent.parentElement?.closest("[data-hs-tree-view-item]");
        }
    }
    // Public methods
    update() {
        this.items.map((el)=>{
            const selector = document.querySelector(`#${el.id}`);
            if (el.path !== this.getPath(selector)) el.path = this.getPath(selector);
            return el;
        });
    }
    getSelectedItems() {
        return this.items.filter((el)=>el.isSelected);
    }
    changeItemProp(id, prop, val) {
        this.items.map((el)=>{
            // @ts-ignore
            if (el.id === id) el[prop] = val;
            return el;
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsTreeViewCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsTreeViewCollection) window.$hsTreeViewCollection = [];
        document.querySelectorAll("[data-hs-tree-view]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsTreeViewCollection.find((elC)=>elC?.element?.el === el)) new $c384d8e41257d6cc$var$HSTreeView(el);
        });
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsTreeViewCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $c384d8e41257d6cc$var$HSTreeView.autoInit();
// Uncomment for debug
// console.log('Tree view collection:', window.$hsTreeViewCollection);
});
if (typeof window !== "undefined") window.HSTreeView = $c384d8e41257d6cc$var$HSTreeView;
var $c384d8e41257d6cc$export$2e2bcd8739ae039 = $c384d8e41257d6cc$var$HSTreeView;


/*
 * HSStaticMethods
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 
var $htam9 = parcelRequire("htam9");
/*
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */ 





var $98dye = parcelRequire("98dye");


var $h1iCb = parcelRequire("h1iCb");




var $jdtiL = parcelRequire("jdtiL");












const $6bd458bda1d4f575$export$c863840a8dc6e11d = [
    {
        key: "copy-markup",
        fn: (0, $0c306a747591bace$export$2e2bcd8739ae039),
        collection: "$hsCopyMarkupCollection"
    },
    {
        key: "accordion",
        fn: (0, $fdf3273b082fdf99$export$2e2bcd8739ae039),
        collection: "$hsAccordionCollection"
    },
    {
        key: "carousel",
        fn: (0, $21e0b253669cf069$export$2e2bcd8739ae039),
        collection: "$hsCarouselCollection"
    },
    {
        key: "collapse",
        fn: (0, $c33bd9274652961f$export$2e2bcd8739ae039),
        collection: "$hsCollapseCollection"
    },
    {
        key: "combobox",
        fn: (0, $4dd20d6ee44ededb$export$2e2bcd8739ae039),
        collection: "$hsComboBoxCollection"
    },
    {
        key: "datatable",
        fn: (0, $98dye.default),
        collection: "$hsDataTableCollection"
    },
    {
        key: "dropdown",
        fn: (0, $3165a178822236d6$export$2e2bcd8739ae039),
        collection: "$hsDropdownCollection"
    },
    {
        key: "file-upload",
        fn: (0, $h1iCb.default),
        collection: "$hsFileUploadCollection"
    },
    {
        key: "input-number",
        fn: (0, $278cd9d7635fbaf2$export$2e2bcd8739ae039),
        collection: "$hsInputNumberCollection"
    },
    {
        key: "overlay",
        fn: (0, $8f2f97605797e558$export$2e2bcd8739ae039),
        collection: "$hsOverlayCollection"
    },
    {
        key: "pin-input",
        fn: (0, $4a788dc9d3bacdfa$export$2e2bcd8739ae039),
        collection: "$hsPinInputCollection"
    },
    {
        key: "range-slider",
        fn: (0, $jdtiL.default),
        collection: "$hsRangeSliderCollection"
    },
    {
        key: "remove-element",
        fn: (0, $308f48fd3b91efe3$export$2e2bcd8739ae039),
        collection: "$hsRemoveElementCollection"
    },
    {
        key: "scrollspy",
        fn: (0, $123fc6210ee090d1$export$2e2bcd8739ae039),
        collection: "$hsScrollspyCollection"
    },
    {
        key: "select",
        fn: (0, $45555ee5ed0eeb66$export$2e2bcd8739ae039),
        collection: "$hsSelectCollection"
    },
    {
        key: "stepper",
        fn: (0, $337d9a5ed351f458$export$2e2bcd8739ae039),
        collection: "$hsStepperCollection"
    },
    {
        key: "strong-password",
        fn: (0, $36a0e440f8597468$export$2e2bcd8739ae039),
        collection: "$hsStrongPasswordCollection"
    },
    {
        key: "tabs",
        fn: (0, $6784483c0c3eb726$export$2e2bcd8739ae039),
        collection: "$hsTabsCollection"
    },
    {
        key: "textarea-auto-height",
        fn: (0, $67ab52e3fc36dff7$export$2e2bcd8739ae039),
        collection: "$hsTextareaAutoHeightCollection"
    },
    {
        key: "theme-switch",
        fn: (0, $6deeff70b35b9220$export$2e2bcd8739ae039),
        collection: "$hsThemeSwitchCollection"
    },
    {
        key: "toggle-count",
        fn: (0, $240fbed97ca869e3$export$2e2bcd8739ae039),
        collection: "$hsToggleCountCollection"
    },
    {
        key: "toggle-password",
        fn: (0, $a5c5fbeaba71ef8c$export$2e2bcd8739ae039),
        collection: "$hsTogglePasswordCollection"
    },
    {
        key: "tooltip",
        fn: (0, $6da614c11ce1004c$export$2e2bcd8739ae039),
        collection: "$hsTooltipCollection"
    },
    {
        key: "tree-view",
        fn: (0, $c384d8e41257d6cc$export$2e2bcd8739ae039),
        collection: "$hsTreeViewCollection"
    }
];


const $d497f11d93434110$var$HSStaticMethods = {
    getClassProperty: $htam9.getClassProperty,
    afterTransition: $htam9.afterTransition,
    autoInit (collection = "all") {
        if (collection === "all") (0, $6bd458bda1d4f575$export$c863840a8dc6e11d).forEach(({ fn: fn })=>{
            fn?.autoInit();
        });
        else (0, $6bd458bda1d4f575$export$c863840a8dc6e11d).forEach(({ key: key, fn: fn })=>{
            if (collection.includes(key)) fn?.autoInit();
        });
    },
    cleanCollection (name = "all") {
        if (name === "all") (0, $6bd458bda1d4f575$export$c863840a8dc6e11d).forEach(({ collection: collection })=>{
            if (window[collection] instanceof Array) window[collection] = [];
        });
        else (0, $6bd458bda1d4f575$export$c863840a8dc6e11d).forEach(({ key: key, collection: collection })=>{
            if (name.includes(key) && window[collection] instanceof Array) window[collection] = [];
        });
    }
};
if (typeof window !== "undefined") window.HSStaticMethods = $d497f11d93434110$var$HSStaticMethods;
var $d497f11d93434110$export$2e2bcd8739ae039 = $d497f11d93434110$var$HSStaticMethods;


let $0cdf79036432e7be$export$66c6706504ee69a5;
let $0cdf79036432e7be$export$c12a6988ccf2bca0;
let $0cdf79036432e7be$export$90c97215a2351d2a;

if (typeof DataTable !== "undefined" && typeof jQuery !== "undefined") $0cdf79036432e7be$export$66c6706504ee69a5 = (parcelRequire("98dye")).default;
else $0cdf79036432e7be$export$66c6706504ee69a5 = null;

if (typeof _ !== "undefined" && typeof Dropzone !== "undefined") $0cdf79036432e7be$export$c12a6988ccf2bca0 = (parcelRequire("h1iCb")).default;
else $0cdf79036432e7be$export$c12a6988ccf2bca0 = null;

if (typeof noUiSlider !== "undefined") $0cdf79036432e7be$export$90c97215a2351d2a = (parcelRequire("jdtiL")).default;
else $0cdf79036432e7be$export$90c97215a2351d2a = null;


// Gallery
document.addEventListener("DOMContentLoaded", function() {
    const gallery = document.querySelector("#lightgallery");
    if (gallery) lightGallery(gallery, {
        mode: "lg-slide"
    });
    const singleGallery = document.querySelector("#lightgallery2");
    if (singleGallery) lightGallery(singleGallery, {
        mode: "lg-slide"
    });
});

})();
//# sourceMappingURL=app.js.map
